// src/countries/countryCodes.ts
var countryCodes = {
  AUSTRALIA: { alphaTwo: "AU", alphaThree: "AUS", numeric: "036" },
  AUSTRIA: { alphaTwo: "AT", alphaThree: "AUT", numeric: "040" },
  BAHRAIN: { alphaTwo: "BH", alphaThree: "BHR", numeric: "048" },
  BARBADOS: { alphaTwo: "BB", alphaThree: "BRB", numeric: "052" },
  BELGIUM: { alphaTwo: "BE", alphaThree: "BEL", numeric: "056" },
  BOTSWANA: { alphaTwo: "BW", alphaThree: "BWA", numeric: "072" },
  BRAZIL: { alphaTwo: "BR", alphaThree: "BRA", numeric: "076" },
  BRUNEI_DARUSSALAM: { alphaTwo: "BN", alphaThree: "BRN", numeric: "096" },
  BULGARIA: { alphaTwo: "BG", alphaThree: "BGR", numeric: "100" },
  CAMBODIA: { alphaTwo: "KH", alphaThree: "KHM", numeric: "116" },
  CANADA: { alphaTwo: "CA", alphaThree: "CAN", numeric: "124" },
  CHILE: { alphaTwo: "CL", alphaThree: "CHL", numeric: "152" },
  CHINA: { alphaTwo: "CN", alphaThree: "CHN", numeric: "156" },
  CROATIA: { alphaTwo: "HR", alphaThree: "HRV", numeric: "191" },
  CYPRUS: { alphaTwo: "CY", alphaThree: "CYP", numeric: "196" },
  CZECH_REPUBLIC: { alphaTwo: "CZ", alphaThree: "CZE", numeric: "203" },
  DENMARK: { alphaTwo: "DK", alphaThree: "DNK", numeric: "208" },
  DOMINICA: { alphaTwo: "DM", alphaThree: "DMA", numeric: "212" },
  ESTONIA: { alphaTwo: "EE", alphaThree: "EST", numeric: "233" },
  FINLAND: { alphaTwo: "FI", alphaThree: "FIN", numeric: "246" },
  FRANCE: { alphaTwo: "FR", alphaThree: "FRA", numeric: "250" },
  GERMANY: { alphaTwo: "DE", alphaThree: "DEU", numeric: "276" },
  GREECE: { alphaTwo: "GR", alphaThree: "GRC", numeric: "300" },
  HONG_KONG: { alphaTwo: "HK", alphaThree: "HKG", numeric: "344" },
  HUNGARY: { alphaTwo: "HU", alphaThree: "HUN", numeric: "348" },
  ICELAND: { alphaTwo: "IS", alphaThree: "ISL", numeric: "352" },
  INDONESIA: { alphaTwo: "ID", alphaThree: "IDN", numeric: "360" },
  IRELAND: { alphaTwo: "IE", alphaThree: "IRL", numeric: "372" },
  ITALY: { alphaTwo: "IT", alphaThree: "ITA", numeric: "380" },
  JAPAN: { alphaTwo: "JP", alphaThree: "JPN", numeric: "392" },
  KAZAKHSTAN: { alphaTwo: "KZ", alphaThree: "KAZ", numeric: "398" },
  SOUTH_KOREA: { alphaTwo: "KR", alphaThree: "KOR", numeric: "410" },
  KUWAIT: { alphaTwo: "KW", alphaThree: "KWT", numeric: "414" },
  LATVIA: { alphaTwo: "LV", alphaThree: "LVA", numeric: "428" },
  LIECHTENSTEIN: { alphaTwo: "LI", alphaThree: "LIE", numeric: "438" },
  LITHUANIA: { alphaTwo: "LT", alphaThree: "LTU", numeric: "440" },
  LUXEMBOURG: { alphaTwo: "LU", alphaThree: "LUX", numeric: "442" },
  MACAU: { alphaTwo: "MO", alphaThree: "MAC", numeric: "446" },
  MALAYSIA: { alphaTwo: "MY", alphaThree: "MYS", numeric: "458" },
  MALTA: { alphaTwo: "MT", alphaThree: "MLT", numeric: "470" },
  MAURITIUS: { alphaTwo: "MU", alphaThree: "MUS", numeric: "480" },
  MEXICO: { alphaTwo: "MX", alphaThree: "MEX", numeric: "484" },
  NETHERLANDS: { alphaTwo: "NL", alphaThree: "NLD", numeric: "528" },
  NEW_ZEALAND: { alphaTwo: "NZ", alphaThree: "NZL", numeric: "554" },
  NORWAY: { alphaTwo: "NO", alphaThree: "NOR", numeric: "578" },
  OMAN: { alphaTwo: "OM", alphaThree: "OMN", numeric: "512" },
  PERU: { alphaTwo: "PE", alphaThree: "PER", numeric: "604" },
  POLAND: { alphaTwo: "PL", alphaThree: "POL", numeric: "616" },
  PORTUGAL: { alphaTwo: "PT", alphaThree: "PRT", numeric: "620" },
  QATAR: { alphaTwo: "QA", alphaThree: "QAT", numeric: "634" },
  ROMANIA: { alphaTwo: "RO", alphaThree: "ROU", numeric: "642" },
  SINGAPORE: { alphaTwo: "SG", alphaThree: "SGP", numeric: "702" },
  SLOVAKIA: { alphaTwo: "SK", alphaThree: "SVK", numeric: "703" },
  SLOVENIA: { alphaTwo: "SI", alphaThree: "SVN", numeric: "705" },
  SPAIN: { alphaTwo: "ES", alphaThree: "ESP", numeric: "724" },
  SWEDEN: { alphaTwo: "SE", alphaThree: "SWE", numeric: "752" },
  SWITZERLAND: { alphaTwo: "CH", alphaThree: "CHE", numeric: "756" },
  TAIWAN: { alphaTwo: "TW", alphaThree: "TWN", numeric: "158" },
  THAILAND: { alphaTwo: "TH", alphaThree: "THA", numeric: "764" },
  TUNISIA: { alphaTwo: "TN", alphaThree: "TUN", numeric: "788" },
  UNITED_ARAB_EMIRATES: { alphaTwo: "AE", alphaThree: "ARE", numeric: "784" },
  UNITED_STATES_OF_AMERICA: { alphaTwo: "US", alphaThree: "USA", numeric: "840" },
  SERBIA: { alphaTwo: "RS", alphaThree: "SRB", numeric: "688" },
  AFGHANISTAN: { alphaTwo: "AF", alphaThree: "AFG", numeric: "004" },
  ALBANIA: { alphaTwo: "AL", alphaThree: "ALB", numeric: "008" },
  ALGERIA: { alphaTwo: "DZ", alphaThree: "DZA", numeric: "012" },
  AMERICAN_SAMOA: { alphaTwo: "AS", alphaThree: "ASM", numeric: "016" },
  ANDORRA: { alphaTwo: "AD", alphaThree: "AND", numeric: "020" },
  ANGOLA: { alphaTwo: "AO", alphaThree: "AGO", numeric: "024" },
  ANGUILLA: { alphaTwo: "AI", alphaThree: "AIA", numeric: "660" },
  ANTARCTICA: { alphaTwo: "AQ", alphaThree: "ATA", numeric: "010" },
  ANTIGUA_AND_BARBUDA: { alphaTwo: "AG", alphaThree: "ATG", numeric: "028" },
  ARGENTINA: { alphaTwo: "AR", alphaThree: "ARG", numeric: "032" },
  ARMENIA: { alphaTwo: "AM", alphaThree: "ARM", numeric: "051" },
  ARUBA: { alphaTwo: "AW", alphaThree: "ABW", numeric: "533" },
  AZERBAIJAN: { alphaTwo: "AZ", alphaThree: "AZE", numeric: "031" },
  BAHAMAS: { alphaTwo: "BS", alphaThree: "BHS", numeric: "044" },
  BANGLADESH: { alphaTwo: "BD", alphaThree: "BGD", numeric: "050" },
  BELARUS: { alphaTwo: "BY", alphaThree: "BLR", numeric: "112" },
  BELIZE: { alphaTwo: "BZ", alphaThree: "BLZ", numeric: "084" },
  BENIN: { alphaTwo: "BJ", alphaThree: "BEN", numeric: "204" },
  BERMUDA: { alphaTwo: "BM", alphaThree: "BMU", numeric: "060" },
  BHUTAN: { alphaTwo: "BT", alphaThree: "BTN", numeric: "064" },
  BOLIVIA: { alphaTwo: "BO", alphaThree: "BOL", numeric: "068" },
  BOSNIA_AND_HERZEGOVINA: { alphaTwo: "BA", alphaThree: "BIH", numeric: "070" },
  BOUVET_ISLAND: { alphaTwo: "BV", alphaThree: "BVT", numeric: "074" },
  BRITISH_INDIAN_OCEAN_TERRITORY: { alphaTwo: "IO", alphaThree: "IOT", numeric: "086" },
  BURKINA_FASO: { alphaTwo: "BF", alphaThree: "BFA", numeric: "854" },
  BURUNDI: { alphaTwo: "BI", alphaThree: "BDI", numeric: "108" },
  CAMEROON: { alphaTwo: "CM", alphaThree: "CMR", numeric: "120" },
  CAPE_VERDE: { alphaTwo: "CV", alphaThree: "CPV", numeric: "132" },
  CAYMAN_ISLANDS: { alphaTwo: "KY", alphaThree: "CYM", numeric: "136" },
  CENTRAL_AFRICAN_REPUBLIC: { alphaTwo: "CF", alphaThree: "CAF", numeric: "140" },
  CHAD: { alphaTwo: "TD", alphaThree: "TCD", numeric: "148" },
  CHRISTMAS_ISLAND: { alphaTwo: "CX", alphaThree: "CXR", numeric: "162" },
  COCOS_KEELING_ISLANDS: { alphaTwo: "CC", alphaThree: "CCK", numeric: "166" },
  COLOMBIA: { alphaTwo: "CO", alphaThree: "COL", numeric: "170" },
  COMOROS: { alphaTwo: "KM", alphaThree: "COM", numeric: "174" },
  CONGO: { alphaTwo: "CG", alphaThree: "COG", numeric: "178" },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: { alphaTwo: "CD", alphaThree: "COD", numeric: "180" },
  COOK_ISLANDS: { alphaTwo: "CK", alphaThree: "COK", numeric: "184" },
  COSTA_RICA: { alphaTwo: "CR", alphaThree: "CRI", numeric: "188" },
  COTE_DIVOIRE: { alphaTwo: "CI", alphaThree: "CIV", numeric: "384" },
  CUBA: { alphaTwo: "CU", alphaThree: "CUB", numeric: "192" },
  DJIBOUTI: { alphaTwo: "DJ", alphaThree: "DJI", numeric: "262" },
  DOMINICAN_REPUBLIC: { alphaTwo: "DO", alphaThree: "DOM", numeric: "214" },
  ECUADOR: { alphaTwo: "EC", alphaThree: "ECU", numeric: "218" },
  EGYPT: { alphaTwo: "EG", alphaThree: "EGY", numeric: "818" },
  EL_SALVADOR: { alphaTwo: "SV", alphaThree: "SLV", numeric: "222" },
  EQUATORIAL_GUINEA: { alphaTwo: "GQ", alphaThree: "GNQ", numeric: "226" },
  ERITREA: { alphaTwo: "ER", alphaThree: "ERI", numeric: "232" },
  ETHIOPIA: { alphaTwo: "ET", alphaThree: "ETH", numeric: "231" },
  FALKLAND_ISLANDS_MALVINAS: { alphaTwo: "FK", alphaThree: "FLK", numeric: "238" },
  FAROE_ISLANDS: { alphaTwo: "FO", alphaThree: "FRO", numeric: "234" },
  FIJI: { alphaTwo: "FJ", alphaThree: "FJI", numeric: "242" },
  FRENCH_GUIANA: { alphaTwo: "GF", alphaThree: "GUF", numeric: "254" },
  FRENCH_POLYNESIA: { alphaTwo: "PF", alphaThree: "PYF", numeric: "258" },
  FRENCH_SOUTHERN_TERRITORIES: { alphaTwo: "TF", alphaThree: "ATF", numeric: "260" },
  GABON: { alphaTwo: "GA", alphaThree: "GAB", numeric: "266" },
  GAMBIA: { alphaTwo: "GM", alphaThree: "GMB", numeric: "270" },
  GEORGIA: { alphaTwo: "GE", alphaThree: "GEO", numeric: "268" },
  GHANA: { alphaTwo: "GH", alphaThree: "GHA", numeric: "288" },
  GIBRALTAR: { alphaTwo: "GI", alphaThree: "GIB", numeric: "292" },
  GREENLAND: { alphaTwo: "GL", alphaThree: "GRL", numeric: "304" },
  GRENADA: { alphaTwo: "GD", alphaThree: "GRD", numeric: "308" },
  GUADELOUPE: { alphaTwo: "GP", alphaThree: "GLP", numeric: "312" },
  GUAM: { alphaTwo: "GU", alphaThree: "GUM", numeric: "316" },
  GUATEMALA: { alphaTwo: "GT", alphaThree: "GTM", numeric: "320" },
  GUINEA: { alphaTwo: "GN", alphaThree: "GIN", numeric: "324" },
  GUINEA_BISSAU: { alphaTwo: "GW", alphaThree: "GNB", numeric: "624" },
  GUYANA: { alphaTwo: "GY", alphaThree: "GUY", numeric: "328" },
  HAITI: { alphaTwo: "HT", alphaThree: "HTI", numeric: "332" },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: { alphaTwo: "HM", alphaThree: "HMD", numeric: "334" },
  VATICAN: { alphaTwo: "VA", alphaThree: "VAT", numeric: "336" },
  HONDURAS: { alphaTwo: "HN", alphaThree: "HND", numeric: "340" },
  INDIA: { alphaTwo: "IN", alphaThree: "IND", numeric: "356" },
  IRAN_ISLAMIC_REPUBLIC_OF: { alphaTwo: "IR", alphaThree: "IRN", numeric: "364" },
  IRAQ: { alphaTwo: "IQ", alphaThree: "IRQ", numeric: "368" },
  ISRAEL: { alphaTwo: "IL", alphaThree: "ISR", numeric: "376" },
  JAMAICA: { alphaTwo: "JM", alphaThree: "JAM", numeric: "388" },
  JORDAN: { alphaTwo: "JO", alphaThree: "JOR", numeric: "400" },
  KENYA: { alphaTwo: "KE", alphaThree: "KEN", numeric: "404" },
  KIRIBATI: { alphaTwo: "KI", alphaThree: "KIR", numeric: "296" },
  NORTH_KOREA: { alphaTwo: "KP", alphaThree: "PRK", numeric: "408" },
  KYRGYZSTAN: { alphaTwo: "KG", alphaThree: "KGZ", numeric: "417" },
  LAOS: { alphaTwo: "LA", alphaThree: "LAO", numeric: "418" },
  LEBANON: { alphaTwo: "LB", alphaThree: "LBN", numeric: "422" },
  LESOTHO: { alphaTwo: "LS", alphaThree: "LSO", numeric: "426" },
  LIBERIA: { alphaTwo: "LR", alphaThree: "LBR", numeric: "430" },
  LIBYA: { alphaTwo: "LY", alphaThree: "LBY", numeric: "434" },
  MADAGASCAR: { alphaTwo: "MG", alphaThree: "MDG", numeric: "450" },
  MALAWI: { alphaTwo: "MW", alphaThree: "MWI", numeric: "454" },
  MALDIVES: { alphaTwo: "MV", alphaThree: "MDV", numeric: "462" },
  MALI: { alphaTwo: "ML", alphaThree: "MLI", numeric: "466" },
  MARSHALL_ISLANDS: { alphaTwo: "MH", alphaThree: "MHL", numeric: "584" },
  MARTINIQUE: { alphaTwo: "MQ", alphaThree: "MTQ", numeric: "474" },
  MAURITANIA: { alphaTwo: "MR", alphaThree: "MRT", numeric: "478" },
  MAYOTTE: { alphaTwo: "YT", alphaThree: "MYT", numeric: "175" },
  MICRONESIA_FEDERATED_STATES_OF: { alphaTwo: "FM", alphaThree: "FSM", numeric: "583" },
  MOLDOVA_REPUBLIC_OF: { alphaTwo: "MD", alphaThree: "MDA", numeric: "498" },
  MONACO: { alphaTwo: "MC", alphaThree: "MCO", numeric: "492" },
  MONGOLIA: { alphaTwo: "MN", alphaThree: "MNG", numeric: "496" },
  MONTSERRAT: { alphaTwo: "MS", alphaThree: "MSR", numeric: "500" },
  MOROCCO: { alphaTwo: "MA", alphaThree: "MAR", numeric: "504" },
  MOZAMBIQUE: { alphaTwo: "MZ", alphaThree: "MOZ", numeric: "508" },
  MYANMAR: { alphaTwo: "MM", alphaThree: "MMR", numeric: "104" },
  NAMIBIA: { alphaTwo: "NA", alphaThree: "NAM", numeric: "516" },
  NAURU: { alphaTwo: "NR", alphaThree: "NRU", numeric: "520" },
  NEPAL: { alphaTwo: "NP", alphaThree: "NPL", numeric: "524" },
  NEW_CALEDONIA: { alphaTwo: "NC", alphaThree: "NCL", numeric: "540" },
  NICARAGUA: { alphaTwo: "NI", alphaThree: "NIC", numeric: "558" },
  NIGER: { alphaTwo: "NE", alphaThree: "NER", numeric: "562" },
  NIGERIA: { alphaTwo: "NG", alphaThree: "NGA", numeric: "566" },
  NIUE: { alphaTwo: "NU", alphaThree: "NIU", numeric: "570" },
  NORFOLK_ISLAND: { alphaTwo: "NF", alphaThree: "NFK", numeric: "574" },
  NORTH_MACEDONIA_REPUBLIC_OF: { alphaTwo: "MK", alphaThree: "MKD", numeric: "807" },
  NORTHERN_MARIANA_ISLANDS: { alphaTwo: "MP", alphaThree: "MNP", numeric: "580" },
  PAKISTAN: { alphaTwo: "PK", alphaThree: "PAK", numeric: "586" },
  PALAU: { alphaTwo: "PW", alphaThree: "PLW", numeric: "585" },
  PALESTINE: { alphaTwo: "PS", alphaThree: "PSE", numeric: "275" },
  PANAMA: { alphaTwo: "PA", alphaThree: "PAN", numeric: "591" },
  PAPUA_NEW_GUINEA: { alphaTwo: "PG", alphaThree: "PNG", numeric: "598" },
  PARAGUAY: { alphaTwo: "PY", alphaThree: "PRY", numeric: "600" },
  PHILIPPINES: { alphaTwo: "PH", alphaThree: "PHL", numeric: "608" },
  PITCAIRN: { alphaTwo: "PN", alphaThree: "PCN", numeric: "612" },
  PUERTO_RICO: { alphaTwo: "PR", alphaThree: "PRI", numeric: "630" },
  REUNION: { alphaTwo: "RE", alphaThree: "REU", numeric: "638" },
  RUSSIA: { alphaTwo: "RU", alphaThree: "RUS", numeric: "643" },
  RWANDA: { alphaTwo: "RW", alphaThree: "RWA", numeric: "646" },
  SAINT_HELENA: { alphaTwo: "SH", alphaThree: "SHN", numeric: "654" },
  SAINT_KITTS_AND_NEVIS: { alphaTwo: "KN", alphaThree: "KNA", numeric: "659" },
  SAINT_LUCIA: { alphaTwo: "LC", alphaThree: "LCA", numeric: "662" },
  SAINT_PIERRE_AND_MIQUELON: { alphaTwo: "PM", alphaThree: "SPM", numeric: "666" },
  SAINT_VINCENT_AND_THE_GRENADINES: { alphaTwo: "VC", alphaThree: "VCT", numeric: "670" },
  SAMOA: { alphaTwo: "WS", alphaThree: "WSM", numeric: "882" },
  SAN_MARINO: { alphaTwo: "SM", alphaThree: "SMR", numeric: "674" },
  SAO_TOME_AND_PRINCIPE: { alphaTwo: "ST", alphaThree: "STP", numeric: "678" },
  SAUDI_ARABIA: { alphaTwo: "SA", alphaThree: "SAU", numeric: "682" },
  SENEGAL: { alphaTwo: "SN", alphaThree: "SEN", numeric: "686" },
  SEYCHELLES: { alphaTwo: "SC", alphaThree: "SYC", numeric: "690" },
  SIERRA_LEONE: { alphaTwo: "SL", alphaThree: "SLE", numeric: "694" },
  SOLOMON_ISLANDS: { alphaTwo: "SB", alphaThree: "SLB", numeric: "090" },
  SOMALIA: { alphaTwo: "SO", alphaThree: "SOM", numeric: "706" },
  SOUTH_AFRICA: { alphaTwo: "ZA", alphaThree: "ZAF", numeric: "710" },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: { alphaTwo: "GS", alphaThree: "SGS", numeric: "239" },
  SRI_LANKA: { alphaTwo: "LK", alphaThree: "LKA", numeric: "144" },
  SUDAN: { alphaTwo: "SD", alphaThree: "SDN", numeric: "729" },
  SURINAME: { alphaTwo: "SR", alphaThree: "SUR", numeric: "740" },
  SVALBARD_AND_JAN_MAYEN: { alphaTwo: "SJ", alphaThree: "SJM", numeric: "744" },
  SWAZILAND: { alphaTwo: "SZ", alphaThree: "SWZ", numeric: "748" },
  SYRIA: { alphaTwo: "SY", alphaThree: "SYR", numeric: "760" },
  TAJIKISTAN: { alphaTwo: "TJ", alphaThree: "TJK", numeric: "762" },
  TANZANIA_UNITED_REPUBLIC_OF: { alphaTwo: "TZ", alphaThree: "TZA", numeric: "834" },
  TIMOR_LESTE: { alphaTwo: "TL", alphaThree: "TLS", numeric: "626" },
  TOGO: { alphaTwo: "TG", alphaThree: "TGO", numeric: "768" },
  TOKELAU: { alphaTwo: "TK", alphaThree: "TKL", numeric: "772" },
  TONGA: { alphaTwo: "TO", alphaThree: "TON", numeric: "776" },
  TRINIDAD_AND_TOBAGO: { alphaTwo: "TT", alphaThree: "TTO", numeric: "780" },
  TURKEY: { alphaTwo: "TR", alphaThree: "TUR", numeric: "792" },
  TURKMENISTAN: { alphaTwo: "TM", alphaThree: "TKM", numeric: "795" },
  TURKS_AND_CAICOS_ISLANDS: { alphaTwo: "TC", alphaThree: "TCA", numeric: "796" },
  TUVALU: { alphaTwo: "TV", alphaThree: "TUV", numeric: "798" },
  UGANDA: { alphaTwo: "UG", alphaThree: "UGA", numeric: "800" },
  UKRAINE: { alphaTwo: "UA", alphaThree: "UKR", numeric: "804" },
  UNITED_KINGDOM: { alphaTwo: "GB", alphaThree: "GBR", numeric: "826" },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: { alphaTwo: "UM", alphaThree: "UMI", numeric: "581" },
  URUGUAY: { alphaTwo: "UY", alphaThree: "URY", numeric: "858" },
  UZBEKISTAN: { alphaTwo: "UZ", alphaThree: "UZB", numeric: "860" },
  VANUATU: { alphaTwo: "VU", alphaThree: "VUT", numeric: "548" },
  VENEZUELA: { alphaTwo: "VE", alphaThree: "VEN", numeric: "862" },
  VIETNAM: { alphaTwo: "VN", alphaThree: "VNM", numeric: "704" },
  VIRGIN_ISLANDS_BRITISH: { alphaTwo: "VG", alphaThree: "VGB", numeric: "092" },
  VIRGIN_ISLANDS_US: { alphaTwo: "VI", alphaThree: "VIR", numeric: "850" },
  WALLIS_AND_FUTUNA: { alphaTwo: "WF", alphaThree: "WLF", numeric: "876" },
  WESTERN_SAHARA: { alphaTwo: "EH", alphaThree: "ESH", numeric: "732" },
  YEMEN: { alphaTwo: "YE", alphaThree: "YEM", numeric: "887" },
  ZAMBIA: { alphaTwo: "ZM", alphaThree: "ZMB", numeric: "894" },
  ZIMBABWE: { alphaTwo: "ZW", alphaThree: "ZWE", numeric: "716" },
  ALAND_ISLANDS: { alphaTwo: "AX", alphaThree: "ALA", numeric: "248" },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: { alphaTwo: "BQ", alphaThree: "BES", numeric: "535" },
  CURACAO: { alphaTwo: "CW", alphaThree: "CUW", numeric: "531" },
  GUERNSEY: { alphaTwo: "GG", alphaThree: "GGY", numeric: "831" },
  ISLE_OF_MAN: { alphaTwo: "IM", alphaThree: "IMN", numeric: "833" },
  JERSEY: { alphaTwo: "JE", alphaThree: "JEY", numeric: "832" },
  MONTENEGRO: { alphaTwo: "ME", alphaThree: "MNE", numeric: "499" },
  SAINT_BARTHELEMY: { alphaTwo: "BL", alphaThree: "BLM", numeric: "652" },
  SAINT_MARTIN_FRANCE: { alphaTwo: "MF", alphaThree: "MAF", numeric: "663" },
  SINT_MAARTEN_DUTCH: { alphaTwo: "SX", alphaThree: "SXM", numeric: "534" },
  SOUTH_SUDAN: { alphaTwo: "SS", alphaThree: "SSD", numeric: "728" },
  KOSOVO: { alphaTwo: "XK", alphaThree: "XKX", numeric: "" }
};

// src/countries/countryDefinitions.ts
var recognisedCountries = {
  AUSTRALIA: {
    key: "AUSTRALIA",
    region: "Oceania",
    countryName: "Australia",
    transferMate: 14,
    nationality: "Australian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.AUSTRALIA
  },
  AUSTRIA: {
    key: "AUSTRIA",
    region: "Europe",
    countryName: "Austria",
    transferMate: 16,
    nationality: "Austrian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.AUSTRIA
  },
  BAHRAIN: {
    key: "BAHRAIN",
    region: "Middle East",
    countryName: "Bahrain",
    transferMate: 19,
    nationality: "Bahraini",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BAHRAIN
  },
  BARBADOS: {
    key: "BARBADOS",
    region: "North America",
    countryName: "Barbados",
    transferMate: 21,
    nationality: "Barbadian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BARBADOS
  },
  BELGIUM: {
    key: "BELGIUM",
    region: "Europe",
    countryName: "Belgium",
    transferMate: 23,
    nationality: "Belgian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.BELGIUM
  },
  BOTSWANA: {
    key: "BOTSWANA",
    region: "Africa",
    countryName: "Botswana",
    transferMate: 30,
    nationality: "Motswana",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BOTSWANA
  },
  BRAZIL: {
    key: "BRAZIL",
    region: "South America",
    countryName: "Brazil",
    transferMate: 32,
    nationality: "Brazilian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BRAZIL
  },
  BRUNEI_DARUSSALAM: {
    key: "BRUNEI_DARUSSALAM",
    region: "Southeast Asia",
    countryName: "Brunei Darussalam",
    nationality: "Bruneian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.BRUNEI_DARUSSALAM
  },
  BULGARIA: {
    key: "BULGARIA",
    region: "Europe",
    countryName: "Bulgaria",
    transferMate: 35,
    nationality: "Bulgarian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.BULGARIA
  },
  CAMBODIA: {
    key: "CAMBODIA",
    region: "Southeast Asia",
    countryName: "Cambodia",
    transferMate: 38,
    nationality: "Cambodian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CAMBODIA
  },
  CANADA: {
    key: "CANADA",
    region: "North America",
    countryName: "Canada",
    transferMate: 40,
    nationality: "Canadian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CANADA
  },
  CHILE: {
    key: "CHILE",
    region: "South America",
    countryName: "Chile",
    transferMate: 46,
    nationality: "Chilean",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CHILE
  },
  CHINA: {
    key: "CHINA",
    region: "East Asia",
    countryName: "China",
    transferMate: 47,
    nationality: "Chinese",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.CHINA
  },
  CROATIA: {
    key: "CROATIA",
    region: "Europe",
    countryName: "Croatia",
    transferMate: 56,
    nationality: "Croatian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CROATIA
  },
  CYPRUS: {
    key: "CYPRUS",
    region: "Europe",
    countryName: "Cyprus",
    transferMate: 58,
    nationality: "Cypriot",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CYPRUS
  },
  CZECH_REPUBLIC: {
    key: "CZECH_REPUBLIC",
    region: "Europe",
    countryName: "Czech Republic",
    transferMate: 60,
    nationality: "Czech",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.CZECH_REPUBLIC
  },
  DENMARK: {
    key: "DENMARK",
    region: "Europe",
    countryName: "Denmark",
    transferMate: 61,
    nationality: "Danish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.DENMARK
  },
  DOMINICA: {
    key: "DOMINICA",
    region: "North America",
    countryName: "Dominica",
    transferMate: 64,
    nationality: "Dominican",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.DOMINICA
  },
  ESTONIA: {
    key: "ESTONIA",
    region: "Europe",
    countryName: "Estonia",
    transferMate: 72,
    nationality: "Estonian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ESTONIA
  },
  FINLAND: {
    key: "FINLAND",
    region: "Europe",
    countryName: "Finland",
    transferMate: 77,
    nationality: "Finnish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.FINLAND
  },
  FRANCE: {
    key: "FRANCE",
    region: "Europe",
    countryName: "France",
    transferMate: 79,
    nationality: "French",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.FRANCE
  },
  GERMANY: {
    key: "GERMANY",
    region: "Europe",
    countryName: "Germany",
    transferMate: 87,
    nationality: "German",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.GERMANY
  },
  GREECE: {
    key: "GREECE",
    region: "Europe",
    countryName: "Greece",
    transferMate: 91,
    nationality: "Greek",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.GREECE
  },
  HONG_KONG: {
    key: "HONG_KONG",
    region: "East Asia",
    countryName: "Hong Kong",
    nationality: "Hong Konger",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.HONG_KONG
  },
  HUNGARY: {
    key: "HUNGARY",
    region: "Europe",
    countryName: "Hungary",
    transferMate: 107,
    nationality: "Hungarian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.HUNGARY
  },
  ICELAND: {
    key: "ICELAND",
    region: "Non_EU Europe",
    countryName: "Iceland",
    transferMate: 108,
    nationality: "Icelander",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ICELAND
  },
  INDONESIA: {
    key: "INDONESIA",
    region: "Southeast Asia",
    countryName: "Indonesia",
    transferMate: 110,
    nationality: "Indonesian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.INDONESIA
  },
  IRELAND: {
    key: "IRELAND",
    region: "Europe",
    countryName: "Ireland",
    transferMate: 113,
    nationality: "Irish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.IRELAND
  },
  ITALY: {
    key: "ITALY",
    region: "Europe",
    countryName: "Italy",
    transferMate: 116,
    nationality: "Italian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ITALY
  },
  JAPAN: {
    key: "JAPAN",
    region: "East Asia",
    countryName: "Japan",
    transferMate: 119,
    nationality: "Japanese",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.JAPAN
  },
  KAZAKHSTAN: {
    key: "KAZAKHSTAN",
    region: "Central Asia (CIS)",
    countryName: "Kazakhstan",
    transferMate: 122,
    nationality: "Kazakhstani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.KAZAKHSTAN
  },
  SOUTH_KOREA: {
    key: "SOUTH_KOREA",
    region: "East Asia",
    countryName: "South Korea",
    nationality: "South Korean",
    atas: false,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SOUTH_KOREA
  },
  KUWAIT: {
    key: "KUWAIT",
    region: "Middle East",
    countryName: "Kuwait",
    transferMate: 126,
    nationality: "Kuwaiti",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.KUWAIT
  },
  LATVIA: {
    key: "LATVIA",
    region: "Europe",
    countryName: "Latvia",
    transferMate: 129,
    nationality: "Latvian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LATVIA
  },
  LIECHTENSTEIN: {
    key: "LIECHTENSTEIN",
    region: "Non_EU Europe",
    countryName: "Liechtenstein",
    transferMate: 134,
    nationality: "Liechtensteiner",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LIECHTENSTEIN
  },
  LITHUANIA: {
    key: "LITHUANIA",
    region: "Europe",
    countryName: "Lithuania",
    transferMate: 135,
    nationality: "Lithuanian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LITHUANIA
  },
  LUXEMBOURG: {
    key: "LUXEMBOURG",
    region: "Europe",
    countryName: "Luxembourg",
    transferMate: 136,
    nationality: "Luxembourger",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.LUXEMBOURG
  },
  MACAU: {
    key: "MACAU",
    region: "East Asia",
    countryName: "Macau",
    nationality: "Macanese",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MACAU
  },
  MALAYSIA: {
    key: "MALAYSIA",
    region: "Southeast Asia",
    countryName: "Malaysia",
    transferMate: 141,
    nationality: "Malaysian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MALAYSIA
  },
  MALTA: {
    key: "MALTA",
    region: "Europe",
    countryName: "Malta",
    transferMate: 144,
    nationality: "Maltese",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.MALTA
  },
  MAURITIUS: {
    key: "MAURITIUS",
    region: "Africa",
    countryName: "Mauritius",
    transferMate: 149,
    nationality: "Mauritian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MAURITIUS
  },
  MEXICO: {
    key: "MEXICO",
    region: "North America",
    countryName: "Mexico",
    transferMate: 151,
    nationality: "Mexican",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.MEXICO
  },
  NETHERLANDS: {
    key: "NETHERLANDS",
    region: "Europe",
    countryName: "Netherlands",
    nationality: "Dutch",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.NETHERLANDS
  },
  NEW_ZEALAND: {
    key: "NEW_ZEALAND",
    region: "Oceania",
    countryName: "New Zealand",
    transferMate: 164,
    nationality: "New Zealander",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.NEW_ZEALAND
  },
  NORWAY: {
    key: "NORWAY",
    region: "Non_EU Europe",
    countryName: "Norway",
    transferMate: 171,
    nationality: "Norwegian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.NORWAY
  },
  OMAN: {
    key: "OMAN",
    region: "Middle East",
    countryName: "Oman",
    transferMate: 172,
    nationality: "Omani",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.OMAN
  },
  PERU: {
    key: "PERU",
    region: "South America",
    countryName: "Peru",
    transferMate: 178,
    nationality: "Peruvian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.PERU
  },
  POLAND: {
    key: "POLAND",
    region: "Europe",
    countryName: "Poland",
    transferMate: 181,
    nationality: "Polish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.POLAND
  },
  PORTUGAL: {
    key: "PORTUGAL",
    region: "Europe",
    countryName: "Portugal",
    transferMate: 182,
    nationality: "Portuguese",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.PORTUGAL
  },
  QATAR: {
    key: "QATAR",
    region: "Middle East",
    countryName: "Qatar",
    transferMate: 184,
    nationality: "Qatari",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.QATAR
  },
  ROMANIA: {
    key: "ROMANIA",
    region: "Europe",
    countryName: "Romania",
    transferMate: 186,
    nationality: "Romanian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.ROMANIA
  },
  SINGAPORE: {
    key: "SINGAPORE",
    region: "Southeast Asia",
    countryName: "Singapore",
    transferMate: 203,
    nationality: "Singaporean",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SINGAPORE
  },
  SLOVAKIA: {
    key: "SLOVAKIA",
    region: "Europe",
    countryName: "Slovakia",
    transferMate: 204,
    nationality: "Slovakian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SLOVAKIA
  },
  SLOVENIA: {
    key: "SLOVENIA",
    region: "Europe",
    countryName: "Slovenia",
    transferMate: 205,
    nationality: "Slovenian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SLOVENIA
  },
  SPAIN: {
    key: "SPAIN",
    region: "Europe",
    countryName: "Spain",
    transferMate: 211,
    nationality: "Spanish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SPAIN
  },
  SWEDEN: {
    key: "SWEDEN",
    region: "Europe",
    countryName: "Sweden",
    transferMate: 217,
    nationality: "Swedish",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SWEDEN
  },
  SWITZERLAND: {
    key: "SWITZERLAND",
    region: "Non_EU Europe",
    countryName: "Switzerland",
    transferMate: 218,
    nationality: "Swiss",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "EUSS",
    categoryNewNameRefactor: "EUSS",
    ...countryCodes.SWITZERLAND
  },
  TAIWAN: {
    key: "TAIWAN",
    region: "East Asia",
    countryName: "Taiwan",
    transferMate: 220,
    nationality: "Taiwanese",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.TAIWAN
  },
  THAILAND: {
    key: "THAILAND",
    region: "Southeast Asia",
    countryName: "Thailand",
    transferMate: 223,
    nationality: "Thai",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.THAILAND
  },
  TUNISIA: {
    key: "TUNISIA",
    region: "Africa",
    countryName: "Tunisia",
    transferMate: 228,
    nationality: "Tunisian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.TUNISIA
  },
  UNITED_ARAB_EMIRATES: {
    key: "UNITED_ARAB_EMIRATES",
    region: "Middle East",
    countryName: "United Arab Emirates",
    transferMate: 235,
    nationality: "Emirati",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.UNITED_ARAB_EMIRATES
  },
  UNITED_STATES_OF_AMERICA: {
    key: "UNITED_STATES_OF_AMERICA",
    region: "North America",
    countryName: "United States of America",
    nationality: "American",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.UNITED_STATES_OF_AMERICA
  },
  SERBIA: {
    key: "SERBIA",
    region: "Non_EU Europe",
    countryName: "Serbia",
    transferMate: 200,
    nationality: "Serbian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.SERBIA
  },
  AFGHANISTAN: {
    key: "AFGHANISTAN",
    region: "Middle East",
    countryName: "Afghanistan",
    transferMate: 2,
    nationality: "Afghan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AFGHANISTAN
  },
  ALBANIA: {
    key: "ALBANIA",
    region: "Non_EU Europe",
    countryName: "Albania",
    transferMate: 3,
    nationality: "Albanian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALBANIA
  },
  ALGERIA: {
    key: "ALGERIA",
    region: "Africa",
    countryName: "Algeria",
    transferMate: 4,
    nationality: "Algerian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALGERIA
  },
  AMERICAN_SAMOA: {
    key: "AMERICAN_SAMOA",
    region: "Oceania",
    countryName: "American Samoa",
    transferMate: 5,
    nationality: "Samoan (American)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AMERICAN_SAMOA
  },
  ANDORRA: {
    key: "ANDORRA",
    region: "Europe",
    countryName: "Andorra",
    transferMate: 6,
    nationality: "Andorran",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANDORRA
  },
  ANGOLA: {
    key: "ANGOLA",
    region: "Africa",
    countryName: "Angola",
    transferMate: 7,
    nationality: "Angolan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANGOLA
  },
  ANGUILLA: {
    key: "ANGUILLA",
    region: "North America",
    countryName: "Anguilla",
    transferMate: 8,
    nationality: "Anguillan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANGUILLA
  },
  ANTARCTICA: {
    key: "ANTARCTICA",
    region: "Antarctica",
    countryName: "Antarctica",
    transferMate: 9,
    nationality: "Antarctic",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANTARCTICA
  },
  ANTIGUA_AND_BARBUDA: {
    key: "ANTIGUA_AND_BARBUDA",
    region: "North America",
    countryName: "Antigua and Barbuda",
    transferMate: 10,
    nationality: "Antiguans",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ANTIGUA_AND_BARBUDA
  },
  ARGENTINA: {
    key: "ARGENTINA",
    region: "South America",
    countryName: "Argentina",
    transferMate: 11,
    nationality: "Argentinean",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARGENTINA
  },
  ARMENIA: {
    key: "ARMENIA",
    region: "Central Asia (CIS)",
    countryName: "Armenia",
    transferMate: 12,
    nationality: "Armenian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARMENIA
  },
  ARUBA: {
    key: "ARUBA",
    region: "South America",
    countryName: "Aruba",
    transferMate: 13,
    nationality: "Arubian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ARUBA
  },
  AZERBAIJAN: {
    key: "AZERBAIJAN",
    region: "Central Asia (CIS)",
    countryName: "Azerbaijan",
    transferMate: 17,
    nationality: "Azerbaijani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.AZERBAIJAN
  },
  BAHAMAS: {
    key: "BAHAMAS",
    region: "North America",
    countryName: "Bahamas",
    transferMate: 18,
    nationality: "Bahamian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BAHAMAS
  },
  BANGLADESH: {
    key: "BANGLADESH",
    region: "South Asia",
    countryName: "Bangladesh",
    transferMate: 20,
    nationality: "Bangladeshi",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BANGLADESH
  },
  BELARUS: {
    key: "BELARUS",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Belarus",
    transferMate: 22,
    nationality: "Belarusian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BELARUS
  },
  BELIZE: {
    key: "BELIZE",
    region: "North America",
    countryName: "Belize",
    transferMate: 24,
    nationality: "Belizean",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BELIZE
  },
  BENIN: {
    key: "BENIN",
    region: "Africa",
    countryName: "Benin",
    transferMate: 25,
    nationality: "Beninese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BENIN
  },
  BERMUDA: {
    key: "BERMUDA",
    region: "North America",
    countryName: "Bermuda",
    transferMate: 26,
    nationality: "Bermudan",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BERMUDA
  },
  BHUTAN: {
    key: "BHUTAN",
    region: "South Asia",
    countryName: "Bhutan",
    transferMate: 27,
    nationality: "Bhutanese",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BHUTAN
  },
  BOLIVIA: {
    key: "BOLIVIA",
    region: "South America",
    countryName: "Bolivia",
    transferMate: 28,
    nationality: "Bolivian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOLIVIA
  },
  BOSNIA_AND_HERZEGOVINA: {
    key: "BOSNIA_AND_HERZEGOVINA",
    region: "Non_EU Europe",
    countryName: "Bosnia and Herzegovina",
    transferMate: 29,
    nationality: "Bosnian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOSNIA_AND_HERZEGOVINA
  },
  BOUVET_ISLAND: {
    key: "BOUVET_ISLAND",
    region: "South America",
    countryName: "Bouvet Island",
    transferMate: 31,
    nationality: "Bouvet Island",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BOUVET_ISLAND
  },
  BRITISH_INDIAN_OCEAN_TERRITORY: {
    key: "BRITISH_INDIAN_OCEAN_TERRITORY",
    region: "South Asia",
    countryName: "British Indian Ocean Territory",
    transferMate: 33,
    nationality: "British (IOT)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY
  },
  BURKINA_FASO: {
    key: "BURKINA_FASO",
    region: "Africa",
    countryName: "Burkina Faso",
    transferMate: 36,
    nationality: "Burkinabe",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BURKINA_FASO
  },
  BURUNDI: {
    key: "BURUNDI",
    region: "Africa",
    countryName: "Burundi",
    transferMate: 37,
    nationality: "Burundian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BURUNDI
  },
  CAMEROON: {
    key: "CAMEROON",
    region: "Africa",
    countryName: "Cameroon",
    transferMate: 39,
    nationality: "Cameroonian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAMEROON
  },
  CAPE_VERDE: {
    key: "CAPE_VERDE",
    region: "Africa",
    countryName: "Cape Verde",
    transferMate: 42,
    nationality: "Cape Verdean",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAPE_VERDE
  },
  CAYMAN_ISLANDS: {
    key: "CAYMAN_ISLANDS",
    region: "North America",
    countryName: "Cayman Islands",
    transferMate: 43,
    nationality: "Caymanian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CAYMAN_ISLANDS
  },
  CENTRAL_AFRICAN_REPUBLIC: {
    key: "CENTRAL_AFRICAN_REPUBLIC",
    region: "Africa",
    countryName: "Central African Republic",
    transferMate: 44,
    nationality: "Central African",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CENTRAL_AFRICAN_REPUBLIC
  },
  CHAD: {
    key: "CHAD",
    region: "Africa",
    countryName: "Chad",
    transferMate: 45,
    nationality: "Chadian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CHAD
  },
  CHRISTMAS_ISLAND: {
    key: "CHRISTMAS_ISLAND",
    region: "Southeast Asia",
    countryName: "Christmas Island",
    transferMate: 48,
    nationality: "Christmas Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CHRISTMAS_ISLAND
  },
  COCOS_KEELING_ISLANDS: {
    key: "COCOS_KEELING_ISLANDS",
    region: "Southeast Asia",
    countryName: "Cocos (Keeling) Islands",
    transferMate: 49,
    nationality: "Cocossian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COCOS_KEELING_ISLANDS
  },
  COLOMBIA: {
    key: "COLOMBIA",
    region: "South America",
    countryName: "Colombia",
    transferMate: 50,
    nationality: "Colombian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COLOMBIA
  },
  COMOROS: {
    key: "COMOROS",
    region: "Africa",
    countryName: "Comoros",
    transferMate: 51,
    nationality: "Comoran",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COMOROS
  },
  CONGO: {
    key: "CONGO",
    region: "Africa",
    countryName: "Congo",
    transferMate: 52,
    nationality: "Congolese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CONGO
  },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: {
    key: "CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE",
    region: "Africa",
    transferMate: 256,
    countryName: "Congo, the Democratic Republic of the",
    nationality: "Congolese (DRC)",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE
  },
  COOK_ISLANDS: {
    key: "COOK_ISLANDS",
    region: "Oceania",
    countryName: "Cook Islands",
    transferMate: 53,
    nationality: "Cook Islander",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COOK_ISLANDS
  },
  COSTA_RICA: {
    key: "COSTA_RICA",
    region: "North America",
    countryName: "Costa Rica",
    transferMate: 54,
    nationality: "Costa Rican",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COSTA_RICA
  },
  COTE_DIVOIRE: {
    key: "COTE_DIVOIRE",
    region: "Africa",
    countryName: "Cote D'Ivoire",
    nationality: "Ivorian",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.COTE_DIVOIRE
  },
  CUBA: {
    key: "CUBA",
    region: "North America",
    countryName: "Cuba",
    transferMate: 57,
    nationality: "Cuban",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CUBA
  },
  DJIBOUTI: {
    key: "DJIBOUTI",
    region: "Africa",
    countryName: "Djibouti",
    transferMate: 63,
    nationality: "Djiboutian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.DJIBOUTI
  },
  DOMINICAN_REPUBLIC: {
    key: "DOMINICAN_REPUBLIC",
    region: "North America",
    countryName: "Dominican Republic",
    transferMate: 65,
    nationality: "Dominican (Republic)",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "AppendixH",
    categoryNewNameRefactor: "Differential (Low Risk)",
    ...countryCodes.DOMINICAN_REPUBLIC
  },
  ECUADOR: {
    key: "ECUADOR",
    region: "South America",
    countryName: "Ecuador",
    transferMate: 67,
    nationality: "Ecuadorean",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ECUADOR
  },
  EGYPT: {
    key: "EGYPT",
    region: "Middle East|Africa",
    countryName: "Egypt",
    transferMate: 68,
    nationality: "Egyptian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EGYPT
  },
  EL_SALVADOR: {
    key: "EL_SALVADOR",
    region: "North America",
    countryName: "El Salvador",
    transferMate: 69,
    nationality: "Salvadorean",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EL_SALVADOR
  },
  EQUATORIAL_GUINEA: {
    key: "EQUATORIAL_GUINEA",
    region: "Africa",
    countryName: "Equatorial Guinea",
    transferMate: 70,
    nationality: "Equatorial Guinean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.EQUATORIAL_GUINEA
  },
  ERITREA: {
    key: "ERITREA",
    region: "Africa",
    countryName: "Eritrea",
    transferMate: 71,
    nationality: "Eritrean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ERITREA
  },
  ETHIOPIA: {
    key: "ETHIOPIA",
    region: "Africa",
    countryName: "Ethiopia",
    transferMate: 73,
    nationality: "Ethiopian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ETHIOPIA
  },
  FALKLAND_ISLANDS_MALVINAS: {
    key: "FALKLAND_ISLANDS_MALVINAS",
    region: "South America",
    countryName: "Falkland Islands (Malvinas)",
    nationality: "Falkland Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FALKLAND_ISLANDS_MALVINAS
  },
  FAROE_ISLANDS: {
    key: "FAROE_ISLANDS",
    region: "Europe",
    countryName: "Faroe Islands",
    transferMate: 75,
    nationality: "Faroese",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FAROE_ISLANDS
  },
  FIJI: {
    key: "FIJI",
    region: "Oceania",
    countryName: "Fiji",
    nationality: "Fijian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FIJI
  },
  FRENCH_GUIANA: {
    key: "FRENCH_GUIANA",
    region: "South America",
    countryName: "French Guiana",
    transferMate: 81,
    nationality: "French Guianese",
    atas: false,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_GUIANA
  },
  FRENCH_POLYNESIA: {
    key: "FRENCH_POLYNESIA",
    region: "Oceania",
    countryName: "French Polynesia",
    transferMate: 82,
    nationality: "French Polynesian",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_POLYNESIA
  },
  FRENCH_SOUTHERN_TERRITORIES: {
    key: "FRENCH_SOUTHERN_TERRITORIES",
    region: "South Asia",
    countryName: "French Southern Territories",
    transferMate: 83,
    nationality: "French (Southern Territories)",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.FRENCH_SOUTHERN_TERRITORIES
  },
  GABON: {
    key: "GABON",
    region: "Africa",
    countryName: "Gabon",
    transferMate: 84,
    nationality: "Gabonese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GABON
  },
  GAMBIA: {
    key: "GAMBIA",
    region: "Africa",
    countryName: "Gambia",
    transferMate: 85,
    nationality: "Gambian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GAMBIA
  },
  GEORGIA: {
    key: "GEORGIA",
    region: "Non_EU Europe",
    countryName: "Georgia",
    transferMate: 86,
    nationality: "Georgian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GEORGIA
  },
  GHANA: {
    key: "GHANA",
    region: "Africa",
    countryName: "Ghana",
    transferMate: 89,
    nationality: "Ghanaian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GHANA
  },
  GIBRALTAR: {
    key: "GIBRALTAR",
    region: "Europe",
    countryName: "Gibraltar",
    transferMate: 90,
    nationality: "Gibraltarian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GIBRALTAR
  },
  GREENLAND: {
    key: "GREENLAND",
    region: "Europe",
    countryName: "Greenland",
    transferMate: 92,
    nationality: "Greenlander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GREENLAND
  },
  GRENADA: {
    key: "GRENADA",
    region: "North America",
    countryName: "Grenada",
    transferMate: 93,
    nationality: "Grenadian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GRENADA
  },
  GUADELOUPE: {
    key: "GUADELOUPE",
    region: "North America",
    countryName: "Guadeloupe",
    transferMate: 94,
    nationality: "Guadeloupean",
    atas: false,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUADELOUPE
  },
  GUAM: {
    key: "GUAM",
    region: "East Asia",
    countryName: "Guam",
    transferMate: 95,
    nationality: "Guamanian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUAM
  },
  GUATEMALA: {
    key: "GUATEMALA",
    region: "North America",
    countryName: "Guatemala",
    transferMate: 96,
    nationality: "Guatemalan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUATEMALA
  },
  GUINEA: {
    key: "GUINEA",
    region: "Africa",
    countryName: "Guinea",
    transferMate: 97,
    nationality: "Guinean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUINEA
  },
  GUINEA_BISSAU: {
    key: "GUINEA_BISSAU",
    region: "Africa",
    countryName: "Guinea-Bissau",
    transferMate: 98,
    nationality: "Guinean (Bissau)",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUINEA_BISSAU
  },
  GUYANA: {
    key: "GUYANA",
    region: "South America",
    countryName: "Guyana",
    transferMate: 99,
    nationality: "Guyanese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUYANA
  },
  HAITI: {
    key: "HAITI",
    region: "North America",
    countryName: "Haiti",
    transferMate: 100,
    nationality: "Haitian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HAITI
  },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: {
    key: "HEARD_ISLAND_AND_MCDONALD_ISLANDS",
    region: "Oceania",
    countryName: "Heard Island and Mcdonald Islands",
    nationality: "Heard Island and Mcdonald Island",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS
  },
  VATICAN: {
    key: "VATICAN",
    region: "Europe",
    countryName: "Vatican",
    nationality: "Vatican",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VATICAN
  },
  HONDURAS: {
    key: "HONDURAS",
    region: "North America",
    countryName: "Honduras",
    transferMate: 104,
    nationality: "Honduran",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.HONDURAS
  },
  INDIA: {
    key: "INDIA",
    region: "South Asia",
    countryName: "India",
    transferMate: 109,
    nationality: "Indian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.INDIA
  },
  IRAN_ISLAMIC_REPUBLIC_OF: {
    key: "IRAN_ISLAMIC_REPUBLIC_OF",
    region: "Middle East",
    countryName: "Iran, Islamic Republic of",
    nationality: "Iranian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.IRAN_ISLAMIC_REPUBLIC_OF
  },
  IRAQ: {
    key: "IRAQ",
    region: "Middle East",
    countryName: "Iraq",
    transferMate: 112,
    nationality: "Iraqi",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.IRAQ
  },
  ISRAEL: {
    key: "ISRAEL",
    region: "Middle East",
    countryName: "Israel",
    transferMate: 115,
    nationality: "Israeli",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ISRAEL
  },
  JAMAICA: {
    key: "JAMAICA",
    region: "North America",
    countryName: "Jamaica",
    transferMate: 118,
    nationality: "Jamaican",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JAMAICA
  },
  JORDAN: {
    key: "JORDAN",
    region: "Middle East",
    countryName: "Jordan",
    transferMate: 121,
    nationality: "Jordanian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JORDAN
  },
  KENYA: {
    key: "KENYA",
    region: "Africa",
    countryName: "Kenya",
    transferMate: 123,
    nationality: "Kenyan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KENYA
  },
  KIRIBATI: {
    key: "KIRIBATI",
    region: "Oceania",
    countryName: "Kiribati",
    transferMate: 124,
    nationality: "I_Kiribati",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KIRIBATI
  },
  NORTH_KOREA: {
    key: "NORTH_KOREA",
    region: "East Asia",
    countryName: "North Korea",
    nationality: "North Korean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTH_KOREA
  },
  KYRGYZSTAN: {
    key: "KYRGYZSTAN",
    region: "Central Asia (CIS)",
    countryName: "Kyrgyzstan",
    transferMate: 127,
    nationality: "Kyrgyzstani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KYRGYZSTAN
  },
  LAOS: {
    key: "LAOS",
    region: "Southeast Asia",
    countryName: "Laos",
    transferMate: 128,
    nationality: "Laotian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LAOS
  },
  LEBANON: {
    key: "LEBANON",
    region: "Middle East",
    countryName: "Lebanon",
    transferMate: 130,
    nationality: "Lebanese",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LEBANON
  },
  LESOTHO: {
    key: "LESOTHO",
    region: "Africa",
    countryName: "Lesotho",
    transferMate: 131,
    nationality: "Mosotho",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LESOTHO
  },
  LIBERIA: {
    key: "LIBERIA",
    region: "Africa",
    countryName: "Liberia",
    transferMate: 132,
    nationality: "Liberian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LIBERIA
  },
  LIBYA: {
    key: "LIBYA",
    region: "Africa",
    countryName: "Libya",
    nationality: "Libyan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.LIBYA
  },
  MADAGASCAR: {
    key: "MADAGASCAR",
    region: "Africa",
    countryName: "Madagascar",
    transferMate: 139,
    nationality: "Malagasy",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MADAGASCAR
  },
  MALAWI: {
    key: "MALAWI",
    region: "Africa",
    countryName: "Malawi",
    transferMate: 140,
    nationality: "Malawian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALAWI
  },
  MALDIVES: {
    key: "MALDIVES",
    region: "South Asia",
    countryName: "Maldives",
    transferMate: 142,
    nationality: "Maldivan",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALDIVES
  },
  MALI: {
    key: "MALI",
    region: "Africa",
    countryName: "Mali",
    transferMate: 143,
    nationality: "Malian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MALI
  },
  MARSHALL_ISLANDS: {
    key: "MARSHALL_ISLANDS",
    region: "Oceania",
    countryName: "Marshall Islands",
    transferMate: 146,
    nationality: "Marshallese",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MARSHALL_ISLANDS
  },
  MARTINIQUE: {
    key: "MARTINIQUE",
    region: "North America",
    countryName: "Martinique",
    transferMate: 147,
    nationality: "Martinican",
    atas: false,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MARTINIQUE
  },
  MAURITANIA: {
    key: "MAURITANIA",
    region: "Africa",
    countryName: "Mauritania",
    transferMate: 148,
    nationality: "Mauritanian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MAURITANIA
  },
  MAYOTTE: {
    key: "MAYOTTE",
    region: "Africa",
    countryName: "Mayotte",
    transferMate: 150,
    nationality: "Mahoran",
    atas: false,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MAYOTTE
  },
  MICRONESIA_FEDERATED_STATES_OF: {
    key: "MICRONESIA_FEDERATED_STATES_OF",
    region: "Oceania",
    countryName: "Micronesia, Federated States of",
    nationality: "Micronesian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MICRONESIA_FEDERATED_STATES_OF
  },
  MOLDOVA_REPUBLIC_OF: {
    key: "MOLDOVA_REPUBLIC_OF",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Moldova, Republic of",
    nationality: "Moldovan",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOLDOVA_REPUBLIC_OF
  },
  MONACO: {
    key: "MONACO",
    region: "Europe",
    countryName: "Monaco",
    transferMate: 154,
    nationality: "Monacan",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONACO
  },
  MONGOLIA: {
    key: "MONGOLIA",
    region: "East Asia",
    countryName: "Mongolia",
    transferMate: 155,
    nationality: "Mongolian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONGOLIA
  },
  MONTSERRAT: {
    key: "MONTSERRAT",
    region: "North America",
    countryName: "Montserrat",
    transferMate: 156,
    nationality: "Montserratian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONTSERRAT
  },
  MOROCCO: {
    key: "MOROCCO",
    region: "Africa",
    countryName: "Morocco",
    transferMate: 157,
    nationality: "Moroccan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOROCCO
  },
  MOZAMBIQUE: {
    key: "MOZAMBIQUE",
    region: "Africa",
    countryName: "Mozambique",
    transferMate: 158,
    nationality: "Mozambican",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MOZAMBIQUE
  },
  MYANMAR: {
    key: "MYANMAR",
    region: "Southeast Asia",
    countryName: "Myanmar",
    transferMate: 159,
    nationality: "Myanmarese",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MYANMAR
  },
  NAMIBIA: {
    key: "NAMIBIA",
    region: "Africa",
    countryName: "Namibia",
    transferMate: 160,
    nationality: "Namibian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NAMIBIA
  },
  NAURU: {
    key: "NAURU",
    region: "Oceania",
    countryName: "Nauru",
    transferMate: 161,
    nationality: "Nauruan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NAURU
  },
  NEPAL: {
    key: "NEPAL",
    region: "South Asia",
    countryName: "Nepal",
    transferMate: 162,
    nationality: "Nepalese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NEPAL
  },
  NEW_CALEDONIA: {
    key: "NEW_CALEDONIA",
    region: "Oceania",
    countryName: "New Caledonia",
    transferMate: 262,
    nationality: "New Caledonian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NEW_CALEDONIA
  },
  NICARAGUA: {
    key: "NICARAGUA",
    region: "North America",
    countryName: "Nicaragua",
    transferMate: 165,
    nationality: "Nicaraguan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NICARAGUA
  },
  NIGER: {
    key: "NIGER",
    region: "Africa",
    countryName: "Niger",
    transferMate: 166,
    nationality: "Nigerien",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIGER
  },
  NIGERIA: {
    key: "NIGERIA",
    region: "Africa",
    countryName: "Nigeria",
    transferMate: 167,
    nationality: "Nigerian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIGERIA
  },
  NIUE: {
    key: "NIUE",
    region: "Oceania",
    countryName: "Niue",
    transferMate: 168,
    nationality: "Niuean",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NIUE
  },
  NORFOLK_ISLAND: {
    key: "NORFOLK_ISLAND",
    region: "Oceania",
    countryName: "Norfolk Island",
    transferMate: 169,
    nationality: "Norfolk Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORFOLK_ISLAND
  },
  NORTH_MACEDONIA_REPUBLIC_OF: {
    key: "NORTH_MACEDONIA_REPUBLIC_OF",
    region: "Non_EU Europe",
    countryName: "North Macedonia, Republic of",
    nationality: "Macedonian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTH_MACEDONIA_REPUBLIC_OF
  },
  NORTHERN_MARIANA_ISLANDS: {
    key: "NORTHERN_MARIANA_ISLANDS",
    region: "Oceania",
    countryName: "Northern Mariana Islands",
    transferMate: 170,
    nationality: "Northern Mariana Islander",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.NORTHERN_MARIANA_ISLANDS
  },
  PAKISTAN: {
    key: "PAKISTAN",
    region: "South Asia",
    countryName: "Pakistan",
    transferMate: 173,
    nationality: "Pakistani",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PAKISTAN
  },
  PALAU: {
    key: "PALAU",
    region: "Oceania",
    countryName: "Palau",
    transferMate: 174,
    nationality: "Palauan",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PALAU
  },
  PALESTINE: {
    key: "PALESTINE",
    region: "Middle East",
    countryName: "Palestine",
    nationality: "Palestinian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PALESTINE
  },
  PANAMA: {
    key: "PANAMA",
    region: "North America",
    countryName: "Panama",
    transferMate: 175,
    nationality: "Panamanian",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PANAMA
  },
  PAPUA_NEW_GUINEA: {
    key: "PAPUA_NEW_GUINEA",
    region: "Oceania",
    countryName: "Papua New Guinea",
    nationality: "Papua New Guinean",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PAPUA_NEW_GUINEA
  },
  PARAGUAY: {
    key: "PARAGUAY",
    region: "South America",
    countryName: "Paraguay",
    transferMate: 177,
    nationality: "Paraguayan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PARAGUAY
  },
  PHILIPPINES: {
    key: "PHILIPPINES",
    region: "Southeast Asia",
    countryName: "Philippines",
    transferMate: 179,
    nationality: "Filipino",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PHILIPPINES
  },
  PITCAIRN: {
    key: "PITCAIRN",
    region: "Oceania",
    countryName: "Pitcairn",
    nationality: "Pitcairn Islander",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PITCAIRN
  },
  PUERTO_RICO: {
    key: "PUERTO_RICO",
    region: "North America",
    countryName: "Puerto Rico",
    transferMate: 183,
    nationality: "Puerto Rican",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.PUERTO_RICO
  },
  REUNION: {
    key: "REUNION",
    region: "South Asia",
    countryName: "Reunion",
    transferMate: 185,
    nationality: "Reunion",
    atas: false,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.REUNION
  },
  RUSSIA: {
    key: "RUSSIA",
    region: "Non_EU Europe|Central Asia (CIS)",
    countryName: "Russia",
    transferMate: 187,
    nationality: "Russian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.RUSSIA
  },
  RWANDA: {
    key: "RWANDA",
    region: "Africa",
    countryName: "Rwanda",
    transferMate: 188,
    nationality: "Rwandan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.RWANDA
  },
  SAINT_HELENA: {
    key: "SAINT_HELENA",
    region: "Africa",
    countryName: "Saint Helena",
    transferMate: 190,
    nationality: "Saint Helenian",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_HELENA
  },
  SAINT_KITTS_AND_NEVIS: {
    key: "SAINT_KITTS_AND_NEVIS",
    region: "North America",
    countryName: "Saint Kitts and Nevis",
    nationality: "Kittian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_KITTS_AND_NEVIS
  },
  SAINT_LUCIA: {
    key: "SAINT_LUCIA",
    region: "North America",
    countryName: "Saint Lucia",
    transferMate: 192,
    nationality: "Saint Lucian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_LUCIA
  },
  SAINT_PIERRE_AND_MIQUELON: {
    key: "SAINT_PIERRE_AND_MIQUELON",
    region: "North America",
    countryName: "Saint Pierre and Miquelon",
    transferMate: 193,
    nationality: "Saint_Pierrais",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_PIERRE_AND_MIQUELON
  },
  SAINT_VINCENT_AND_THE_GRENADINES: {
    key: "SAINT_VINCENT_AND_THE_GRENADINES",
    region: "North America",
    countryName: "Saint Vincent and the Grenadines",
    nationality: "Saint Vincentian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_VINCENT_AND_THE_GRENADINES
  },
  SAMOA: {
    key: "SAMOA",
    region: "Oceania",
    countryName: "Samoa",
    transferMate: 195,
    nationality: "Samoan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAMOA
  },
  SAN_MARINO: {
    key: "SAN_MARINO",
    region: "Europe",
    countryName: "San Marino",
    transferMate: 196,
    nationality: "Sanmarinese",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAN_MARINO
  },
  SAO_TOME_AND_PRINCIPE: {
    key: "SAO_TOME_AND_PRINCIPE",
    region: "Africa",
    countryName: "Sao Tome and Principe",
    transferMate: 197,
    nationality: "Sao Tomean",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAO_TOME_AND_PRINCIPE
  },
  SAUDI_ARABIA: {
    key: "SAUDI_ARABIA",
    region: "Middle East",
    countryName: "Saudi Arabia",
    transferMate: 198,
    nationality: "Saudi Arabian",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAUDI_ARABIA
  },
  SENEGAL: {
    key: "SENEGAL",
    region: "Africa",
    countryName: "Senegal",
    transferMate: 199,
    nationality: "Senegalese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SENEGAL
  },
  SEYCHELLES: {
    key: "SEYCHELLES",
    region: "Africa",
    countryName: "Seychelles",
    transferMate: 201,
    nationality: "Seychellois",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SEYCHELLES
  },
  SIERRA_LEONE: {
    key: "SIERRA_LEONE",
    region: "Africa",
    countryName: "Sierra Leone",
    transferMate: 202,
    nationality: "Sierra Leonean",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SIERRA_LEONE
  },
  SOLOMON_ISLANDS: {
    key: "SOLOMON_ISLANDS",
    region: "Oceania",
    countryName: "Solomon Islands",
    transferMate: 206,
    nationality: "Solomon Islander",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOLOMON_ISLANDS
  },
  SOMALIA: {
    key: "SOMALIA",
    region: "Africa",
    countryName: "Somalia",
    transferMate: 207,
    nationality: "Somali",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOMALIA
  },
  SOUTH_AFRICA: {
    key: "SOUTH_AFRICA",
    region: "Africa",
    countryName: "South Africa",
    transferMate: 208,
    nationality: "South African",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_AFRICA
  },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: {
    key: "SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS",
    region: "Central Asia (CIS)",
    countryName: "South Georgia and the South Sandwich Islands",
    nationality: "South Georgia and the South Sandwich Islands",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS
  },
  SRI_LANKA: {
    key: "SRI_LANKA",
    region: "South Asia",
    countryName: "Sri Lanka",
    transferMate: 212,
    nationality: "Sri Lankan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SRI_LANKA
  },
  SUDAN: {
    key: "SUDAN",
    region: "Africa",
    countryName: "Sudan",
    transferMate: 213,
    nationality: "Sudanese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SUDAN
  },
  SURINAME: {
    key: "SURINAME",
    region: "South America",
    countryName: "Suriname",
    transferMate: 214,
    nationality: "Surinamer",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SURINAME
  },
  SVALBARD_AND_JAN_MAYEN: {
    key: "SVALBARD_AND_JAN_MAYEN",
    region: "Europe",
    countryName: "Svalbard and Jan Mayen",
    nationality: "Svalbard and Jan Mayen",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SVALBARD_AND_JAN_MAYEN
  },
  SWAZILAND: {
    key: "SWAZILAND",
    region: "Africa",
    countryName: "Swaziland",
    transferMate: 216,
    nationality: "Swazi",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SWAZILAND
  },
  SYRIA: {
    key: "SYRIA",
    region: "Middle East",
    countryName: "Syria",
    nationality: "Syrian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SYRIA
  },
  TAJIKISTAN: {
    key: "TAJIKISTAN",
    region: "Central Asia (CIS)",
    countryName: "Tajikistan",
    transferMate: 221,
    nationality: "Tajikistani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TAJIKISTAN
  },
  TANZANIA_UNITED_REPUBLIC_OF: {
    key: "TANZANIA_UNITED_REPUBLIC_OF",
    region: "Africa",
    countryName: "Tanzania, United Republic of",
    nationality: "Tanzanian",
    atas: true,
    tb: true,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TANZANIA_UNITED_REPUBLIC_OF
  },
  TIMOR_LESTE: {
    key: "TIMOR_LESTE",
    region: "Southeast Asia",
    countryName: "Timor-Leste",
    nationality: "Timorese",
    atas: true,
    tb: true,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TIMOR_LESTE
  },
  TOGO: {
    key: "TOGO",
    region: "Africa",
    countryName: "Togo",
    transferMate: 224,
    nationality: "Togolese",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TOGO
  },
  TOKELAU: {
    key: "TOKELAU",
    region: "Oceania",
    countryName: "Tokelau",
    transferMate: 225,
    nationality: "Tokelauan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TOKELAU
  },
  TONGA: {
    key: "TONGA",
    region: "Oceania",
    countryName: "Tonga",
    transferMate: 226,
    nationality: "Tongan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TONGA
  },
  TRINIDAD_AND_TOBAGO: {
    key: "TRINIDAD_AND_TOBAGO",
    region: "North America",
    countryName: "Trinidad and Tobago",
    nationality: "Trinidadian",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TRINIDAD_AND_TOBAGO
  },
  TURKEY: {
    key: "TURKEY",
    region: "Non_EU Europe",
    countryName: "Turkey",
    transferMate: 229,
    nationality: "Turkish",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKEY
  },
  TURKMENISTAN: {
    key: "TURKMENISTAN",
    region: "Central Asia (CIS)",
    countryName: "Turkmenistan",
    transferMate: 230,
    nationality: "Turkmen",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKMENISTAN
  },
  TURKS_AND_CAICOS_ISLANDS: {
    key: "TURKS_AND_CAICOS_ISLANDS",
    region: "North America",
    countryName: "Turks and Caicos Islands",
    nationality: "Turks and Caicos Islander",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TURKS_AND_CAICOS_ISLANDS
  },
  TUVALU: {
    key: "TUVALU",
    region: "Oceania",
    countryName: "Tuvalu",
    transferMate: 232,
    nationality: "Tuvaluan",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.TUVALU
  },
  UGANDA: {
    key: "UGANDA",
    region: "Africa",
    countryName: "Uganda",
    transferMate: 233,
    nationality: "Ugandan",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UGANDA
  },
  UKRAINE: {
    key: "UKRAINE",
    region: "Non_EU Europe",
    countryName: "Ukraine",
    transferMate: 234,
    nationality: "Ukrainian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UKRAINE
  },
  UNITED_KINGDOM: {
    key: "UNITED_KINGDOM",
    region: "UK",
    countryName: "United Kingdom",
    transferMate: 236,
    nationality: "British",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UNITED_KINGDOM
  },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: {
    key: "UNITED_STATES_MINOR_OUTLYING_ISLANDS",
    region: "Oceania",
    countryName: "United States Minor Outlying Islands",
    nationality: "American (MOI)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS
  },
  URUGUAY: {
    key: "URUGUAY",
    region: "South America",
    countryName: "Uruguay",
    transferMate: 239,
    nationality: "Uruguayan",
    atas: true,
    tb: false,
    riskLevel: 1,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.URUGUAY
  },
  UZBEKISTAN: {
    key: "UZBEKISTAN",
    region: "Central Asia (CIS)",
    countryName: "Uzbekistan",
    transferMate: 241,
    nationality: "Uzbekistani",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.UZBEKISTAN
  },
  VANUATU: {
    key: "VANUATU",
    region: "Oceania",
    countryName: "Vanuatu",
    transferMate: 242,
    nationality: "Ni_Vanuatu",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VANUATU
  },
  VENEZUELA: {
    key: "VENEZUELA",
    region: "South America",
    countryName: "Venezuela",
    transferMate: 244,
    nationality: "Venezuelan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VENEZUELA
  },
  VIETNAM: {
    key: "VIETNAM",
    region: "Southeast Asia",
    countryName: "Vietnam",
    transferMate: 245,
    nationality: "Vietnamese",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIETNAM
  },
  VIRGIN_ISLANDS_BRITISH: {
    key: "VIRGIN_ISLANDS_BRITISH",
    region: "North America",
    countryName: "Virgin Islands, British",
    nationality: "Virgin Islander (British)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIRGIN_ISLANDS_BRITISH
  },
  VIRGIN_ISLANDS_US: {
    key: "VIRGIN_ISLANDS_US",
    region: "North America",
    countryName: "Virgin Islands, U.S.",
    nationality: "Virgin Islander (American)",
    atas: true,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.VIRGIN_ISLANDS_US
  },
  WALLIS_AND_FUTUNA: {
    key: "WALLIS_AND_FUTUNA",
    region: "Oceania",
    countryName: "Wallis and Futuna",
    nationality: "Wallisian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.WALLIS_AND_FUTUNA
  },
  WESTERN_SAHARA: {
    key: "WESTERN_SAHARA",
    region: "Africa",
    countryName: "Western Sahara",
    transferMate: 266,
    nationality: "Western Saharan",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.WESTERN_SAHARA
  },
  YEMEN: {
    key: "YEMEN",
    region: "Middle East",
    countryName: "Yemen",
    transferMate: 249,
    nationality: "Yemenese",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.YEMEN
  },
  ZAMBIA: {
    key: "ZAMBIA",
    region: "Africa",
    countryName: "Zambia",
    transferMate: 250,
    nationality: "Zambian",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ZAMBIA
  },
  ZIMBABWE: {
    key: "ZIMBABWE",
    region: "Africa",
    countryName: "Zimbabwe",
    transferMate: 251,
    nationality: "Zimbabwean",
    atas: true,
    tb: true,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ZIMBABWE
  },
  ALAND_ISLANDS: {
    key: "ALAND_ISLANDS",
    region: "Europe",
    countryName: "\xC5land Islands",
    nationality: "\xC5landic",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ALAND_ISLANDS
  },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: {
    key: "BONAIRE_SINT_EUSTATIUS_AND_SABA",
    region: "North America",
    countryName: "Bonaire, Sint Eustatius and Saba",
    nationality: "Dutch (Caribbean)",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA
  },
  CURACAO: {
    key: "CURACAO",
    region: "North America",
    countryName: "Cura\xE7ao",
    nationality: "Cura\xE7aoan",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.CURACAO
  },
  GUERNSEY: {
    key: "GUERNSEY",
    region: "Europe",
    countryName: "Guernsey",
    transferMate: 258,
    nationality: "Guernsey",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.GUERNSEY
  },
  ISLE_OF_MAN: {
    key: "ISLE_OF_MAN",
    region: "Europe",
    countryName: "Isle of Man",
    transferMate: 259,
    nationality: "Manx",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.ISLE_OF_MAN
  },
  JERSEY: {
    key: "JERSEY",
    region: "Europe",
    countryName: "Jersey",
    transferMate: 260,
    nationality: "Jersey",
    atas: false,
    tb: false,
    riskLevel: 0,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.JERSEY
  },
  MONTENEGRO: {
    key: "MONTENEGRO",
    region: "Non_EU Europe",
    countryName: "Montenegro",
    nationality: "Montenegrin",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.MONTENEGRO
  },
  SAINT_BARTHELEMY: {
    key: "SAINT_BARTHELEMY",
    region: "North America",
    countryName: "Saint Barth\xE9lemy",
    nationality: "Barth\xE9lemois",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_BARTHELEMY
  },
  SAINT_MARTIN_FRANCE: {
    key: "SAINT_MARTIN_FRANCE",
    region: "North America",
    countryName: "Saint Martin (France)",
    nationality: "French (Saint Martin)",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SAINT_MARTIN_FRANCE
  },
  SINT_MAARTEN_DUTCH: {
    key: "SINT_MAARTEN_DUTCH",
    region: "North America",
    countryName: "Sint Maarten (Dutch)",
    nationality: "Dutch (St. Martin)",
    atas: true,
    tb: false,
    riskLevel: 2,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SINT_MAARTEN_DUTCH
  },
  SOUTH_SUDAN: {
    key: "SOUTH_SUDAN",
    region: "Africa",
    countryName: "South Sudan",
    nationality: "Sudanese (South)",
    atas: true,
    tb: true,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.SOUTH_SUDAN
  },
  KOSOVO: {
    key: "KOSOVO",
    region: "Non_EU Europe",
    countryName: "Kosovo",
    nationality: "Kosovian",
    atas: true,
    tb: false,
    riskLevel: 3,
    category: "NonAppendixH",
    categoryNewNameRefactor: "Standard",
    ...countryCodes.KOSOVO
  }
};

// src/countries/countryArray.ts
var countries = [
  recognisedCountries.AUSTRALIA,
  recognisedCountries.AUSTRIA,
  recognisedCountries.BAHRAIN,
  recognisedCountries.BARBADOS,
  recognisedCountries.BELGIUM,
  recognisedCountries.BERMUDA,
  recognisedCountries.BOTSWANA,
  recognisedCountries.BRAZIL,
  recognisedCountries.BRUNEI_DARUSSALAM,
  recognisedCountries.BULGARIA,
  recognisedCountries.CANADA,
  recognisedCountries.CAYMAN_ISLANDS,
  recognisedCountries.CHILE,
  recognisedCountries.CHINA,
  recognisedCountries.COLOMBIA,
  recognisedCountries.COSTA_RICA,
  recognisedCountries.CROATIA,
  recognisedCountries.CYPRUS,
  recognisedCountries.CZECH_REPUBLIC,
  recognisedCountries.DENMARK,
  recognisedCountries.ESTONIA,
  recognisedCountries.FINLAND,
  recognisedCountries.FRANCE,
  recognisedCountries.GERMANY,
  recognisedCountries.GREECE,
  recognisedCountries.HUNGARY,
  recognisedCountries.INDIA,
  recognisedCountries.INDONESIA,
  recognisedCountries.IRAN_ISLAMIC_REPUBLIC_OF,
  recognisedCountries.IRELAND,
  recognisedCountries.ISRAEL,
  recognisedCountries.ITALY,
  recognisedCountries.JAPAN,
  recognisedCountries.KENYA,
  recognisedCountries.NORTH_KOREA,
  recognisedCountries.SOUTH_KOREA,
  recognisedCountries.KUWAIT,
  recognisedCountries.LATVIA,
  recognisedCountries.LITHUANIA,
  recognisedCountries.LUXEMBOURG,
  recognisedCountries.MALAYSIA,
  recognisedCountries.MALTA,
  recognisedCountries.MEXICO,
  recognisedCountries.NETHERLANDS,
  recognisedCountries.NEW_ZEALAND,
  recognisedCountries.NORWAY,
  recognisedCountries.OMAN,
  recognisedCountries.PAKISTAN,
  recognisedCountries.PHILIPPINES,
  recognisedCountries.POLAND,
  recognisedCountries.PORTUGAL,
  recognisedCountries.QATAR,
  recognisedCountries.ROMANIA,
  recognisedCountries.SAUDI_ARABIA,
  recognisedCountries.SINGAPORE,
  recognisedCountries.SLOVAKIA,
  recognisedCountries.SLOVENIA,
  recognisedCountries.SOUTH_AFRICA,
  recognisedCountries.SPAIN,
  recognisedCountries.SWEDEN,
  recognisedCountries.SWITZERLAND,
  recognisedCountries.TAIWAN,
  recognisedCountries.THAILAND,
  recognisedCountries.TUNISIA,
  recognisedCountries.TURKEY,
  recognisedCountries.UNITED_ARAB_EMIRATES,
  recognisedCountries.UNITED_KINGDOM,
  recognisedCountries.UNITED_STATES_OF_AMERICA,
  recognisedCountries.VIETNAM,
  recognisedCountries.ZAMBIA,
  recognisedCountries.EGYPT,
  recognisedCountries.SRI_LANKA,
  recognisedCountries.MOROCCO,
  recognisedCountries.NIGERIA,
  recognisedCountries.NIGER,
  recognisedCountries.GHANA,
  recognisedCountries.BANGLADESH,
  recognisedCountries.PERU,
  recognisedCountries.VENEZUELA,
  recognisedCountries.ICELAND,
  recognisedCountries.CAMBODIA,
  recognisedCountries.BOLIVIA,
  recognisedCountries.URUGUAY,
  recognisedCountries.JORDAN,
  recognisedCountries.LIECHTENSTEIN,
  recognisedCountries.MACAU,
  recognisedCountries.MOLDOVA_REPUBLIC_OF,
  recognisedCountries.MONACO,
  recognisedCountries.NEPAL,
  recognisedCountries.SENEGAL,
  recognisedCountries.UZBEKISTAN,
  recognisedCountries.FIJI,
  recognisedCountries.BURUNDI,
  recognisedCountries.BENIN,
  recognisedCountries.CHAD,
  recognisedCountries.DJIBOUTI,
  recognisedCountries.ERITREA,
  recognisedCountries.GABON,
  recognisedCountries.LIBERIA,
  recognisedCountries.MAURITIUS,
  recognisedCountries.RWANDA,
  recognisedCountries.SIERRA_LEONE,
  recognisedCountries.SOMALIA,
  recognisedCountries.SWAZILAND,
  recognisedCountries.YEMEN,
  recognisedCountries.MALAWI,
  recognisedCountries.ZIMBABWE,
  recognisedCountries.MYANMAR,
  recognisedCountries.LAOS,
  recognisedCountries.NAMIBIA,
  recognisedCountries.BAHAMAS,
  recognisedCountries.GUATEMALA,
  recognisedCountries.HONDURAS,
  recognisedCountries.EL_SALVADOR,
  recognisedCountries.CUBA,
  recognisedCountries.JAMAICA,
  recognisedCountries.TRINIDAD_AND_TOBAGO,
  recognisedCountries.DOMINICAN_REPUBLIC,
  recognisedCountries.PARAGUAY,
  recognisedCountries.FAROE_ISLANDS,
  recognisedCountries.GREENLAND,
  recognisedCountries.ISLE_OF_MAN,
  recognisedCountries.JERSEY,
  recognisedCountries.GUERNSEY,
  recognisedCountries.SAINT_LUCIA,
  recognisedCountries.ANGUILLA,
  recognisedCountries.COOK_ISLANDS,
  recognisedCountries.GIBRALTAR,
  recognisedCountries.MONTENEGRO,
  recognisedCountries.SAINT_VINCENT_AND_THE_GRENADINES,
  recognisedCountries.TURKS_AND_CAICOS_ISLANDS,
  recognisedCountries.NORTH_MACEDONIA_REPUBLIC_OF,
  recognisedCountries.SAINT_KITTS_AND_NEVIS,
  recognisedCountries.ANTIGUA_AND_BARBUDA,
  recognisedCountries.DOMINICA,
  recognisedCountries.HONG_KONG,
  recognisedCountries.KAZAKHSTAN,
  recognisedCountries.SERBIA,
  recognisedCountries.AFGHANISTAN,
  recognisedCountries.ALBANIA,
  recognisedCountries.ALGERIA,
  recognisedCountries.AMERICAN_SAMOA,
  recognisedCountries.ANDORRA,
  recognisedCountries.ANGOLA,
  recognisedCountries.ANTARCTICA,
  recognisedCountries.ARGENTINA,
  recognisedCountries.ARMENIA,
  recognisedCountries.ARUBA,
  recognisedCountries.AZERBAIJAN,
  recognisedCountries.BELARUS,
  recognisedCountries.BELIZE,
  recognisedCountries.BHUTAN,
  recognisedCountries.BOSNIA_AND_HERZEGOVINA,
  recognisedCountries.BOUVET_ISLAND,
  recognisedCountries.BRITISH_INDIAN_OCEAN_TERRITORY,
  recognisedCountries.BURKINA_FASO,
  recognisedCountries.CAMEROON,
  recognisedCountries.CAPE_VERDE,
  recognisedCountries.CENTRAL_AFRICAN_REPUBLIC,
  recognisedCountries.CHRISTMAS_ISLAND,
  recognisedCountries.COCOS_KEELING_ISLANDS,
  recognisedCountries.COMOROS,
  recognisedCountries.CONGO,
  recognisedCountries.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  recognisedCountries.ECUADOR,
  recognisedCountries.EQUATORIAL_GUINEA,
  recognisedCountries.ETHIOPIA,
  recognisedCountries.FALKLAND_ISLANDS_MALVINAS,
  recognisedCountries.FRENCH_GUIANA,
  recognisedCountries.FRENCH_POLYNESIA,
  recognisedCountries.FRENCH_SOUTHERN_TERRITORIES,
  recognisedCountries.GAMBIA,
  recognisedCountries.GEORGIA,
  recognisedCountries.GRENADA,
  recognisedCountries.GUADELOUPE,
  recognisedCountries.GUAM,
  recognisedCountries.GUINEA,
  recognisedCountries.GUINEA_BISSAU,
  recognisedCountries.GUYANA,
  recognisedCountries.HAITI,
  recognisedCountries.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  recognisedCountries.VATICAN,
  recognisedCountries.IRAQ,
  recognisedCountries.KIRIBATI,
  recognisedCountries.KYRGYZSTAN,
  recognisedCountries.LEBANON,
  recognisedCountries.LESOTHO,
  recognisedCountries.LIBYA,
  recognisedCountries.MADAGASCAR,
  recognisedCountries.MALDIVES,
  recognisedCountries.MALI,
  recognisedCountries.MARSHALL_ISLANDS,
  recognisedCountries.MARTINIQUE,
  recognisedCountries.MAURITANIA,
  recognisedCountries.MAYOTTE,
  recognisedCountries.MICRONESIA_FEDERATED_STATES_OF,
  recognisedCountries.MONGOLIA,
  recognisedCountries.MONTSERRAT,
  recognisedCountries.MOZAMBIQUE,
  recognisedCountries.NAURU,
  recognisedCountries.NEW_CALEDONIA,
  recognisedCountries.NICARAGUA,
  recognisedCountries.NIUE,
  recognisedCountries.NORFOLK_ISLAND,
  recognisedCountries.NORTHERN_MARIANA_ISLANDS,
  recognisedCountries.PALAU,
  recognisedCountries.PALESTINE,
  recognisedCountries.PANAMA,
  recognisedCountries.PAPUA_NEW_GUINEA,
  recognisedCountries.PITCAIRN,
  recognisedCountries.PUERTO_RICO,
  recognisedCountries.REUNION,
  recognisedCountries.RUSSIA,
  recognisedCountries.SAINT_HELENA,
  recognisedCountries.SAINT_PIERRE_AND_MIQUELON,
  recognisedCountries.SAMOA,
  recognisedCountries.SAN_MARINO,
  recognisedCountries.SAO_TOME_AND_PRINCIPE,
  recognisedCountries.SEYCHELLES,
  recognisedCountries.SOLOMON_ISLANDS,
  recognisedCountries.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  recognisedCountries.SUDAN,
  recognisedCountries.SURINAME,
  recognisedCountries.SVALBARD_AND_JAN_MAYEN,
  recognisedCountries.SYRIA,
  recognisedCountries.TAJIKISTAN,
  recognisedCountries.TANZANIA_UNITED_REPUBLIC_OF,
  recognisedCountries.TIMOR_LESTE,
  recognisedCountries.TOGO,
  recognisedCountries.TOKELAU,
  recognisedCountries.TONGA,
  recognisedCountries.TURKMENISTAN,
  recognisedCountries.TUVALU,
  recognisedCountries.UGANDA,
  recognisedCountries.UKRAINE,
  recognisedCountries.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  recognisedCountries.VANUATU,
  recognisedCountries.VIRGIN_ISLANDS_BRITISH,
  recognisedCountries.VIRGIN_ISLANDS_US,
  recognisedCountries.WALLIS_AND_FUTUNA,
  recognisedCountries.WESTERN_SAHARA,
  recognisedCountries.ALAND_ISLANDS,
  recognisedCountries.BONAIRE_SINT_EUSTATIUS_AND_SABA,
  recognisedCountries.CURACAO,
  recognisedCountries.SAINT_BARTHELEMY,
  recognisedCountries.SAINT_MARTIN_FRANCE,
  recognisedCountries.SINT_MAARTEN_DUTCH,
  recognisedCountries.SOUTH_SUDAN,
  recognisedCountries.KOSOVO,
  recognisedCountries.COTE_DIVOIRE
];

// src/countries/countryLookups.ts
function deepFreeze(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var nationalityCountriesMapTemp = {};
for (const country of countries) {
  const { nationality, countryName } = country;
  nationalityCountriesMapTemp[nationality] = [...nationalityCountriesMapTemp[nationality] || [], countryName];
}
var nationalityCountriesMap = deepFreeze(nationalityCountriesMapTemp);
var countryByNationality = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.nationality]: country });
    return prev;
  }, {})
);
var countryByCountryName = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.countryName]: country });
    return prev;
  }, {})
);
var countryByAlpha3 = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.alphaThree]: country });
    return prev;
  }, {})
);
var countryByNumeric = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.numeric]: country });
    return prev;
  }, {})
);
var countryByRegionName = deepFreeze(
  countries.reduce((prev, country) => {
    Object.assign(prev, { [country.region]: country });
    return prev;
  }, {})
);

// src/countries/phoneCodes.ts
function deepFreeze2(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze2(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var countryPhoneCodes = deepFreeze2({
  [countryCodes.BANGLADESH.alphaTwo]: "880",
  [countryCodes.BELGIUM.alphaTwo]: "32",
  [countryCodes.BURKINA_FASO.alphaTwo]: "226",
  [countryCodes.BULGARIA.alphaTwo]: "359",
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: "387",
  [countryCodes.BARBADOS.alphaTwo]: "1246",
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: "681",
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: "590",
  [countryCodes.BERMUDA.alphaTwo]: "1441",
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: "673",
  [countryCodes.BOLIVIA.alphaTwo]: "591",
  [countryCodes.BAHRAIN.alphaTwo]: "973",
  [countryCodes.BURUNDI.alphaTwo]: "257",
  [countryCodes.BENIN.alphaTwo]: "229",
  [countryCodes.BHUTAN.alphaTwo]: "975",
  [countryCodes.JAMAICA.alphaTwo]: "1876",
  [countryCodes.BOUVET_ISLAND.alphaTwo]: "",
  [countryCodes.BOTSWANA.alphaTwo]: "267",
  [countryCodes.SAMOA.alphaTwo]: "685",
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: "599",
  [countryCodes.BRAZIL.alphaTwo]: "55",
  [countryCodes.BAHAMAS.alphaTwo]: "1242",
  [countryCodes.JERSEY.alphaTwo]: "441534",
  [countryCodes.BELARUS.alphaTwo]: "375",
  [countryCodes.BELIZE.alphaTwo]: "501",
  [countryCodes.RUSSIA.alphaTwo]: "7",
  [countryCodes.RWANDA.alphaTwo]: "250",
  [countryCodes.SERBIA.alphaTwo]: "381",
  [countryCodes.TIMOR_LESTE.alphaTwo]: "670",
  [countryCodes.REUNION.alphaTwo]: "262",
  [countryCodes.TURKMENISTAN.alphaTwo]: "993",
  [countryCodes.TAJIKISTAN.alphaTwo]: "992",
  [countryCodes.ROMANIA.alphaTwo]: "40",
  [countryCodes.TOKELAU.alphaTwo]: "690",
  [countryCodes.GUINEA_BISSAU.alphaTwo]: "245",
  [countryCodes.GUAM.alphaTwo]: "1671",
  [countryCodes.GUATEMALA.alphaTwo]: "502",
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: "",
  [countryCodes.GREECE.alphaTwo]: "30",
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: "240",
  [countryCodes.GUADELOUPE.alphaTwo]: "590",
  [countryCodes.JAPAN.alphaTwo]: "81",
  [countryCodes.GUYANA.alphaTwo]: "592",
  [countryCodes.GUERNSEY.alphaTwo]: "441481",
  [countryCodes.FRENCH_GUIANA.alphaTwo]: "594",
  [countryCodes.GEORGIA.alphaTwo]: "995",
  [countryCodes.GRENADA.alphaTwo]: "1473",
  [countryCodes.UNITED_KINGDOM.alphaTwo]: "44",
  [countryCodes.GABON.alphaTwo]: "241",
  [countryCodes.EL_SALVADOR.alphaTwo]: "503",
  [countryCodes.GUINEA.alphaTwo]: "224",
  [countryCodes.GAMBIA.alphaTwo]: "220",
  [countryCodes.GREENLAND.alphaTwo]: "299",
  [countryCodes.GIBRALTAR.alphaTwo]: "350",
  [countryCodes.GHANA.alphaTwo]: "233",
  [countryCodes.OMAN.alphaTwo]: "968",
  [countryCodes.TUNISIA.alphaTwo]: "216",
  [countryCodes.JORDAN.alphaTwo]: "962",
  [countryCodes.CROATIA.alphaTwo]: "385",
  [countryCodes.HAITI.alphaTwo]: "509",
  [countryCodes.HUNGARY.alphaTwo]: "36",
  [countryCodes.HONG_KONG.alphaTwo]: "852",
  [countryCodes.HONDURAS.alphaTwo]: "504",
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: " ",
  [countryCodes.VENEZUELA.alphaTwo]: "58",
  [countryCodes.PUERTO_RICO.alphaTwo]: "1787 and 1939",
  [countryCodes.PALESTINE.alphaTwo]: "970",
  [countryCodes.PALAU.alphaTwo]: "680",
  [countryCodes.PORTUGAL.alphaTwo]: "351",
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: "47",
  [countryCodes.PARAGUAY.alphaTwo]: "595",
  [countryCodes.IRAQ.alphaTwo]: "964",
  [countryCodes.PANAMA.alphaTwo]: "507",
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: "689",
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: "675",
  [countryCodes.PERU.alphaTwo]: "51",
  [countryCodes.PAKISTAN.alphaTwo]: "92",
  [countryCodes.PHILIPPINES.alphaTwo]: "63",
  [countryCodes.PITCAIRN.alphaTwo]: "870",
  [countryCodes.POLAND.alphaTwo]: "48",
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: "508",
  [countryCodes.ZAMBIA.alphaTwo]: "260",
  [countryCodes.WESTERN_SAHARA.alphaTwo]: "212",
  [countryCodes.ESTONIA.alphaTwo]: "372",
  [countryCodes.EGYPT.alphaTwo]: "20",
  [countryCodes.SOUTH_AFRICA.alphaTwo]: "27",
  [countryCodes.ECUADOR.alphaTwo]: "593",
  [countryCodes.ITALY.alphaTwo]: "39",
  [countryCodes.VIETNAM.alphaTwo]: "84",
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: "677",
  [countryCodes.ETHIOPIA.alphaTwo]: "251",
  [countryCodes.SOMALIA.alphaTwo]: "252",
  [countryCodes.ZIMBABWE.alphaTwo]: "263",
  [countryCodes.SAUDI_ARABIA.alphaTwo]: "966",
  [countryCodes.SPAIN.alphaTwo]: "34",
  [countryCodes.ERITREA.alphaTwo]: "291",
  [countryCodes.MONTENEGRO.alphaTwo]: "382",
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: "373",
  [countryCodes.MADAGASCAR.alphaTwo]: "261",
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: "590",
  [countryCodes.MOROCCO.alphaTwo]: "212",
  [countryCodes.MONACO.alphaTwo]: "377",
  [countryCodes.UZBEKISTAN.alphaTwo]: "998",
  [countryCodes.MYANMAR.alphaTwo]: "95",
  [countryCodes.MALI.alphaTwo]: "223",
  [countryCodes.MACAU.alphaTwo]: "853",
  [countryCodes.MONGOLIA.alphaTwo]: "976",
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: "692",
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: "389",
  [countryCodes.MAURITIUS.alphaTwo]: "230",
  [countryCodes.MALTA.alphaTwo]: "356",
  [countryCodes.MALAWI.alphaTwo]: "265",
  [countryCodes.MALDIVES.alphaTwo]: "960",
  [countryCodes.MARTINIQUE.alphaTwo]: "596",
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: "1670",
  [countryCodes.MONTSERRAT.alphaTwo]: "1664",
  [countryCodes.MAURITANIA.alphaTwo]: "222",
  [countryCodes.ISLE_OF_MAN.alphaTwo]: "441624",
  [countryCodes.UGANDA.alphaTwo]: "256",
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: "255",
  [countryCodes.MALAYSIA.alphaTwo]: "60",
  [countryCodes.MEXICO.alphaTwo]: "52",
  [countryCodes.ISRAEL.alphaTwo]: "972",
  [countryCodes.FRANCE.alphaTwo]: "33",
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: "246",
  [countryCodes.SAINT_HELENA.alphaTwo]: "290",
  [countryCodes.FINLAND.alphaTwo]: "358",
  [countryCodes.FIJI.alphaTwo]: "679",
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: "500",
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: "691",
  [countryCodes.FAROE_ISLANDS.alphaTwo]: "298",
  [countryCodes.NICARAGUA.alphaTwo]: "505",
  [countryCodes.NETHERLANDS.alphaTwo]: "31",
  [countryCodes.NORWAY.alphaTwo]: "47",
  [countryCodes.NAMIBIA.alphaTwo]: "264",
  [countryCodes.VANUATU.alphaTwo]: "678",
  [countryCodes.NEW_CALEDONIA.alphaTwo]: "687",
  [countryCodes.NIGER.alphaTwo]: "227",
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: "672",
  [countryCodes.NIGERIA.alphaTwo]: "234",
  [countryCodes.NEW_ZEALAND.alphaTwo]: "64",
  [countryCodes.NEPAL.alphaTwo]: "977",
  [countryCodes.NAURU.alphaTwo]: "674",
  [countryCodes.NIUE.alphaTwo]: "683",
  [countryCodes.COOK_ISLANDS.alphaTwo]: "682",
  [countryCodes.KOSOVO.alphaTwo]: "",
  [countryCodes.COTE_DIVOIRE.alphaTwo]: "225",
  [countryCodes.SWITZERLAND.alphaTwo]: "41",
  [countryCodes.COLOMBIA.alphaTwo]: "57",
  [countryCodes.CHINA.alphaTwo]: "86",
  [countryCodes.CAMEROON.alphaTwo]: "237",
  [countryCodes.CHILE.alphaTwo]: "56",
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: "61",
  [countryCodes.CANADA.alphaTwo]: "1",
  [countryCodes.CONGO.alphaTwo]: "242",
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: "236",
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: "243",
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: "420",
  [countryCodes.CYPRUS.alphaTwo]: "357",
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: "61",
  [countryCodes.COSTA_RICA.alphaTwo]: "506",
  [countryCodes.CURACAO.alphaTwo]: "599",
  [countryCodes.CAPE_VERDE.alphaTwo]: "238",
  [countryCodes.CUBA.alphaTwo]: "53",
  [countryCodes.SWAZILAND.alphaTwo]: "268",
  [countryCodes.SYRIA.alphaTwo]: "963",
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: "599",
  [countryCodes.KYRGYZSTAN.alphaTwo]: "996",
  [countryCodes.KENYA.alphaTwo]: "254",
  [countryCodes.SOUTH_SUDAN.alphaTwo]: "211",
  [countryCodes.SURINAME.alphaTwo]: "597",
  [countryCodes.KIRIBATI.alphaTwo]: "686",
  [countryCodes.CAMBODIA.alphaTwo]: "855",
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: "1869",
  [countryCodes.COMOROS.alphaTwo]: "269",
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: "239",
  [countryCodes.SLOVAKIA.alphaTwo]: "421",
  [countryCodes.SOUTH_KOREA.alphaTwo]: "82",
  [countryCodes.SLOVENIA.alphaTwo]: "386",
  [countryCodes.NORTH_KOREA.alphaTwo]: "850",
  [countryCodes.KUWAIT.alphaTwo]: "965",
  [countryCodes.SENEGAL.alphaTwo]: "221",
  [countryCodes.SAN_MARINO.alphaTwo]: "378",
  [countryCodes.SIERRA_LEONE.alphaTwo]: "232",
  [countryCodes.SEYCHELLES.alphaTwo]: "248",
  [countryCodes.KAZAKHSTAN.alphaTwo]: "7",
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: "1345",
  [countryCodes.SINGAPORE.alphaTwo]: "65",
  [countryCodes.SWEDEN.alphaTwo]: "46",
  [countryCodes.SUDAN.alphaTwo]: "249",
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: "1809 and 1829",
  [countryCodes.DOMINICA.alphaTwo]: "1767",
  [countryCodes.DJIBOUTI.alphaTwo]: "253",
  [countryCodes.DENMARK.alphaTwo]: "45",
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: "1284",
  [countryCodes.GERMANY.alphaTwo]: "49",
  [countryCodes.YEMEN.alphaTwo]: "967",
  [countryCodes.ALGERIA.alphaTwo]: "213",
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: "1",
  [countryCodes.URUGUAY.alphaTwo]: "598",
  [countryCodes.MAYOTTE.alphaTwo]: "262",
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: "1",
  [countryCodes.LEBANON.alphaTwo]: "961",
  [countryCodes.SAINT_LUCIA.alphaTwo]: "1758",
  [countryCodes.LAOS.alphaTwo]: "856",
  [countryCodes.TUVALU.alphaTwo]: "688",
  [countryCodes.TAIWAN.alphaTwo]: "886",
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: "1868",
  [countryCodes.TURKEY.alphaTwo]: "90",
  [countryCodes.SRI_LANKA.alphaTwo]: "94",
  [countryCodes.LIECHTENSTEIN.alphaTwo]: "423",
  [countryCodes.LATVIA.alphaTwo]: "371",
  [countryCodes.TONGA.alphaTwo]: "676",
  [countryCodes.LITHUANIA.alphaTwo]: "370",
  [countryCodes.LUXEMBOURG.alphaTwo]: "352",
  [countryCodes.LIBERIA.alphaTwo]: "231",
  [countryCodes.LESOTHO.alphaTwo]: "266",
  [countryCodes.THAILAND.alphaTwo]: "66",
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: "",
  [countryCodes.TOGO.alphaTwo]: "228",
  [countryCodes.CHAD.alphaTwo]: "235",
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: "1649",
  [countryCodes.LIBYA.alphaTwo]: "218",
  [countryCodes.VATICAN.alphaTwo]: "379",
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: "1784",
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: "971",
  [countryCodes.ANDORRA.alphaTwo]: "376",
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: "1268",
  [countryCodes.AFGHANISTAN.alphaTwo]: "93",
  [countryCodes.ANGUILLA.alphaTwo]: "1264",
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: "1340",
  [countryCodes.ICELAND.alphaTwo]: "354",
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: "98",
  [countryCodes.ARMENIA.alphaTwo]: "374",
  [countryCodes.ALBANIA.alphaTwo]: "355",
  [countryCodes.ANGOLA.alphaTwo]: "244",
  [countryCodes.ANTARCTICA.alphaTwo]: "",
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: "1684",
  [countryCodes.ARGENTINA.alphaTwo]: "54",
  [countryCodes.AUSTRALIA.alphaTwo]: "61",
  [countryCodes.AUSTRIA.alphaTwo]: "43",
  [countryCodes.ARUBA.alphaTwo]: "297",
  [countryCodes.INDIA.alphaTwo]: "91",
  [countryCodes.ALAND_ISLANDS.alphaTwo]: "35818",
  [countryCodes.AZERBAIJAN.alphaTwo]: "994",
  [countryCodes.IRELAND.alphaTwo]: "353",
  [countryCodes.INDONESIA.alphaTwo]: "62",
  [countryCodes.UKRAINE.alphaTwo]: "380",
  [countryCodes.QATAR.alphaTwo]: "974",
  [countryCodes.MOZAMBIQUE.alphaTwo]: "258"
});
var countryNames = deepFreeze2({
  [countryCodes.BANGLADESH.alphaTwo]: "Bangladesh",
  [countryCodes.BELGIUM.alphaTwo]: "Belgium",
  [countryCodes.BURKINA_FASO.alphaTwo]: "Burkina Faso",
  [countryCodes.BULGARIA.alphaTwo]: "Bulgaria",
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: "Bosnia and Herzegovina",
  [countryCodes.BARBADOS.alphaTwo]: "Barbados",
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: "Wallis and Futuna",
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: "Saint Barthelemy",
  [countryCodes.BERMUDA.alphaTwo]: "Bermuda",
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: "Brunei",
  [countryCodes.BOLIVIA.alphaTwo]: "Bolivia",
  [countryCodes.BAHRAIN.alphaTwo]: "Bahrain",
  [countryCodes.BURUNDI.alphaTwo]: "Burundi",
  [countryCodes.BENIN.alphaTwo]: "Benin",
  [countryCodes.BHUTAN.alphaTwo]: "Bhutan",
  [countryCodes.JAMAICA.alphaTwo]: "Jamaica",
  [countryCodes.BOUVET_ISLAND.alphaTwo]: "Bouvet Island",
  [countryCodes.BOTSWANA.alphaTwo]: "Botswana",
  [countryCodes.SAMOA.alphaTwo]: "Samoa",
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: "Bonaire, Saint Eustatius and Saba ",
  [countryCodes.BRAZIL.alphaTwo]: "Brazil",
  [countryCodes.BAHAMAS.alphaTwo]: "Bahamas",
  [countryCodes.JERSEY.alphaTwo]: "Jersey",
  [countryCodes.BELARUS.alphaTwo]: "Belarus",
  [countryCodes.BELIZE.alphaTwo]: "Belize",
  [countryCodes.RUSSIA.alphaTwo]: "Russia",
  [countryCodes.RWANDA.alphaTwo]: "Rwanda",
  [countryCodes.SERBIA.alphaTwo]: "Serbia",
  [countryCodes.TIMOR_LESTE.alphaTwo]: "East Timor",
  [countryCodes.REUNION.alphaTwo]: "Reunion",
  [countryCodes.TURKMENISTAN.alphaTwo]: "Turkmenistan",
  [countryCodes.TAJIKISTAN.alphaTwo]: "Tajikistan",
  [countryCodes.ROMANIA.alphaTwo]: "Romania",
  [countryCodes.TOKELAU.alphaTwo]: "Tokelau",
  [countryCodes.GUINEA_BISSAU.alphaTwo]: "Guinea-Bissau",
  [countryCodes.GUAM.alphaTwo]: "Guam",
  [countryCodes.GUATEMALA.alphaTwo]: "Guatemala",
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: "South Georgia and the South Sandwich Islands",
  [countryCodes.GREECE.alphaTwo]: "Greece",
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: "Equatorial Guinea",
  [countryCodes.GUADELOUPE.alphaTwo]: "Guadeloupe",
  [countryCodes.JAPAN.alphaTwo]: "Japan",
  [countryCodes.GUYANA.alphaTwo]: "Guyana",
  [countryCodes.GUERNSEY.alphaTwo]: "Guernsey",
  [countryCodes.FRENCH_GUIANA.alphaTwo]: "French Guiana",
  [countryCodes.GEORGIA.alphaTwo]: "Georgia",
  [countryCodes.GRENADA.alphaTwo]: "Grenada",
  [countryCodes.UNITED_KINGDOM.alphaTwo]: "United Kingdom",
  [countryCodes.GABON.alphaTwo]: "Gabon",
  [countryCodes.EL_SALVADOR.alphaTwo]: "El Salvador",
  [countryCodes.GUINEA.alphaTwo]: "Guinea",
  [countryCodes.GAMBIA.alphaTwo]: "Gambia",
  [countryCodes.GREENLAND.alphaTwo]: "Greenland",
  [countryCodes.GIBRALTAR.alphaTwo]: "Gibraltar",
  [countryCodes.GHANA.alphaTwo]: "Ghana",
  [countryCodes.OMAN.alphaTwo]: "Oman",
  [countryCodes.TUNISIA.alphaTwo]: "Tunisia",
  [countryCodes.JORDAN.alphaTwo]: "Jordan",
  [countryCodes.CROATIA.alphaTwo]: "Croatia",
  [countryCodes.HAITI.alphaTwo]: "Haiti",
  [countryCodes.HUNGARY.alphaTwo]: "Hungary",
  [countryCodes.HONG_KONG.alphaTwo]: "Hong Kong",
  [countryCodes.HONDURAS.alphaTwo]: "Honduras",
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: "Heard Island and McDonald Islands",
  [countryCodes.VENEZUELA.alphaTwo]: "Venezuela",
  [countryCodes.PUERTO_RICO.alphaTwo]: "Puerto Rico",
  [countryCodes.PALESTINE.alphaTwo]: "Palestinian Territory",
  [countryCodes.PALAU.alphaTwo]: "Palau",
  [countryCodes.PORTUGAL.alphaTwo]: "Portugal",
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: "Svalbard and Jan Mayen",
  [countryCodes.PARAGUAY.alphaTwo]: "Paraguay",
  [countryCodes.IRAQ.alphaTwo]: "Iraq",
  [countryCodes.PANAMA.alphaTwo]: "Panama",
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: "French Polynesia",
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: "Papua New Guinea",
  [countryCodes.PERU.alphaTwo]: "Peru",
  [countryCodes.PAKISTAN.alphaTwo]: "Pakistan",
  [countryCodes.PHILIPPINES.alphaTwo]: "Philippines",
  [countryCodes.PITCAIRN.alphaTwo]: "Pitcairn",
  [countryCodes.POLAND.alphaTwo]: "Poland",
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: "Saint Pierre and Miquelon",
  [countryCodes.ZAMBIA.alphaTwo]: "Zambia",
  [countryCodes.WESTERN_SAHARA.alphaTwo]: "Western Sahara",
  [countryCodes.ESTONIA.alphaTwo]: "Estonia",
  [countryCodes.EGYPT.alphaTwo]: "Egypt",
  [countryCodes.SOUTH_AFRICA.alphaTwo]: "South Africa",
  [countryCodes.ECUADOR.alphaTwo]: "Ecuador",
  [countryCodes.ITALY.alphaTwo]: "Italy",
  [countryCodes.VIETNAM.alphaTwo]: "Vietnam",
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: "Solomon Islands",
  [countryCodes.ETHIOPIA.alphaTwo]: "Ethiopia",
  [countryCodes.SOMALIA.alphaTwo]: "Somalia",
  [countryCodes.ZIMBABWE.alphaTwo]: "Zimbabwe",
  [countryCodes.SAUDI_ARABIA.alphaTwo]: "Saudi Arabia",
  [countryCodes.SPAIN.alphaTwo]: "Spain",
  [countryCodes.ERITREA.alphaTwo]: "Eritrea",
  [countryCodes.MONTENEGRO.alphaTwo]: "Montenegro",
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: "Moldova",
  [countryCodes.MADAGASCAR.alphaTwo]: "Madagascar",
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: "Saint Martin",
  [countryCodes.MOROCCO.alphaTwo]: "Morocco",
  [countryCodes.MONACO.alphaTwo]: "Monaco",
  [countryCodes.UZBEKISTAN.alphaTwo]: "Uzbekistan",
  [countryCodes.MYANMAR.alphaTwo]: "Myanmar",
  [countryCodes.MALI.alphaTwo]: "Mali",
  [countryCodes.MACAU.alphaTwo]: "Macao",
  [countryCodes.MONGOLIA.alphaTwo]: "Mongolia",
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: "Marshall Islands",
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: "Macedonia",
  [countryCodes.MAURITIUS.alphaTwo]: "Mauritius",
  [countryCodes.MALTA.alphaTwo]: "Malta",
  [countryCodes.MALAWI.alphaTwo]: "Malawi",
  [countryCodes.MALDIVES.alphaTwo]: "Maldives",
  [countryCodes.MARTINIQUE.alphaTwo]: "Martinique",
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: "Northern Mariana Islands",
  [countryCodes.MONTSERRAT.alphaTwo]: "Montserrat",
  [countryCodes.MAURITANIA.alphaTwo]: "Mauritania",
  [countryCodes.ISLE_OF_MAN.alphaTwo]: "Isle of Man",
  [countryCodes.UGANDA.alphaTwo]: "Uganda",
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: "Tanzania",
  [countryCodes.MALAYSIA.alphaTwo]: "Malaysia",
  [countryCodes.MEXICO.alphaTwo]: "Mexico",
  [countryCodes.ISRAEL.alphaTwo]: "Israel",
  [countryCodes.FRANCE.alphaTwo]: "France",
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: "British Indian Ocean Territory",
  [countryCodes.SAINT_HELENA.alphaTwo]: "Saint Helena",
  [countryCodes.FINLAND.alphaTwo]: "Finland",
  [countryCodes.FIJI.alphaTwo]: "Fiji",
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: "Falkland Islands",
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: "Micronesia",
  [countryCodes.FAROE_ISLANDS.alphaTwo]: "Faroe Islands",
  [countryCodes.NICARAGUA.alphaTwo]: "Nicaragua",
  [countryCodes.NETHERLANDS.alphaTwo]: "Netherlands",
  [countryCodes.NORWAY.alphaTwo]: "Norway",
  [countryCodes.NAMIBIA.alphaTwo]: "Namibia",
  [countryCodes.VANUATU.alphaTwo]: "Vanuatu",
  [countryCodes.NEW_CALEDONIA.alphaTwo]: "New Caledonia",
  [countryCodes.NIGER.alphaTwo]: "Niger",
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: "Norfolk Island",
  [countryCodes.NIGERIA.alphaTwo]: "Nigeria",
  [countryCodes.NEW_ZEALAND.alphaTwo]: "New Zealand",
  [countryCodes.NEPAL.alphaTwo]: "Nepal",
  [countryCodes.NAURU.alphaTwo]: "Nauru",
  [countryCodes.NIUE.alphaTwo]: "Niue",
  [countryCodes.COOK_ISLANDS.alphaTwo]: "Cook Islands",
  [countryCodes.KOSOVO.alphaTwo]: "Kosovo",
  [countryCodes.COTE_DIVOIRE.alphaTwo]: "Ivory Coast",
  [countryCodes.SWITZERLAND.alphaTwo]: "Switzerland",
  [countryCodes.COLOMBIA.alphaTwo]: "Colombia",
  [countryCodes.CHINA.alphaTwo]: "China",
  [countryCodes.CAMEROON.alphaTwo]: "Cameroon",
  [countryCodes.CHILE.alphaTwo]: "Chile",
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: "Cocos Islands",
  [countryCodes.CANADA.alphaTwo]: "Canada",
  [countryCodes.CONGO.alphaTwo]: "Republic of the Congo",
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: "Central African Republic",
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: "Democratic Republic of the Congo",
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: "Czech Republic",
  [countryCodes.CYPRUS.alphaTwo]: "Cyprus",
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: "Christmas Island",
  [countryCodes.COSTA_RICA.alphaTwo]: "Costa Rica",
  [countryCodes.CURACAO.alphaTwo]: "Curacao",
  [countryCodes.CAPE_VERDE.alphaTwo]: "Cape Verde",
  [countryCodes.CUBA.alphaTwo]: "Cuba",
  [countryCodes.SWAZILAND.alphaTwo]: "Swaziland",
  [countryCodes.SYRIA.alphaTwo]: "Syria",
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: "Sint Maarten",
  [countryCodes.KYRGYZSTAN.alphaTwo]: "Kyrgyzstan",
  [countryCodes.KENYA.alphaTwo]: "Kenya",
  [countryCodes.SOUTH_SUDAN.alphaTwo]: "South Sudan",
  [countryCodes.SURINAME.alphaTwo]: "Suriname",
  [countryCodes.KIRIBATI.alphaTwo]: "Kiribati",
  [countryCodes.CAMBODIA.alphaTwo]: "Cambodia",
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: "Saint Kitts and Nevis",
  [countryCodes.COMOROS.alphaTwo]: "Comoros",
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: "Sao Tome and Principe",
  [countryCodes.SLOVAKIA.alphaTwo]: "Slovakia",
  [countryCodes.SOUTH_KOREA.alphaTwo]: "South Korea",
  [countryCodes.SLOVENIA.alphaTwo]: "Slovenia",
  [countryCodes.NORTH_KOREA.alphaTwo]: "North Korea",
  [countryCodes.KUWAIT.alphaTwo]: "Kuwait",
  [countryCodes.SENEGAL.alphaTwo]: "Senegal",
  [countryCodes.SAN_MARINO.alphaTwo]: "San Marino",
  [countryCodes.SIERRA_LEONE.alphaTwo]: "Sierra Leone",
  [countryCodes.SEYCHELLES.alphaTwo]: "Seychelles",
  [countryCodes.KAZAKHSTAN.alphaTwo]: "Kazakhstan",
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: "Cayman Islands",
  [countryCodes.SINGAPORE.alphaTwo]: "Singapore",
  [countryCodes.SWEDEN.alphaTwo]: "Sweden",
  [countryCodes.SUDAN.alphaTwo]: "Sudan",
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: "Dominican Republic",
  [countryCodes.DOMINICA.alphaTwo]: "Dominica",
  [countryCodes.DJIBOUTI.alphaTwo]: "Djibouti",
  [countryCodes.DENMARK.alphaTwo]: "Denmark",
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: "British Virgin Islands",
  [countryCodes.GERMANY.alphaTwo]: "Germany",
  [countryCodes.YEMEN.alphaTwo]: "Yemen",
  [countryCodes.ALGERIA.alphaTwo]: "Algeria",
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: "United States",
  [countryCodes.URUGUAY.alphaTwo]: "Uruguay",
  [countryCodes.MAYOTTE.alphaTwo]: "Mayotte",
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: "United States Minor Outlying Islands",
  [countryCodes.LEBANON.alphaTwo]: "Lebanon",
  [countryCodes.SAINT_LUCIA.alphaTwo]: "Saint Lucia",
  [countryCodes.LAOS.alphaTwo]: "Laos",
  [countryCodes.TUVALU.alphaTwo]: "Tuvalu",
  [countryCodes.TAIWAN.alphaTwo]: "Taiwan",
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: "Trinidad and Tobago",
  [countryCodes.TURKEY.alphaTwo]: "Turkey",
  [countryCodes.SRI_LANKA.alphaTwo]: "Sri Lanka",
  [countryCodes.LIECHTENSTEIN.alphaTwo]: "Liechtenstein",
  [countryCodes.LATVIA.alphaTwo]: "Latvia",
  [countryCodes.TONGA.alphaTwo]: "Tonga",
  [countryCodes.LITHUANIA.alphaTwo]: "Lithuania",
  [countryCodes.LUXEMBOURG.alphaTwo]: "Luxembourg",
  [countryCodes.LIBERIA.alphaTwo]: "Liberia",
  [countryCodes.LESOTHO.alphaTwo]: "Lesotho",
  [countryCodes.THAILAND.alphaTwo]: "Thailand",
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: "French Southern Territories",
  [countryCodes.TOGO.alphaTwo]: "Togo",
  [countryCodes.CHAD.alphaTwo]: "Chad",
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: "Turks and Caicos Islands",
  [countryCodes.LIBYA.alphaTwo]: "Libya",
  [countryCodes.VATICAN.alphaTwo]: "Vatican",
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: "Saint Vincent and the Grenadines",
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: "United Arab Emirates",
  [countryCodes.ANDORRA.alphaTwo]: "Andorra",
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: "Antigua and Barbuda",
  [countryCodes.AFGHANISTAN.alphaTwo]: "Afghanistan",
  [countryCodes.ANGUILLA.alphaTwo]: "Anguilla",
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: "U.S. Virgin Islands",
  [countryCodes.ICELAND.alphaTwo]: "Iceland",
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: "Iran",
  [countryCodes.ARMENIA.alphaTwo]: "Armenia",
  [countryCodes.ALBANIA.alphaTwo]: "Albania",
  [countryCodes.ANGOLA.alphaTwo]: "Angola",
  [countryCodes.ANTARCTICA.alphaTwo]: "Antarctica",
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: "American Samoa",
  [countryCodes.ARGENTINA.alphaTwo]: "Argentina",
  [countryCodes.AUSTRALIA.alphaTwo]: "Australia",
  [countryCodes.AUSTRIA.alphaTwo]: "Austria",
  [countryCodes.ARUBA.alphaTwo]: "Aruba",
  [countryCodes.INDIA.alphaTwo]: "India",
  [countryCodes.ALAND_ISLANDS.alphaTwo]: "Aland Islands",
  [countryCodes.AZERBAIJAN.alphaTwo]: "Azerbaijan",
  [countryCodes.IRELAND.alphaTwo]: "Ireland",
  [countryCodes.INDONESIA.alphaTwo]: "Indonesia",
  [countryCodes.UKRAINE.alphaTwo]: "Ukraine",
  [countryCodes.QATAR.alphaTwo]: "Qatar",
  [countryCodes.MOZAMBIQUE.alphaTwo]: "Mozambique"
});

// src/countries/subdivisions.ts
var subdivisions = {
  [countryCodes.ANDORRA.alphaTwo]: {
    subdivisions: [
      { name: "Andorra la Vella", code: "AD-07" },
      { name: "Canillo", code: "AD-02" },
      { name: "Encamp", code: "AD-03" },
      { name: "Escaldes-Engordany", code: "AD-08" },
      { name: "La Massana", code: "AD-04" },
      { name: "Ordino", code: "AD-05" },
      { name: "Sant Julia de Loria", code: "AD-06" }
    ]
  },
  [countryCodes.UNITED_ARAB_EMIRATES.alphaTwo]: {
    subdivisions: [
      { name: "Ajman", code: "AE-AJ" },
      { name: "Abu Zaby", code: "AE-AZ" },
      { name: "Al Fujayrah", code: "AE-FU" },
      { name: "Ash Shariqah", code: "AE-SH" },
      { name: "Dubayy", code: "AE-DU" },
      { name: "Ra's al Khaymah", code: "AE-RK" },
      { name: "Umm al Qaywayn", code: "AE-UQ" }
    ]
  },
  [countryCodes.AFGHANISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Badakhshan", code: "AF-BDS" },
      { name: "Badghis", code: "AF-BDG" },
      { name: "Baghlan", code: "AF-BGL" },
      { name: "Balkh", code: "AF-BAL" },
      { name: "Bamyan", code: "AF-BAM" },
      { name: "Daykundi", code: "AF-DAY" },
      { name: "Farah", code: "AF-FRA" },
      { name: "Faryab", code: "AF-FYB" },
      { name: "Ghazni", code: "AF-GHA" },
      { name: "Helmand", code: "AF-HEL" },
      { name: "Herat", code: "AF-HER" },
      { name: "Jowzjan", code: "AF-JOW" },
      { name: "Kabul", code: "AF-KAB" },
      { name: "Kandahar", code: "AF-KAN" },
      { name: "Khost", code: "AF-KHO" },
      { name: "Kunar", code: "AF-KNR" },
      { name: "Kunduz", code: "AF-KDZ" },
      { name: "Logar", code: "AF-LOG" },
      { name: "Nangarhar", code: "AF-NAN" },
      { name: "Nimroz", code: "AF-NIM" },
      { name: "Paktika", code: "AF-PKA" },
      { name: "Paktiya", code: "AF-PIA" },
      { name: "Panjshayr", code: "AF-PAN" },
      { name: "Parwan", code: "AF-PAR" },
      { name: "Samangan", code: "AF-SAM" },
      { name: "Sar-e Pul", code: "AF-SAR" },
      { name: "Takhar", code: "AF-TAK" },
      { name: "Uruzgan", code: "AF-URU" },
      { name: "Ghor", code: "AF-GHO" },
      { name: "Kapisa", code: "AF-KAP" },
      { name: "Laghman", code: "AF-LAG" },
      { name: "Nuristan", code: "AF-NUR" },
      { name: "Wardak", code: "AF-WAR" },
      { name: "Zabul", code: "AF-ZAB" }
    ]
  },
  [countryCodes.ANTIGUA_AND_BARBUDA.alphaTwo]: {
    subdivisions: [
      { name: "Barbuda", code: "AG-10" },
      { name: "Redonda", code: "AG-11" },
      { name: "Saint George", code: "AG-03" },
      { name: "Saint John", code: "AG-04" },
      { name: "Saint Mary", code: "AG-05" },
      { name: "Saint Peter", code: "AG-07" },
      { name: "Saint Philip", code: "AG-08" },
      { name: "Saint Paul", code: "AG-06" }
    ]
  },
  [countryCodes.ANGUILLA.alphaTwo]: { subdivisions: [{ name: "Anguilla", code: "-" }] },
  [countryCodes.ALBANIA.alphaTwo]: {
    subdivisions: [
      { name: "Berat", code: "AL-01" },
      { name: "Diber", code: "AL-09" },
      { name: "Durres", code: "AL-02" },
      { name: "Elbasan", code: "AL-03" },
      { name: "Fier", code: "AL-04" },
      { name: "Gjirokaster", code: "AL-05" },
      { name: "Korce", code: "AL-06" },
      { name: "Kukes", code: "AL-07" },
      { name: "Lezhe", code: "AL-08" },
      { name: "Shkoder", code: "AL-10" },
      { name: "Tirane", code: "AL-11" },
      { name: "Vlore", code: "AL-12" }
    ]
  },
  [countryCodes.ARMENIA.alphaTwo]: {
    subdivisions: [
      { name: "Aragacotn", code: "AM-AG" },
      { name: "Ararat", code: "AM-AR" },
      { name: "Armavir", code: "AM-AV" },
      { name: "Erevan", code: "AM-ER" },
      { name: "Gegark'unik'", code: "AM-GR" },
      { name: "Kotayk'", code: "AM-KT" },
      { name: "Lori", code: "AM-LO" },
      { name: "Sirak", code: "AM-SH" },
      { name: "Syunik'", code: "AM-SU" },
      { name: "Tavus", code: "AM-TV" },
      { name: "Vayoc Jor", code: "AM-VD" }
    ]
  },
  [countryCodes.ANGOLA.alphaTwo]: {
    subdivisions: [
      { name: "Bengo", code: "AO-BGO" },
      { name: "Benguela", code: "AO-BGU" },
      { name: "Bie", code: "AO-BIE" },
      { name: "Cabinda", code: "AO-CAB" },
      { name: "Cuando Cubango", code: "AO-CCU" },
      { name: "Cuanza-Norte", code: "AO-CNO" },
      { name: "Cuanza-Sul", code: "AO-CUS" },
      { name: "Cunene", code: "AO-CNN" },
      { name: "Huambo", code: "AO-HUA" },
      { name: "Huila", code: "AO-HUI" },
      { name: "Luanda", code: "AO-LUA" },
      { name: "Lunda-Norte", code: "AO-LNO" },
      { name: "Lunda-Sul", code: "AO-LSU" },
      { name: "Malange", code: "AO-MAL" },
      { name: "Moxico", code: "AO-MOX" },
      { name: "Namibe", code: "AO-NAM" },
      { name: "Uige", code: "AO-UIG" },
      { name: "Zaire", code: "AO-ZAI" }
    ]
  },
  [countryCodes.ANTARCTICA.alphaTwo]: { subdivisions: [{ name: "Antarctica", code: "-" }] },
  [countryCodes.ARGENTINA.alphaTwo]: {
    subdivisions: [
      { name: "Buenos Aires", code: "AR-B" },
      { name: "Catamarca", code: "AR-K" },
      { name: "Chaco", code: "AR-H" },
      { name: "Chubut", code: "AR-U" },
      { name: "Ciudad Autonoma de Buenos Aires", code: "AR-C" },
      { name: "Cordoba", code: "AR-X" },
      { name: "Corrientes", code: "AR-W" },
      { name: "Entre Rios", code: "AR-E" },
      { name: "Formosa", code: "AR-P" },
      { name: "Jujuy", code: "AR-Y" },
      { name: "La Pampa", code: "AR-L" },
      { name: "La Rioja", code: "AR-F" },
      { name: "Mendoza", code: "AR-M" },
      { name: "Misiones", code: "AR-N" },
      { name: "Neuquen", code: "AR-Q" },
      { name: "Rio Negro", code: "AR-R" },
      { name: "Salta", code: "AR-A" },
      { name: "San Juan", code: "AR-J" },
      { name: "San Luis", code: "AR-D" },
      { name: "Santa Cruz", code: "AR-Z" },
      { name: "Santa Fe", code: "AR-S" },
      { name: "Santiago del Estero", code: "AR-G" },
      { name: "Tierra del Fuego", code: "AR-V" },
      { name: "Tucuman", code: "AR-T" }
    ]
  },
  [countryCodes.AMERICAN_SAMOA.alphaTwo]: {
    subdivisions: [
      { name: "Eastern District", code: "-" },
      { name: "Western District", code: "-" }
    ]
  },
  [countryCodes.AUSTRIA.alphaTwo]: {
    subdivisions: [
      { name: "Burgenland", code: "AT-1" },
      { name: "Karnten", code: "AT-2" },
      { name: "Niederosterreich", code: "AT-3" },
      { name: "Oberosterreich", code: "AT-4" },
      { name: "Salzburg", code: "AT-5" },
      { name: "Steiermark", code: "AT-6" },
      { name: "Tirol", code: "AT-7" },
      { name: "Vorarlberg", code: "AT-8" },
      { name: "Wien", code: "AT-9" }
    ]
  },
  [countryCodes.AUSTRALIA.alphaTwo]: {
    subdivisions: [
      { name: "Australian Capital Territory", code: "AU-ACT" },
      { name: "New South Wales", code: "AU-NSW" },
      { name: "Northern Territory", code: "AU-NT" },
      { name: "Queensland", code: "AU-QLD" },
      { name: "South Australia", code: "AU-SA" },
      { name: "Tasmania", code: "AU-TAS" },
      { name: "Victoria", code: "AU-VIC" },
      { name: "Western Australia", code: "AU-WA" }
    ]
  },
  [countryCodes.ARUBA.alphaTwo]: { subdivisions: [{ name: "Aruba", code: "-" }] },
  [countryCodes.ALAND_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Eckeroe", code: "-" },
      { name: "Finstroem", code: "-" },
      { name: "Hammarland", code: "-" },
      { name: "Jomala", code: "-" },
      { name: "Lemland", code: "-" },
      { name: "Mariehamn", code: "-" },
      { name: "Saltvik", code: "-" }
    ]
  },
  [countryCodes.AZERBAIJAN.alphaTwo]: {
    subdivisions: [
      { name: "Abseron", code: "AZ-ABS" },
      { name: "Agcabadi", code: "AZ-AGC" },
      { name: "Agdas", code: "AZ-AGS" },
      { name: "Agstafa", code: "AZ-AGA" },
      { name: "Agsu", code: "AZ-AGU" },
      { name: "Astara", code: "AZ-AST" },
      { name: "Baki", code: "AZ-BA" },
      { name: "Balakan", code: "AZ-BAL" },
      { name: "Barda", code: "AZ-BAR" },
      { name: "Beylaqan", code: "AZ-BEY" },
      { name: "Calilabad", code: "AZ-CAL" },
      { name: "Ganca", code: "AZ-GA" },
      { name: "Goranboy", code: "AZ-GOR" },
      { name: "Goycay", code: "AZ-GOY" },
      { name: "Goygol", code: "AZ-GYG" },
      { name: "Haciqabul", code: "AZ-HAC" },
      { name: "Imisli", code: "AZ-IMI" },
      { name: "Kalbacar", code: "AZ-KAL" },
      { name: "Kurdamir", code: "AZ-KUR" },
      { name: "Lankaran", code: "AZ-LA" },
      { name: "Lerik", code: "AZ-LER" },
      { name: "Masalli", code: "AZ-MAS" },
      { name: "Mingacevir", code: "AZ-MI" },
      { name: "Naftalan", code: "AZ-NA" },
      { name: "Naxcivan", code: "AZ-NX" },
      { name: "Oguz", code: "AZ-OGU" },
      { name: "Qabala", code: "AZ-QAB" },
      { name: "Qazax", code: "AZ-QAZ" },
      { name: "Quba", code: "AZ-QBA" },
      { name: "Qusar", code: "AZ-QUS" },
      { name: "Sabirabad", code: "AZ-SAB" },
      { name: "Saki", code: "AZ-SAK" },
      { name: "Salyan", code: "AZ-SAL" },
      { name: "Samaxi", code: "AZ-SMI" },
      { name: "Samkir", code: "AZ-SKR" },
      { name: "Samux", code: "AZ-SMX" },
      { name: "Sirvan", code: "AZ-SR" },
      { name: "Siyazan", code: "AZ-SIY" },
      { name: "Sumqayit", code: "AZ-SM" },
      { name: "Tartar", code: "AZ-TAR" },
      { name: "Tovuz", code: "AZ-TOV" },
      { name: "Ucar", code: "AZ-UCA" },
      { name: "Xacmaz", code: "AZ-XAC" },
      { name: "Xizi", code: "AZ-XIZ" },
      { name: "Yardimli", code: "AZ-YAR" },
      { name: "Yevlax", code: "AZ-YEV" },
      { name: "Zaqatala", code: "AZ-ZAQ" },
      { name: "Zardab", code: "AZ-ZARD" },
      { name: "Agdam", code: "AZ-AGM" },
      { name: "Bilasuvar", code: "AZ-BIL" },
      { name: "Cabrayil", code: "AZ-CAB" },
      { name: "Dashkasan", code: "AZ-DAS" },
      { name: "Fuzuli", code: "AZ-FUZ" },
      { name: "Gadabay", code: "AZ-GAD" },
      { name: "Ismayilli", code: "AZ-ISM" },
      { name: "Lacin", code: "AZ-LAC" },
      { name: "Neftcala", code: "AZ-NEF" },
      { name: "Qax", code: "AZ-QAX" },
      { name: "Qubadli", code: "AZ-QBI" },
      { name: "Qobustan", code: "AZ-QOB" },
      { name: "Sahbuz", code: "AZ-SAH" },
      { name: "Saatli", code: "AZ-SAT" },
      { name: "Sabran", code: "AZ-SBN" },
      { name: "Susa", code: "AZ-SUS" },
      { name: "Xocali", code: "AZ-XCI" },
      { name: "Xocavand", code: "AZ-XVD" },
      { name: "Z@ngilan", code: "AZ-ZAN" }
    ]
  },
  [countryCodes.BOSNIA_AND_HERZEGOVINA.alphaTwo]: {
    subdivisions: [
      { name: "Brcko distrikt", code: "BA-BRC" },
      { name: "Federacija Bosne i Hercegovine", code: "BA-BIH" },
      { name: "Republika Srpska", code: "BA-SRP" }
    ]
  },
  [countryCodes.BARBADOS.alphaTwo]: {
    subdivisions: [
      { name: "Christ Church", code: "BB-01" },
      { name: "Saint Andrew", code: "BB-02" },
      { name: "Saint George", code: "BB-03" },
      { name: "Saint James", code: "BB-04" },
      { name: "Saint John", code: "BB-05" },
      { name: "Saint Joseph", code: "BB-06" },
      { name: "Saint Lucy", code: "BB-07" },
      { name: "Saint Michael", code: "BB-08" },
      { name: "Saint Peter", code: "BB-09" },
      { name: "Saint Philip", code: "BB-10" },
      { name: "Saint Thomas", code: "BB-11" }
    ]
  },
  [countryCodes.BANGLADESH.alphaTwo]: {
    subdivisions: [
      { name: "Barishal", code: "BD-A" },
      { name: "Chattogram", code: "BD-B" },
      { name: "Dhaka", code: "BD-C" },
      { name: "Khulna", code: "BD-D" },
      { name: "Rajshahi", code: "BD-E" },
      { name: "Rangpur", code: "BD-F" },
      { name: "Sylhet", code: "BD-G" },
      { name: "Mymensingh", code: "BD-H" }
    ]
  },
  [countryCodes.BELGIUM.alphaTwo]: {
    subdivisions: [
      { name: "Antwerpen", code: "BE-VAN" },
      { name: "Brabant wallon", code: "BE-WBR" },
      { name: "Brussels Hoofdstedelijk Gewest", code: "BE-BRU" },
      { name: "Hainaut", code: "BE-WHT" },
      { name: "Liege", code: "BE-WLG" },
      { name: "Limburg", code: "BE-VLI" },
      { name: "Luxembourg", code: "BE-WLX" },
      { name: "Namur", code: "BE-WNA" },
      { name: "Oost-Vlaanderen", code: "BE-VOV" },
      { name: "Vlaams-Brabant", code: "BE-VBR" },
      { name: "West-Vlaanderen", code: "BE-VWV" }
    ]
  },
  [countryCodes.BURKINA_FASO.alphaTwo]: {
    subdivisions: [
      { name: "Bale", code: "BF-BAL" },
      { name: "Bam", code: "BF-BAM" },
      { name: "Bazega", code: "BF-BAZ" },
      { name: "Boulgou", code: "BF-BLG" },
      { name: "Boulkiemde", code: "BF-BLK" },
      { name: "Comoe", code: "BF-COM" },
      { name: "Ganzourgou", code: "BF-GAN" },
      { name: "Gnagna", code: "BF-GNA" },
      { name: "Gourma", code: "BF-GOU" },
      { name: "Houet", code: "BF-HOU" },
      { name: "Kadiogo", code: "BF-KAD" },
      { name: "Kenedougou", code: "BF-KEN" },
      { name: "Kossi", code: "BF-KOS" },
      { name: "Kouritenga", code: "BF-KOT" },
      { name: "Kourweogo", code: "BF-KOW" },
      { name: "Leraba", code: "BF-LER" },
      { name: "Loroum", code: "BF-LOR" },
      { name: "Mouhoun", code: "BF-MOU" },
      { name: "Nahouri", code: "BF-NAO" },
      { name: "Namentenga", code: "BF-NAM" },
      { name: "Nayala", code: "BF-NAY" },
      { name: "Oubritenga", code: "BF-OUB" },
      { name: "Oudalan", code: "BF-OUD" },
      { name: "Passore", code: "BF-PAS" },
      { name: "Poni", code: "BF-PON" },
      { name: "Sanmatenga", code: "BF-SMT" },
      { name: "Seno", code: "BF-SEN" },
      { name: "Sissili", code: "BF-SIS" },
      { name: "Soum", code: "BF-SOM" },
      { name: "Tapoa", code: "BF-TAP" },
      { name: "Tuy", code: "BF-TUI" },
      { name: "Yatenga", code: "BF-YAT" },
      { name: "Ziro", code: "BF-ZIR" },
      { name: "Zondoma", code: "BF-ZON" },
      { name: "Zoundweogo", code: "BF-ZOU" },
      { name: "Banwa", code: "BF-BAN" },
      { name: "Bougouriba", code: "BF-BGR" },
      { name: "Ioba", code: "BF-IOB" },
      { name: "Komondjari", code: "BF-KMD" },
      { name: "Kompienga", code: "BF-KMP" },
      { name: "Koulpelogo", code: "BF-KOP" },
      { name: "Noumbiel", code: "BF-NOU" },
      { name: "Sanguie", code: "BF-SNG" },
      { name: "Sourou", code: "BF-SOR" },
      { name: "Yagha", code: "BF-YAG" }
    ]
  },
  [countryCodes.BULGARIA.alphaTwo]: {
    subdivisions: [
      { name: "Blagoevgrad", code: "BG-01" },
      { name: "Burgas", code: "BG-02" },
      { name: "Dobrich", code: "BG-08" },
      { name: "Gabrovo", code: "BG-07" },
      { name: "Haskovo", code: "BG-26" },
      { name: "Kardzhali", code: "BG-09" },
      { name: "Kyustendil", code: "BG-10" },
      { name: "Lovech", code: "BG-11" },
      { name: "Montana", code: "BG-12" },
      { name: "Pazardzhik", code: "BG-13" },
      { name: "Pernik", code: "BG-14" },
      { name: "Pleven", code: "BG-15" },
      { name: "Plovdiv", code: "BG-16" },
      { name: "Razgrad", code: "BG-17" },
      { name: "Ruse", code: "BG-18" },
      { name: "Shumen", code: "BG-27" },
      { name: "Silistra", code: "BG-19" },
      { name: "Sliven", code: "BG-20" },
      { name: "Smolyan", code: "BG-21" },
      { name: "Sofia", code: "BG-23" },
      { name: "Sofia (stolitsa)", code: "BG-22" },
      { name: "Stara Zagora", code: "BG-24" },
      { name: "Targovishte", code: "BG-25" },
      { name: "Varna", code: "BG-03" },
      { name: "Veliko Tarnovo", code: "BG-04" },
      { name: "Vidin", code: "BG-05" },
      { name: "Vratsa", code: "BG-06" },
      { name: "Yambol", code: "BG-28" }
    ]
  },
  [countryCodes.BAHRAIN.alphaTwo]: {
    subdivisions: [
      { name: "Al 'Asimah", code: "BH-13" },
      { name: "Al Janubiyah", code: "BH-14" },
      { name: "Al Muharraq", code: "BH-15" },
      { name: "Ash Shamaliyah", code: "BH-17" }
    ]
  },
  [countryCodes.BURUNDI.alphaTwo]: {
    subdivisions: [
      { name: "Bujumbura Mairie", code: "BI-BM" },
      { name: "Bururi", code: "BI-BR" },
      { name: "Cibitoke", code: "BI-CI" },
      { name: "Gitega", code: "BI-GI" },
      { name: "Karuzi", code: "BI-KR" },
      { name: "Kayanza", code: "BI-KY" },
      { name: "Kirundo", code: "BI-KI" },
      { name: "Makamba", code: "BI-MA" },
      { name: "Mwaro", code: "BI-MW" },
      { name: "Ngozi", code: "BI-NG" },
      { name: "Rumonge", code: "BI-RM" },
      { name: "Rutana", code: "BI-RT" },
      { name: "Ruyigi", code: "BI-RY" },
      { name: "Bubanza", code: "BI-BB" },
      { name: "Bujumbura Rural", code: "BI-BL" },
      { name: "Cankuzo", code: "BI-CA" },
      { name: "Muramvya", code: "BI-MU" },
      { name: "Muyinga", code: "BI-MY" }
    ]
  },
  [countryCodes.BENIN.alphaTwo]: {
    subdivisions: [
      { name: "Atacora", code: "BJ-AK" },
      { name: "Atlantique", code: "BJ-AQ" },
      { name: "Borgou", code: "BJ-BO" },
      { name: "Collines", code: "BJ-CO" },
      { name: "Donga", code: "BJ-DO" },
      { name: "Littoral", code: "BJ-LI" },
      { name: "Oueme", code: "BJ-OU" },
      { name: "Plateau", code: "BJ-PL" },
      { name: "Zou", code: "BJ-ZO" },
      { name: "Alibori", code: "BJ-AL" },
      { name: "Couffo", code: "BJ-KO" },
      { name: "Mono", code: "BJ-MO" }
    ]
  },
  [countryCodes.SAINT_BARTHELEMY.alphaTwo]: { subdivisions: [{ name: "Saint Barthelemy", code: "-" }] },
  [countryCodes.BERMUDA.alphaTwo]: {
    subdivisions: [
      { name: "Hamilton", code: "-" },
      { name: "Saint George", code: "-" }
    ]
  },
  [countryCodes.BRUNEI_DARUSSALAM.alphaTwo]: {
    subdivisions: [
      { name: "Belait", code: "BN-BE" },
      { name: "Brunei-Muara", code: "BN-BM" },
      { name: "Temburong", code: "BN-TE" },
      { name: "Tutong", code: "BN-TU" }
    ]
  },
  [countryCodes.BOLIVIA.alphaTwo]: {
    subdivisions: [
      { name: "Chuquisaca", code: "BO-H" },
      { name: "Cochabamba", code: "BO-C" },
      { name: "El Beni", code: "BO-B" },
      { name: "La Paz", code: "BO-L" },
      { name: "Oruro", code: "BO-O" },
      { name: "Pando", code: "BO-N" },
      { name: "Potosi", code: "BO-P" },
      { name: "Santa Cruz", code: "BO-S" },
      { name: "Tarija", code: "BO-T" }
    ]
  },
  [countryCodes.BONAIRE_SINT_EUSTATIUS_AND_SABA.alphaTwo]: {
    subdivisions: [
      { name: "Bonaire", code: "BQ-BO" },
      { name: "Saba", code: "BQ-SA" },
      { name: "Sint Eustatius", code: "BQ-SE" }
    ]
  },
  [countryCodes.BRAZIL.alphaTwo]: {
    subdivisions: [
      { name: "Acre", code: "BR-AC" },
      { name: "Alagoas", code: "BR-AL" },
      { name: "Amapa", code: "BR-AP" },
      { name: "Amazonas", code: "BR-AM" },
      { name: "Bahia", code: "BR-BA" },
      { name: "Ceara", code: "BR-CE" },
      { name: "Distrito Federal", code: "BR-DF" },
      { name: "Espirito Santo", code: "BR-ES" },
      { name: "Goias", code: "BR-GO" },
      { name: "Maranhao", code: "BR-MA" },
      { name: "Mato Grosso", code: "BR-MT" },
      { name: "Mato Grosso do Sul", code: "BR-MS" },
      { name: "Minas Gerais", code: "BR-MG" },
      { name: "Para", code: "BR-PA" },
      { name: "Paraiba", code: "BR-PB" },
      { name: "Parana", code: "BR-PR" },
      { name: "Pernambuco", code: "BR-PE" },
      { name: "Piaui", code: "BR-PI" },
      { name: "Rio Grande do Norte", code: "BR-RN" },
      { name: "Rio Grande do Sul", code: "BR-RS" },
      { name: "Rio de Janeiro", code: "BR-RJ" },
      { name: "Rondonia", code: "BR-RO" },
      { name: "Roraima", code: "BR-RR" },
      { name: "Santa Catarina", code: "BR-SC" },
      { name: "Sao Paulo", code: "BR-SP" },
      { name: "Sergipe", code: "BR-SE" },
      { name: "Tocantins", code: "BR-TO" }
    ]
  },
  [countryCodes.BAHAMAS.alphaTwo]: {
    subdivisions: [
      { name: "Black Point", code: "BS-BP" },
      { name: "Central Abaco", code: "BS-CO" },
      { name: "City of Freeport", code: "BS-FP" },
      { name: "East Grand Bahama", code: "BS-EG" },
      { name: "Harbour Island", code: "BS-HI" },
      { name: "Moore's Island", code: "BS-MI" },
      { name: "New Providence", code: "BS-NP" },
      { name: "North Andros", code: "BS-NS" },
      { name: "North Eleuthera", code: "BS-NE" },
      { name: "San Salvador", code: "BS-SS" },
      { name: "South Eleuthera", code: "BS-SE" },
      { name: "West Grand Bahama", code: "BS-WG" },
      { name: "Acklins", code: "BS-AK" },
      { name: "Bimini", code: "BS-BI" },
      { name: "Berry Islands", code: "BS-BY" },
      { name: "Central Eleuthera", code: "BS-CE" },
      { name: "Cat Island", code: "BS-CI" },
      { name: "Crooked Island and Long Cay", code: "BS-CK" },
      { name: "Central Andros", code: "BS-CS" },
      { name: "Exuma", code: "BS-EX" },
      { name: "Grand Cay", code: "BS-GC" },
      { name: "Hope Town", code: "BS-HT" },
      { name: "Inagua", code: "BS-IN" },
      { name: "Long Island", code: "BS-LI" },
      { name: "Mangrove Cay", code: "BS-MC" },
      { name: "Mayaguana", code: "BS-MG" },
      { name: "North Abaco", code: "BS-NO" },
      { name: "Rum Cay", code: "BS-RC" },
      { name: "Ragged Island", code: "BS-RI" },
      { name: "South Andros", code: "BS-SA" },
      { name: "South Abaco", code: "BS-SO" },
      { name: "Spanish Wells", code: "BS-SW" }
    ]
  },
  [countryCodes.BHUTAN.alphaTwo]: {
    subdivisions: [
      { name: "Bumthang", code: "BT-33" },
      { name: "Chhukha", code: "BT-12" },
      { name: "Gasa", code: "BT-GA" },
      { name: "Lhuentse", code: "BT-44" },
      { name: "Monggar", code: "BT-42" },
      { name: "Paro", code: "BT-11" },
      { name: "Pema Gatshel", code: "BT-43" },
      { name: "Punakha", code: "BT-23" },
      { name: "Samdrup Jongkhar", code: "BT-45" },
      { name: "Samtse", code: "BT-14" },
      { name: "Sarpang", code: "BT-31" },
      { name: "Thimphu", code: "BT-15" },
      { name: "Trashigang", code: "BT-41" },
      { name: "Trongsa", code: "BT-32" },
      { name: "Tsirang", code: "BT-21" },
      { name: "Wangdue Phodrang", code: "BT-24" },
      { name: "Haa", code: "BT-13" },
      { name: "Dagana", code: "BT-22" },
      { name: "Zhemgang", code: "BT-34" },
      { name: "Trashi Yangtse", code: "BT-TY" }
    ]
  },
  [countryCodes.BOUVET_ISLAND.alphaTwo]: { subdivisions: [{ name: "Bouvet Island", code: "-" }] },
  [countryCodes.BOTSWANA.alphaTwo]: {
    subdivisions: [
      { name: "Central", code: "BW-CE" },
      { name: "Chobe", code: "BW-CH" },
      { name: "Ghanzi", code: "BW-GH" },
      { name: "Kgalagadi", code: "BW-KG" },
      { name: "Kgatleng", code: "BW-KL" },
      { name: "Kweneng", code: "BW-KW" },
      { name: "North East", code: "BW-NE" },
      { name: "North West", code: "BW-NW" },
      { name: "South East", code: "BW-SE" },
      { name: "Southern", code: "BW-SO" },
      { name: "Francistown", code: "BW-FR" },
      { name: "Gaborone", code: "BW-GA" },
      { name: "Jwaneng", code: "BW-JW" },
      { name: "Lobatse", code: "BW-LO" },
      { name: "Selibe Phikwe", code: "BW-SP" },
      { name: "Sowa Town", code: "BW-ST" }
    ]
  },
  [countryCodes.BELARUS.alphaTwo]: {
    subdivisions: [
      { name: "Brestskaya voblasts'", code: "BY-BR" },
      { name: "Homyel'skaya voblasts'", code: "BY-HO" },
      { name: "Horad Minsk", code: "BY-HM" },
      { name: "Hrodzyenskaya voblasts'", code: "BY-HR" },
      { name: "Mahilyowskaya voblasts'", code: "BY-MA" },
      { name: "Minskaya voblasts'", code: "BY-MI" },
      { name: "Vitsyebskaya voblasts'", code: "BY-VI" }
    ]
  },
  [countryCodes.BELIZE.alphaTwo]: {
    subdivisions: [
      { name: "Belize", code: "BZ-BZ" },
      { name: "Cayo", code: "BZ-CY" },
      { name: "Corozal", code: "BZ-CZL" },
      { name: "Orange Walk", code: "BZ-OW" },
      { name: "Stann Creek", code: "BZ-SC" },
      { name: "Toledo", code: "BZ-TOL" }
    ]
  },
  [countryCodes.CANADA.alphaTwo]: {
    subdivisions: [
      { name: "Alberta", code: "CA-AB" },
      { name: "British Columbia", code: "CA-BC" },
      { name: "Manitoba", code: "CA-MB" },
      { name: "New Brunswick", code: "CA-NB" },
      { name: "Newfoundland and Labrador", code: "CA-NL" },
      { name: "Northwest Territories", code: "CA-NT" },
      { name: "Nova Scotia", code: "CA-NS" },
      { name: "Nunavut", code: "CA-NU" },
      { name: "Ontario", code: "CA-ON" },
      { name: "Prince Edward Island", code: "CA-PE" },
      { name: "Quebec", code: "CA-QC" },
      { name: "Saskatchewan", code: "CA-SK" },
      { name: "Yukon", code: "CA-YT" }
    ]
  },
  [countryCodes.COCOS_KEELING_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Cocos (Keeling) Islands", code: "-" }]
  },
  [countryCodes.CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE.alphaTwo]: {
    subdivisions: [
      { name: "Equateur", code: "CD-EQ" },
      { name: "Haut-Katanga", code: "CD-HK" },
      { name: "Haut-Lomami", code: "CD-HL" },
      { name: "Haut-Uele", code: "CD-HU" },
      { name: "Ituri", code: "CD-IT" },
      { name: "Kasai", code: "CD-KS" },
      { name: "Kasai Central", code: "CD-KC" },
      { name: "Kasai Oriental", code: "CD-KE" },
      { name: "Kinshasa", code: "CD-KN" },
      { name: "Lualaba", code: "CD-LU" },
      { name: "Maniema", code: "CD-MA" },
      { name: "Nord-Kivu", code: "CD-NK" },
      { name: "Sankuru", code: "CD-SA" },
      { name: "Sud-Kivu", code: "CD-SK" },
      { name: "Tanganyika", code: "CD-TA" },
      { name: "Tshopo", code: "CD-TO" },
      { name: "Tshuapa", code: "CD-TU" },
      { name: "Kongo Central", code: "CD-BC" },
      { name: "Bas-Uele", code: "CD-BU" },
      { name: "Kwango", code: "CD-KG" },
      { name: "Kwilu", code: "CD-KL" },
      { name: "Lomami", code: "CD-LO" },
      { name: "Mai-Ndombe", code: "CD-MN" },
      { name: "Mongala", code: "CD-MO" },
      { name: "Nord-Ubangi", code: "CD-NU" },
      { name: "Sud-Ubangi", code: "CD-SU" }
    ]
  },
  [countryCodes.CENTRAL_AFRICAN_REPUBLIC.alphaTwo]: {
    subdivisions: [
      { name: "Bamingui-Bangoran", code: "CF-BB" },
      { name: "Bangui", code: "CF-BGF" },
      { name: "Haut-Mbomou", code: "CF-HM" },
      { name: "Haute-Kotto", code: "CF-HK" },
      { name: "Kemo-Gribingui", code: "CF-KG" },
      { name: "Lobaye", code: "CF-LB" },
      { name: "Mambere-Kadei", code: "CF-HS" },
      { name: "Nana-Mambere", code: "CF-NM" },
      { name: "Ouaka", code: "CF-UK" },
      { name: "Ouham", code: "CF-AC" },
      { name: "Vakaga", code: "CF-VK" },
      { name: "Basse-Kotto", code: "CF-BK" },
      { name: "Gribingui", code: "CF-KB" },
      { name: "Mbomou", code: "CF-MB" },
      { name: "Ombella-Mpoko", code: "CF-MP" },
      { name: "Ouham-Pende", code: "CF-OP" },
      { name: "Sangha", code: "CF-SE" }
    ]
  },
  [countryCodes.CONGO.alphaTwo]: {
    subdivisions: [
      { name: "Brazzaville", code: "CG-BZV" },
      { name: "Cuvette", code: "CG-8" },
      { name: "Cuvette-Ouest", code: "CG-15" },
      { name: "Likouala", code: "CG-7" },
      { name: "Niari", code: "CG-9" },
      { name: "Pointe-Noire", code: "CG-16" },
      { name: "Sangha", code: "CG-13" },
      { name: "Bouenza", code: "CG-11" },
      { name: "Pool", code: "CG-12" },
      { name: "Plateaux", code: "CG-14" },
      { name: "Lekoumou", code: "CG-2" },
      { name: "Kouilou", code: "CG-5" }
    ]
  },
  [countryCodes.SWITZERLAND.alphaTwo]: {
    subdivisions: [
      { name: "Aargau", code: "CH-AG" },
      { name: "Appenzell Ausserrhoden", code: "CH-AR" },
      { name: "Appenzell Innerrhoden", code: "CH-AI" },
      { name: "Basel-Landschaft", code: "CH-BL" },
      { name: "Basel-Stadt", code: "CH-BS" },
      { name: "Bern", code: "CH-BE" },
      { name: "Fribourg", code: "CH-FR" },
      { name: "Geneve", code: "CH-GE" },
      { name: "Glarus", code: "CH-GL" },
      { name: "Graubunden", code: "CH-GR" },
      { name: "Jura", code: "CH-JU" },
      { name: "Luzern", code: "CH-LU" },
      { name: "Neuchatel", code: "CH-NE" },
      { name: "Nidwalden", code: "CH-NW" },
      { name: "Obwalden", code: "CH-OW" },
      { name: "Sankt Gallen", code: "CH-SG" },
      { name: "Schaffhausen", code: "CH-SH" },
      { name: "Schwyz", code: "CH-SZ" },
      { name: "Solothurn", code: "CH-SO" },
      { name: "Thurgau", code: "CH-TG" },
      { name: "Ticino", code: "CH-TI" },
      { name: "Uri", code: "CH-UR" },
      { name: "Valais", code: "CH-VS" },
      { name: "Vaud", code: "CH-VD" },
      { name: "Zug", code: "CH-ZG" },
      { name: "Zurich", code: "CH-ZH" }
    ]
  },
  [countryCodes.COTE_DIVOIRE.alphaTwo]: {
    subdivisions: [
      { name: "Abidjan", code: "CI-AB" },
      { name: "Bas-Sassandra", code: "CI-BS" },
      { name: "Comoe", code: "CI-CM" },
      { name: "Denguele", code: "CI-DN" },
      { name: "Goh-Djiboua", code: "CI-GD" },
      { name: "Lacs", code: "CI-LC" },
      { name: "Lagunes", code: "CI-LG" },
      { name: "Montagnes", code: "CI-MG" },
      { name: "Sassandra-Marahoue", code: "CI-SM" },
      { name: "Savanes", code: "CI-SV" },
      { name: "Vallee du Bandama", code: "CI-VB" },
      { name: "Woroba", code: "CI-WR" },
      { name: "Yamoussoukro", code: "CI-YM" },
      { name: "Zanzan", code: "CI-ZZ" }
    ]
  },
  [countryCodes.COOK_ISLANDS.alphaTwo]: { subdivisions: [{ name: "Cook Islands", code: "-" }] },
  [countryCodes.CHILE.alphaTwo]: {
    subdivisions: [
      { name: "Aisen del General Carlos Ibanez del Campo", code: "CL-AI" },
      { name: "Antofagasta", code: "CL-AN" },
      { name: "Arica y Parinacota", code: "CL-AP" },
      { name: "Atacama", code: "CL-AT" },
      { name: "Biobio", code: "CL-BI" },
      { name: "Coquimbo", code: "CL-CO" },
      { name: "La Araucania", code: "CL-AR" },
      { name: "Libertador General Bernardo O'Higgins", code: "CL-LI" },
      { name: "Los Lagos", code: "CL-LL" },
      { name: "Los Rios", code: "CL-LR" },
      { name: "Magallanes", code: "CL-MA" },
      { name: "Maule", code: "CL-ML" },
      { name: "Nuble", code: "CL-NB" },
      { name: "Region Metropolitana de Santiago", code: "CL-RM" },
      { name: "Tarapaca", code: "CL-TA" },
      { name: "Valparaiso", code: "CL-VS" }
    ]
  },
  [countryCodes.CAMEROON.alphaTwo]: {
    subdivisions: [
      { name: "Adamaoua", code: "CM-AD" },
      { name: "Centre", code: "CM-CE" },
      { name: "Est", code: "CM-ES" },
      { name: "Extreme-Nord", code: "CM-EN" },
      { name: "Littoral", code: "CM-LT" },
      { name: "Nord", code: "CM-NO" },
      { name: "Nord-Ouest", code: "CM-NW" },
      { name: "Ouest", code: "CM-OU" },
      { name: "Sud", code: "CM-SU" },
      { name: "Sud-Ouest", code: "CM-SW" }
    ]
  },
  [countryCodes.CHINA.alphaTwo]: {
    subdivisions: [
      { name: "Anhui", code: "CN-AH" },
      { name: "Beijing", code: "CN-BJ" },
      { name: "Chongqing", code: "CN-CQ" },
      { name: "Fujian", code: "CN-FJ" },
      { name: "Gansu", code: "CN-GS" },
      { name: "Guangdong", code: "CN-GD" },
      { name: "Guangxi Zhuangzu", code: "CN-GX" },
      { name: "Guizhou", code: "CN-GZ" },
      { name: "Hainan", code: "CN-HI" },
      { name: "Hebei", code: "CN-HE" },
      { name: "Heilongjiang", code: "CN-HL" },
      { name: "Henan", code: "CN-HA" },
      { name: "Hubei", code: "CN-HB" },
      { name: "Hunan", code: "CN-HN" },
      { name: "Jiangsu", code: "CN-JS" },
      { name: "Jiangxi", code: "CN-JX" },
      { name: "Jilin", code: "CN-JL" },
      { name: "Liaoning", code: "CN-LN" },
      { name: "Nei Mongol", code: "CN-NM" },
      { name: "Ningxia Huizu", code: "CN-NX" },
      { name: "Qinghai", code: "CN-QH" },
      { name: "Shaanxi", code: "CN-SN" },
      { name: "Shandong", code: "CN-SD" },
      { name: "Shanghai", code: "CN-SH" },
      { name: "Shanxi", code: "CN-SX" },
      { name: "Sichuan", code: "CN-SC" },
      { name: "Tianjin", code: "CN-TJ" },
      { name: "Xinjiang Uygur", code: "CN-XJ" },
      { name: "Xizang", code: "CN-XZ" },
      { name: "Yunnan", code: "CN-YN" },
      { name: "Zhejiang", code: "CN-ZJ" }
    ]
  },
  [countryCodes.COLOMBIA.alphaTwo]: {
    subdivisions: [
      { name: "Amazonas", code: "CO-AMA" },
      { name: "Antioquia", code: "CO-ANT" },
      { name: "Arauca", code: "CO-ARA" },
      { name: "Atlantico", code: "CO-ATL" },
      { name: "Bolivar", code: "CO-BOL" },
      { name: "Boyaca", code: "CO-BOY" },
      { name: "Caldas", code: "CO-CAL" },
      { name: "Caqueta", code: "CO-CAQ" },
      { name: "Casanare", code: "CO-CAS" },
      { name: "Cauca", code: "CO-CAU" },
      { name: "Cesar", code: "CO-CES" },
      { name: "Choco", code: "CO-CHO" },
      { name: "Cordoba", code: "CO-COR" },
      { name: "Cundinamarca", code: "CO-CUN" },
      { name: "Distrito Capital de Bogota", code: "CO-DC" },
      { name: "Guainia", code: "CO-GUA" },
      { name: "Guaviare", code: "CO-GUV" },
      { name: "Huila", code: "CO-HUI" },
      { name: "La Guajira", code: "CO-LAG" },
      { name: "Magdalena", code: "CO-MAG" },
      { name: "Meta", code: "CO-MET" },
      { name: "Narino", code: "CO-NAR" },
      { name: "Norte de Santander", code: "CO-NSA" },
      { name: "Putumayo", code: "CO-PUT" },
      { name: "Quindio", code: "CO-QUI" },
      { name: "Risaralda", code: "CO-RIS" },
      { name: "San Andres, Providencia y Santa Catalina", code: "CO-SAP" },
      { name: "Santander", code: "CO-SAN" },
      { name: "Sucre", code: "CO-SUC" },
      { name: "Tolima", code: "CO-TOL" },
      { name: "Valle del Cauca", code: "CO-VAC" },
      { name: "Vaupes", code: "CO-VAU" },
      { name: "Vichada", code: "CO-VID" }
    ]
  },
  [countryCodes.COSTA_RICA.alphaTwo]: {
    subdivisions: [
      { name: "Alajuela", code: "CR-A" },
      { name: "Cartago", code: "CR-C" },
      { name: "Guanacaste", code: "CR-G" },
      { name: "Heredia", code: "CR-H" },
      { name: "Limon", code: "CR-L" },
      { name: "Puntarenas", code: "CR-P" },
      { name: "San Jose", code: "CR-SJ" }
    ]
  },
  [countryCodes.CUBA.alphaTwo]: {
    subdivisions: [
      { name: "Artemisa", code: "CU-15" },
      { name: "Camaguey", code: "CU-09" },
      { name: "Ciego de Avila", code: "CU-08" },
      { name: "Cienfuegos", code: "CU-06" },
      { name: "Granma", code: "CU-12" },
      { name: "Guantanamo", code: "CU-14" },
      { name: "Holguin", code: "CU-11" },
      { name: "Isla de la Juventud", code: "CU-99" },
      { name: "La Habana", code: "CU-03" },
      { name: "Las Tunas", code: "CU-10" },
      { name: "Matanzas", code: "CU-04" },
      { name: "Mayabeque", code: "CU-16" },
      { name: "Pinar del Rio", code: "CU-01" },
      { name: "Sancti Spiritus", code: "CU-07" },
      { name: "Santiago de Cuba", code: "CU-13" },
      { name: "Villa Clara", code: "CU-05" }
    ]
  },
  [countryCodes.CAPE_VERDE.alphaTwo]: {
    subdivisions: [
      { name: "Boa Vista", code: "CV-BV" },
      { name: "Maio", code: "CV-MA" },
      { name: "Porto Novo", code: "CV-PN" },
      { name: "Praia", code: "CV-PR" },
      { name: "Ribeira Grande", code: "CV-RG" },
      { name: "Ribeira Grande de Santiago", code: "CV-RS" },
      { name: "Sal", code: "CV-SL" },
      { name: "Sao Domingos", code: "CV-SD" },
      { name: "Sao Filipe", code: "CV-SF" },
      { name: "Sao Lourenco dos Orgaos", code: "CV-SO" },
      { name: "Sao Miguel", code: "CV-SM" },
      { name: "Sao Salvador do Mundo", code: "CV-SS" },
      { name: "Sao Vicente", code: "CV-SV" },
      { name: "Tarrafal", code: "CV-TA" },
      { name: "Brava", code: "CV-BR" },
      { name: "Santa Catarina", code: "CV-CA" },
      { name: "Santa Catarina do Fogo", code: "CV-CF" },
      { name: "Santa Cruz", code: "CV-CR" },
      { name: "Mosteiros", code: "CV-MO" },
      { name: "Paul", code: "CV-PA" },
      { name: "Ribeira Brava", code: "CV-RB" },
      { name: "Tarrafal de Sao Nicolau", code: "CV-TS" }
    ]
  },
  [countryCodes.CURACAO.alphaTwo]: { subdivisions: [{ name: "Curacao", code: "-" }] },
  [countryCodes.CHRISTMAS_ISLAND.alphaTwo]: { subdivisions: [{ name: "Christmas Island", code: "-" }] },
  [countryCodes.CYPRUS.alphaTwo]: {
    subdivisions: [
      { name: "Ammochostos", code: "CY-04" },
      { name: "Keryneia", code: "CY-06" },
      { name: "Larnaka", code: "CY-03" },
      { name: "Lefkosia", code: "CY-01" },
      { name: "Lemesos", code: "CY-02" },
      { name: "Pafos", code: "CY-05" }
    ]
  },
  [countryCodes.CZECH_REPUBLIC.alphaTwo]: {
    subdivisions: [
      { name: "Jihocesky kraj", code: "CZ-31" },
      { name: "Jihomoravsky kraj", code: "CZ-64" },
      { name: "Karlovarsky kraj", code: "CZ-41" },
      { name: "Kraj Vysocina", code: "CZ-63" },
      { name: "Kralovehradecky kraj", code: "CZ-52" },
      { name: "Liberecky kraj", code: "CZ-51" },
      { name: "Moravskoslezsky kraj", code: "CZ-80" },
      { name: "Olomoucky kraj", code: "CZ-71" },
      { name: "Pardubicky kraj", code: "CZ-53" },
      { name: "Plzensky kraj", code: "CZ-32" },
      { name: "Praha, Hlavni mesto", code: "CZ-10" },
      { name: "Stredocesky kraj", code: "CZ-20" },
      { name: "Ustecky kraj", code: "CZ-42" },
      { name: "Zlinsky kraj", code: "CZ-72" }
    ]
  },
  [countryCodes.GERMANY.alphaTwo]: {
    subdivisions: [
      { name: "Baden-Wurttemberg", code: "DE-BW" },
      { name: "Bayern", code: "DE-BY" },
      { name: "Berlin", code: "DE-BE" },
      { name: "Brandenburg", code: "DE-BB" },
      { name: "Bremen", code: "DE-HB" },
      { name: "Hamburg", code: "DE-HH" },
      { name: "Hessen", code: "DE-HE" },
      { name: "Mecklenburg-Vorpommern", code: "DE-MV" },
      { name: "Niedersachsen", code: "DE-NI" },
      { name: "Nordrhein-Westfalen", code: "DE-NW" },
      { name: "Rheinland-Pfalz", code: "DE-RP" },
      { name: "Saarland", code: "DE-SL" },
      { name: "Sachsen", code: "DE-SN" },
      { name: "Sachsen-Anhalt", code: "DE-ST" },
      { name: "Schleswig-Holstein", code: "DE-SH" },
      { name: "Thuringen", code: "DE-TH" }
    ]
  },
  [countryCodes.DJIBOUTI.alphaTwo]: {
    subdivisions: [
      { name: "Arta", code: "DJ-AR" },
      { name: "Dikhil", code: "DJ-DI" },
      { name: "Djibouti", code: "DJ-DJ" },
      { name: "Ali Sabieh", code: "DJ-AS" },
      { name: "Obock", code: "DJ-OB" },
      { name: "Tadjourah", code: "DJ-TA" }
    ]
  },
  [countryCodes.DENMARK.alphaTwo]: {
    subdivisions: [
      { name: "Hovedstaden", code: "DK-84" },
      { name: "Midtjylland", code: "DK-82" },
      { name: "Nordjylland", code: "DK-81" },
      { name: "Sjaelland", code: "DK-85" },
      { name: "Syddanmark", code: "DK-83" }
    ]
  },
  [countryCodes.DOMINICA.alphaTwo]: {
    subdivisions: [
      { name: "Saint Andrew", code: "DM-02" },
      { name: "Saint George", code: "DM-04" },
      { name: "Saint John", code: "DM-05" },
      { name: "Saint Joseph", code: "DM-06" },
      { name: "Saint Luke", code: "DM-07" },
      { name: "Saint Patrick", code: "DM-09" },
      { name: "Saint Paul", code: "DM-10" },
      { name: "Saint Peter", code: "DM-11" },
      { name: "Saint David", code: "DM-03" },
      { name: "Saint Mark", code: "DM-08" }
    ]
  },
  [countryCodes.DOMINICAN_REPUBLIC.alphaTwo]: {
    subdivisions: [
      { name: "Azua", code: "DO-02" },
      { name: "Baoruco", code: "DO-03" },
      { name: "Barahona", code: "DO-04" },
      { name: "Dajabon", code: "DO-05" },
      { name: "Distrito Nacional (Santo Domingo)", code: "DO-01" },
      { name: "Duarte", code: "DO-06" },
      { name: "El Seibo", code: "DO-08" },
      { name: "Elias Pina", code: "DO-07" },
      { name: "Espaillat", code: "DO-09" },
      { name: "Hato Mayor", code: "DO-30" },
      { name: "Hermanas Mirabal", code: "DO-19" },
      { name: "Independencia", code: "DO-10" },
      { name: "La Altagracia", code: "DO-11" },
      { name: "La Romana", code: "DO-12" },
      { name: "La Vega", code: "DO-13" },
      { name: "Maria Trinidad Sanchez", code: "DO-14" },
      { name: "Monsenor Nouel", code: "DO-28" },
      { name: "Monte Cristi", code: "DO-15" },
      { name: "Monte Plata", code: "DO-29" },
      { name: "Pedernales", code: "DO-16" },
      { name: "Peravia", code: "DO-17" },
      { name: "Puerto Plata", code: "DO-18" },
      { name: "Samana", code: "DO-20" },
      { name: "San Cristobal", code: "DO-21" },
      { name: "San Jose de Ocoa", code: "DO-31" },
      { name: "San Juan", code: "DO-22" },
      { name: "San Pedro de Macoris", code: "DO-23" },
      { name: "Sanchez Ramirez", code: "DO-24" },
      { name: "Santiago", code: "DO-25" },
      { name: "Santiago Rodriguez", code: "DO-26" },
      { name: "Valverde", code: "DO-27" },
      { name: "Santo Domingo", code: "DO-32" }
    ]
  },
  [countryCodes.ALGERIA.alphaTwo]: {
    subdivisions: [
      { name: "Adrar", code: "DZ-01" },
      { name: "Ain Defla", code: "DZ-44" },
      { name: "Ain Temouchent", code: "DZ-46" },
      { name: "Alger", code: "DZ-16" },
      { name: "Annaba", code: "DZ-23" },
      { name: "Batna", code: "DZ-05" },
      { name: "Bechar", code: "DZ-08" },
      { name: "Bejaia", code: "DZ-06" },
      { name: "Biskra", code: "DZ-07" },
      { name: "Blida", code: "DZ-09" },
      { name: "Bordj Bou Arreridj", code: "DZ-34" },
      { name: "Bouira", code: "DZ-10" },
      { name: "Boumerdes", code: "DZ-35" },
      { name: "Chlef", code: "DZ-02" },
      { name: "Constantine", code: "DZ-25" },
      { name: "Djanet", code: "DZ-56" },
      { name: "Djelfa", code: "DZ-17" },
      { name: "El Bayadh", code: "DZ-32" },
      { name: "El Meghaier", code: "DZ-57" },
      { name: "El Oued", code: "DZ-39" },
      { name: "El Tarf", code: "DZ-36" },
      { name: "Ghardaia", code: "DZ-47" },
      { name: "Guelma", code: "DZ-24" },
      { name: "Illizi", code: "DZ-33" },
      { name: "In Salah", code: "DZ-53" },
      { name: "Jijel", code: "DZ-18" },
      { name: "Khenchela", code: "DZ-40" },
      { name: "Laghouat", code: "DZ-03" },
      { name: "M'sila", code: "DZ-28" },
      { name: "Mascara", code: "DZ-29" },
      { name: "Medea", code: "DZ-26" },
      { name: "Mila", code: "DZ-43" },
      { name: "Mostaganem", code: "DZ-27" },
      { name: "Naama", code: "DZ-45" },
      { name: "Oran", code: "DZ-31" },
      { name: "Ouargla", code: "DZ-30" },
      { name: "Ouled Djellal", code: "DZ-51" },
      { name: "Oum el Bouaghi", code: "DZ-04" },
      { name: "Relizane", code: "DZ-48" },
      { name: "Saida", code: "DZ-20" },
      { name: "Setif", code: "DZ-19" },
      { name: "Sidi Bel Abbes", code: "DZ-22" },
      { name: "Skikda", code: "DZ-21" },
      { name: "Souk Ahras", code: "DZ-41" },
      { name: "Tamanrasset", code: "DZ-11" },
      { name: "Tebessa", code: "DZ-12" },
      { name: "Tiaret", code: "DZ-14" },
      { name: "Timimoun", code: "DZ-49" },
      { name: "Tindouf", code: "DZ-37" },
      { name: "Tipaza", code: "DZ-42" },
      { name: "Tissemsilt", code: "DZ-38" },
      { name: "Tizi Ouzou", code: "DZ-15" },
      { name: "Tlemcen", code: "DZ-13" },
      { name: "Touggourt", code: "DZ-55" },
      { name: "Bordj Badji Mokhtar", code: "DZ-50" },
      { name: "Beni Abbes", code: "DZ-52" },
      { name: "In Guezzam", code: "DZ-54" },
      { name: "El Meniaa", code: "DZ-58" }
    ]
  },
  [countryCodes.ECUADOR.alphaTwo]: {
    subdivisions: [
      { name: "Azuay", code: "EC-A" },
      { name: "Bolivar", code: "EC-B" },
      { name: "Canar", code: "EC-F" },
      { name: "Carchi", code: "EC-C" },
      { name: "Chimborazo", code: "EC-H" },
      { name: "Cotopaxi", code: "EC-X" },
      { name: "El Oro", code: "EC-O" },
      { name: "Esmeraldas", code: "EC-E" },
      { name: "Galapagos", code: "EC-W" },
      { name: "Guayas", code: "EC-G" },
      { name: "Imbabura", code: "EC-I" },
      { name: "Loja", code: "EC-L" },
      { name: "Los Rios", code: "EC-R" },
      { name: "Manabi", code: "EC-M" },
      { name: "Morona Santiago", code: "EC-S" },
      { name: "Napo", code: "EC-N" },
      { name: "Orellana", code: "EC-D" },
      { name: "Pastaza", code: "EC-Y" },
      { name: "Pichincha", code: "EC-P" },
      { name: "Santa Elena", code: "EC-SE" },
      { name: "Santo Domingo de los Tsachilas", code: "EC-SD" },
      { name: "Sucumbios", code: "EC-U" },
      { name: "Tungurahua", code: "EC-T" },
      { name: "Zamora Chinchipe", code: "EC-Z" }
    ]
  },
  [countryCodes.ESTONIA.alphaTwo]: {
    subdivisions: [
      { name: "Harjumaa", code: "EE-37" },
      { name: "Hiiumaa", code: "EE-39" },
      { name: "Ida-Virumaa", code: "EE-45" },
      { name: "Jarvamaa", code: "EE-52" },
      { name: "Jogevamaa", code: "EE-50" },
      { name: "Laane-Virumaa", code: "EE-60" },
      { name: "Laanemaa", code: "EE-56" },
      { name: "Parnumaa", code: "EE-68" },
      { name: "Polvamaa", code: "EE-64" },
      { name: "Raplamaa", code: "EE-71" },
      { name: "Saaremaa", code: "EE-74" },
      { name: "Tartumaa", code: "EE-79" },
      { name: "Valgamaa", code: "EE-81" },
      { name: "Viljandimaa", code: "EE-84" },
      { name: "Vorumaa", code: "EE-87" }
    ]
  },
  [countryCodes.EGYPT.alphaTwo]: {
    subdivisions: [
      { name: "Ad Daqahliyah", code: "EG-DK" },
      { name: "Al Bahr al Ahmar", code: "EG-BA" },
      { name: "Al Buhayrah", code: "EG-BH" },
      { name: "Al Fayyum", code: "EG-FYM" },
      { name: "Al Gharbiyah", code: "EG-GH" },
      { name: "Al Iskandariyah", code: "EG-ALX" },
      { name: "Al Isma'iliyah", code: "EG-IS" },
      { name: "Al Jizah", code: "EG-GZ" },
      { name: "Al Minufiyah", code: "EG-MNF" },
      { name: "Al Minya", code: "EG-MN" },
      { name: "Al Qahirah", code: "EG-C" },
      { name: "Al Qalyubiyah", code: "EG-KB" },
      { name: "Al Uqsur", code: "EG-LX" },
      { name: "Al Wadi al Jadid", code: "EG-WAD" },
      { name: "As Suways", code: "EG-SUZ" },
      { name: "Ash Sharqiyah", code: "EG-SHR" },
      { name: "Aswan", code: "EG-ASN" },
      { name: "Asyut", code: "EG-AST" },
      { name: "Bani Suwayf", code: "EG-BNS" },
      { name: "Bur Sa'id", code: "EG-PTS" },
      { name: "Dumyat", code: "EG-DT" },
      { name: "Janub Sina'", code: "EG-JS" },
      { name: "Kafr ash Shaykh", code: "EG-KFS" },
      { name: "Matruh", code: "EG-MT" },
      { name: "Qina", code: "EG-KN" },
      { name: "Shamal Sina'", code: "EG-SIN" },
      { name: "Suhaj", code: "EG-SHG" }
    ]
  },
  [countryCodes.WESTERN_SAHARA.alphaTwo]: { subdivisions: [{ name: "Western Sahara", code: "-" }] },
  [countryCodes.ERITREA.alphaTwo]: {
    subdivisions: [
      { name: "Al Awsat", code: "ER-MA" },
      { name: "Qash-Barkah", code: "ER-GB" },
      { name: "Ansaba", code: "ER-AN" },
      { name: "Debubawi K'eyyih Bahri", code: "ER-DK" },
      { name: "Al Janubi", code: "ER-DU" },
      { name: "Semienawi K'eyyih Bahri", code: "ER-SK" }
    ]
  },
  [countryCodes.SPAIN.alphaTwo]: {
    subdivisions: [
      { name: "Andalucia", code: "ES-AN" },
      { name: "Aragon", code: "ES-AR" },
      { name: "Asturias, Principado de", code: "ES-AS" },
      { name: "Canarias", code: "ES-CN" },
      { name: "Cantabria", code: "ES-CB" },
      { name: "Castilla y Leon", code: "ES-CL" },
      { name: "Castilla-La Mancha", code: "ES-CM" },
      { name: "Catalunya", code: "ES-CT" },
      { name: "Ceuta", code: "ES-CE" },
      { name: "Extremadura", code: "ES-EX" },
      { name: "Galicia", code: "ES-GA" },
      { name: "Illes Balears", code: "ES-IB" },
      { name: "La Rioja", code: "ES-RI" },
      { name: "Madrid, Comunidad de", code: "ES-MD" },
      { name: "Melilla", code: "ES-ML" },
      { name: "Murcia, Region de", code: "ES-MC" },
      { name: "Navarra, Comunidad Foral de", code: "ES-NC" },
      { name: "Pais Vasco", code: "ES-PV" },
      { name: "Valenciana, Comunidad", code: "ES-VC" }
    ]
  },
  [countryCodes.ETHIOPIA.alphaTwo]: {
    subdivisions: [
      { name: "Addis Ababa", code: "ET-AA" },
      { name: "Afar", code: "ET-AF" },
      { name: "Amara", code: "ET-AM" },
      { name: "Benshangul-Gumaz", code: "ET-BE" },
      { name: "Dire Dawa", code: "ET-DD" },
      { name: "Gambela Peoples", code: "ET-GA" },
      { name: "Harari People", code: "ET-HA" },
      { name: "Oromia", code: "ET-OR" },
      { name: "Somali", code: "ET-SO" },
      { name: "Southern Nations, Nationalities and Peoples", code: "ET-SN" },
      { name: "Tigrai", code: "ET-TI" },
      { name: "Sidama", code: "ET-SI" },
      { name: "Southwest Ethiopia Peoples", code: "ET-SW" }
    ]
  },
  [countryCodes.FINLAND.alphaTwo]: {
    subdivisions: [
      { name: "Etela-Karjala", code: "FI-02" },
      { name: "Etela-Pohjanmaa", code: "FI-03" },
      { name: "Etela-Savo", code: "FI-04" },
      { name: "Kainuu", code: "FI-05" },
      { name: "Kanta-Hame", code: "FI-06" },
      { name: "Keski-Pohjanmaa", code: "FI-07" },
      { name: "Keski-Suomi", code: "FI-08" },
      { name: "Kymenlaakso", code: "FI-09" },
      { name: "Lappi", code: "FI-10" },
      { name: "Paijat-Hame", code: "FI-16" },
      { name: "Pirkanmaa", code: "FI-11" },
      { name: "Pohjanmaa", code: "FI-12" },
      { name: "Pohjois-Karjala", code: "FI-13" },
      { name: "Pohjois-Pohjanmaa", code: "FI-14" },
      { name: "Pohjois-Savo", code: "FI-15" },
      { name: "Satakunta", code: "FI-17" },
      { name: "Uusimaa", code: "FI-18" },
      { name: "Varsinais-Suomi", code: "FI-19" },
      { name: "Landskapet Aland", code: "FI-01" }
    ]
  },
  [countryCodes.FIJI.alphaTwo]: {
    subdivisions: [
      { name: "Central", code: "FJ-C" },
      { name: "Eastern", code: "FJ-E" },
      { name: "Rotuma", code: "FJ-R" },
      { name: "Western", code: "FJ-W" },
      { name: "Northern", code: "FJ-N" }
    ]
  },
  [countryCodes.FALKLAND_ISLANDS_MALVINAS.alphaTwo]: {
    subdivisions: [{ name: "Falkland Islands (Malvinas)", code: "-" }]
  },
  [countryCodes.MICRONESIA_FEDERATED_STATES_OF.alphaTwo]: {
    subdivisions: [
      { name: "Chuuk", code: "FM-TRK" },
      { name: "Kosrae", code: "FM-KSA" },
      { name: "Pohnpei", code: "FM-PNI" },
      { name: "Yap", code: "FM-YAP" }
    ]
  },
  [countryCodes.FAROE_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Eysturoy", code: "-" },
      { name: "Nordoyar", code: "-" },
      { name: "Sandoy", code: "-" },
      { name: "Streymoy", code: "-" },
      { name: "Suduroy", code: "-" },
      { name: "Vagar", code: "-" }
    ]
  },
  [countryCodes.FRANCE.alphaTwo]: {
    subdivisions: [
      { name: "Auvergne-Rhone-Alpes", code: "FR-ARA" },
      { name: "Bourgogne-Franche-Comte", code: "FR-BFC" },
      { name: "Bretagne", code: "FR-BRE" },
      { name: "Centre-Val de Loire", code: "FR-CVL" },
      { name: "Corse", code: "FR-20R" },
      { name: "Grand-Est", code: "FR-GES" },
      { name: "Hauts-de-France", code: "FR-HDF" },
      { name: "Ile-de-France", code: "FR-IDF" },
      { name: "Normandie", code: "FR-NOR" },
      { name: "Nouvelle-Aquitaine", code: "FR-NAQ" },
      { name: "Occitanie", code: "FR-OCC" },
      { name: "Pays-de-la-Loire", code: "FR-PDL" },
      { name: "Provence-Alpes-Cote-d'Azur", code: "FR-PAC" }
    ]
  },
  [countryCodes.GABON.alphaTwo]: {
    subdivisions: [
      { name: "Estuaire", code: "GA-1" },
      { name: "Haut-Ogooue", code: "GA-2" },
      { name: "Moyen-Ogooue", code: "GA-3" },
      { name: "Ngounie", code: "GA-4" },
      { name: "Nyanga", code: "GA-5" },
      { name: "Ogooue-Ivindo", code: "GA-6" },
      { name: "Ogooue-Lolo", code: "GA-7" },
      { name: "Ogooue-Maritime", code: "GA-8" },
      { name: "Woleu-Ntem", code: "GA-9" }
    ]
  },
  [countryCodes.UNITED_KINGDOM.alphaTwo]: {
    subdivisions: [
      { name: "England", code: "GB-ENG" },
      { name: "Northern Ireland", code: "GB-NIR" },
      { name: "Scotland", code: "GB-SCT" },
      { name: "Wales", code: "GB-WLS" }
    ]
  },
  [countryCodes.GRENADA.alphaTwo]: {
    subdivisions: [
      { name: "Saint Andrew", code: "GD-01" },
      { name: "Saint David", code: "GD-02" },
      { name: "Saint George", code: "GD-03" },
      { name: "Saint Mark", code: "GD-05" },
      { name: "Saint Patrick", code: "GD-06" },
      { name: "Southern Grenadine Islands", code: "GD-10" },
      { name: "Saint John", code: "GD-04" }
    ]
  },
  [countryCodes.GEORGIA.alphaTwo]: {
    subdivisions: [
      { name: "Abkhazia", code: "GE-AB" },
      { name: "Ajaria", code: "GE-AJ" },
      { name: "Guria", code: "GE-GU" },
      { name: "Imereti", code: "GE-IM" },
      { name: "K'akheti", code: "GE-KA" },
      { name: "Kvemo Kartli", code: "GE-KK" },
      { name: "Mtskheta-Mtianeti", code: "GE-MM" },
      { name: "Rach'a-Lechkhumi-Kvemo Svaneti", code: "GE-RL" },
      { name: "Samegrelo-Zemo Svaneti", code: "GE-SZ" },
      { name: "Samtskhe-Javakheti", code: "GE-SJ" },
      { name: "Shida Kartli", code: "GE-SK" },
      { name: "Tbilisi", code: "GE-TB" }
    ]
  },
  [countryCodes.FRENCH_GUIANA.alphaTwo]: { subdivisions: [{ name: "Guyane", code: "-" }] },
  [countryCodes.GUERNSEY.alphaTwo]: { subdivisions: [{ name: "Guernsey", code: "-" }] },
  [countryCodes.GHANA.alphaTwo]: {
    subdivisions: [
      { name: "Ahafo", code: "GH-AF" },
      { name: "Ashanti", code: "GH-AH" },
      { name: "Bono", code: "GH-BO" },
      { name: "Bono East", code: "GH-BE" },
      { name: "Central", code: "GH-CP" },
      { name: "Eastern", code: "GH-EP" },
      { name: "Greater Accra", code: "GH-AA" },
      { name: "Northern", code: "GH-NP" },
      { name: "Upper East", code: "GH-UE" },
      { name: "Upper West", code: "GH-UW" },
      { name: "Volta", code: "GH-TV" },
      { name: "Western", code: "GH-WP" },
      { name: "Oti", code: "GH-OT" },
      { name: "Savannah", code: "GH-SV" },
      { name: "Western North", code: "GH-WN" }
    ]
  },
  [countryCodes.GIBRALTAR.alphaTwo]: { subdivisions: [{ name: "Gibraltar", code: "-" }] },
  [countryCodes.GREENLAND.alphaTwo]: {
    subdivisions: [
      { name: "Avannaata Kommunia", code: "GL-AV" },
      { name: "Kommune Kujalleq", code: "GL-KU" },
      { name: "Kommune Qeqertalik", code: "GL-QT" },
      { name: "Kommuneqarfik Sermersooq", code: "GL-SM" },
      { name: "Qeqqata Kommunia", code: "GL-QE" }
    ]
  },
  [countryCodes.GAMBIA.alphaTwo]: {
    subdivisions: [
      { name: "Banjul", code: "GM-B" },
      { name: "Central River", code: "GM-M" },
      { name: "Lower River", code: "GM-L" },
      { name: "North Bank", code: "GM-N" },
      { name: "Upper River", code: "GM-U" },
      { name: "Western", code: "GM-W" }
    ]
  },
  [countryCodes.GUINEA.alphaTwo]: {
    subdivisions: [
      { name: "Beyla", code: "GN-BE" },
      { name: "Boke", code: "GN-BK" },
      { name: "Conakry", code: "GN-C" },
      { name: "Coyah", code: "GN-CO" },
      { name: "Dabola", code: "GN-DB" },
      { name: "Dinguiraye", code: "GN-DI" },
      { name: "Dubreka", code: "GN-DU" },
      { name: "Fria", code: "GN-FR" },
      { name: "Kankan", code: "GN-KA" },
      { name: "Kindia", code: "GN-KD" },
      { name: "Kouroussa", code: "GN-KO" },
      { name: "Labe", code: "GN-LA" },
      { name: "Mamou", code: "GN-MM" },
      { name: "Siguiri", code: "GN-SI" },
      { name: "Boffa", code: "GN-BF" },
      { name: "Dalaba", code: "GN-DL" },
      { name: "Faranah", code: "GN-FA" },
      { name: "Forecariah", code: "GN-FO" },
      { name: "Gaoual", code: "GN-GA" },
      { name: "Guekedou", code: "GN-GU" },
      { name: "Koubia", code: "GN-KB" },
      { name: "Kerouane", code: "GN-KE" },
      { name: "Koundara", code: "GN-KN" },
      { name: "Kissidougou", code: "GN-KS" },
      { name: "Lelouma", code: "GN-LE" },
      { name: "Lola", code: "GN-LO" },
      { name: "Macenta", code: "GN-MC" },
      { name: "Mandiana", code: "GN-MD" },
      { name: "Mali", code: "GN-ML" },
      { name: "Nzerekore", code: "GN-NZ" },
      { name: "Pita", code: "GN-PI" },
      { name: "Telimele", code: "GN-TE" },
      { name: "Tougue", code: "GN-TO" },
      { name: "Yomou", code: "GN-YO" }
    ]
  },
  [countryCodes.GUADELOUPE.alphaTwo]: { subdivisions: [{ name: "Guadeloupe", code: "-" }] },
  [countryCodes.EQUATORIAL_GUINEA.alphaTwo]: {
    subdivisions: [
      { name: "Bioko Norte", code: "GQ-BN" },
      { name: "Bioko Sur", code: "GQ-BS" },
      { name: "Centro Sur", code: "GQ-CS" },
      { name: "Kie-Ntem", code: "GQ-KN" },
      { name: "Litoral", code: "GQ-LI" },
      { name: "Wele-Nzas", code: "GQ-WN" },
      { name: "Annobon", code: "GQ-AN" },
      { name: "Djibloho", code: "GQ-DJ" }
    ]
  },
  [countryCodes.GREECE.alphaTwo]: {
    subdivisions: [
      { name: "Agion Oros", code: "GR-69" },
      { name: "Anatoliki Makedonia kai Thraki", code: "GR-A" },
      { name: "Attiki", code: "GR-I" },
      { name: "Dytiki Ellada", code: "GR-G" },
      { name: "Dytiki Makedonia", code: "GR-C" },
      { name: "Ionia Nisia", code: "GR-F" },
      { name: "Ipeiros", code: "GR-D" },
      { name: "Kentriki Makedonia", code: "GR-B" },
      { name: "Kriti", code: "GR-M" },
      { name: "Notio Aigaio", code: "GR-L" },
      { name: "Peloponnisos", code: "GR-J" },
      { name: "Sterea Ellada", code: "GR-H" },
      { name: "Thessalia", code: "GR-E" },
      { name: "Voreio Aigaio", code: "GR-K" }
    ]
  },
  [countryCodes.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "South Georgia and the South Sandwich Islands", code: "-" }]
  },
  [countryCodes.GUATEMALA.alphaTwo]: {
    subdivisions: [
      { name: "Alta Verapaz", code: "GT-16" },
      { name: "Baja Verapaz", code: "GT-15" },
      { name: "Chimaltenango", code: "GT-04" },
      { name: "Chiquimula", code: "GT-20" },
      { name: "El Progreso", code: "GT-02" },
      { name: "Escuintla", code: "GT-05" },
      { name: "Guatemala", code: "GT-01" },
      { name: "Huehuetenango", code: "GT-13" },
      { name: "Izabal", code: "GT-18" },
      { name: "Jalapa", code: "GT-21" },
      { name: "Jutiapa", code: "GT-22" },
      { name: "Peten", code: "GT-17" },
      { name: "Quetzaltenango", code: "GT-09" },
      { name: "Quiche", code: "GT-14" },
      { name: "Retalhuleu", code: "GT-11" },
      { name: "Sacatepequez", code: "GT-03" },
      { name: "San Marcos", code: "GT-12" },
      { name: "Santa Rosa", code: "GT-06" },
      { name: "Solola", code: "GT-07" },
      { name: "Suchitepequez", code: "GT-10" },
      { name: "Totonicapan", code: "GT-08" },
      { name: "Zacapa", code: "GT-19" }
    ]
  },
  [countryCodes.GUAM.alphaTwo]: {
    subdivisions: [
      { name: "Agat", code: "-" },
      { name: "Barrigada", code: "-" },
      { name: "Chalan Pago-Ordot", code: "-" },
      { name: "Dededo", code: "-" },
      { name: "Hagatna", code: "-" },
      { name: "Inarajan", code: "-" },
      { name: "Mangilao", code: "-" },
      { name: "Merizo", code: "-" },
      { name: "Mongmong-Toto-Maite", code: "-" },
      { name: "Piti", code: "-" },
      { name: "Santa Rita", code: "-" },
      { name: "Talofofo", code: "-" },
      { name: "Tamuning-Tumon-Harmon", code: "-" },
      { name: "Yigo", code: "-" },
      { name: "Yona", code: "-" }
    ]
  },
  [countryCodes.GUINEA_BISSAU.alphaTwo]: {
    subdivisions: [
      { name: "Bafata", code: "GW-BA" },
      { name: "Bissau", code: "GW-BS" },
      { name: "Cacheu", code: "GW-CA" },
      { name: "Gabu", code: "GW-GA" },
      { name: "Oio", code: "GW-OI" },
      { name: "Bolama / Bijagos", code: "GW-BL" },
      { name: "Biombo", code: "GW-BM" },
      { name: "Quinara", code: "GW-QU" },
      { name: "Tombali", code: "GW-TO" }
    ]
  },
  [countryCodes.GUYANA.alphaTwo]: {
    subdivisions: [
      { name: "Barima-Waini", code: "GY-BA" },
      { name: "Cuyuni-Mazaruni", code: "GY-CU" },
      { name: "Demerara-Mahaica", code: "GY-DE" },
      { name: "East Berbice-Corentyne", code: "GY-EB" },
      { name: "Essequibo Islands-West Demerara", code: "GY-ES" },
      { name: "Mahaica-Berbice", code: "GY-MA" },
      { name: "Pomeroon-Supenaam", code: "GY-PM" },
      { name: "Potaro-Siparuni", code: "GY-PT" },
      { name: "Upper Demerara-Berbice", code: "GY-UD" },
      { name: "Upper Takutu-Upper Essequibo", code: "GY-UT" }
    ]
  },
  [countryCodes.HONG_KONG.alphaTwo]: { subdivisions: [{ name: "Hong Kong", code: "-" }] },
  [countryCodes.HEARD_ISLAND_AND_MCDONALD_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Heard Island and McDonald Islands", code: "-" }]
  },
  [countryCodes.HONDURAS.alphaTwo]: {
    subdivisions: [
      { name: "Atlantida", code: "HN-AT" },
      { name: "Choluteca", code: "HN-CH" },
      { name: "Colon", code: "HN-CL" },
      { name: "Comayagua", code: "HN-CM" },
      { name: "Copan", code: "HN-CP" },
      { name: "Cortes", code: "HN-CR" },
      { name: "El Paraiso", code: "HN-EP" },
      { name: "Francisco Morazan", code: "HN-FM" },
      { name: "Gracias a Dios", code: "HN-GD" },
      { name: "Intibuca", code: "HN-IN" },
      { name: "Islas de la Bahia", code: "HN-IB" },
      { name: "La Paz", code: "HN-LP" },
      { name: "Lempira", code: "HN-LE" },
      { name: "Ocotepeque", code: "HN-OC" },
      { name: "Olancho", code: "HN-OL" },
      { name: "Santa Barbara", code: "HN-SB" },
      { name: "Valle", code: "HN-VA" },
      { name: "Yoro", code: "HN-YO" }
    ]
  },
  [countryCodes.CROATIA.alphaTwo]: {
    subdivisions: [
      { name: "Bjelovarsko-bilogorska zupanija", code: "HR-07" },
      { name: "Brodsko-posavska zupanija", code: "HR-12" },
      { name: "Dubrovacko-neretvanska zupanija", code: "HR-19" },
      { name: "Grad Zagreb", code: "HR-21" },
      { name: "Istarska zupanija", code: "HR-18" },
      { name: "Karlovacka zupanija", code: "HR-04" },
      { name: "Koprivnicko-krizevacka zupanija", code: "HR-06" },
      { name: "Krapinsko-zagorska zupanija", code: "HR-02" },
      { name: "Licko-senjska zupanija", code: "HR-09" },
      { name: "Medimurska zupanija", code: "HR-20" },
      { name: "Osjecko-baranjska zupanija", code: "HR-14" },
      { name: "Pozesko-slavonska zupanija", code: "HR-11" },
      { name: "Primorsko-goranska zupanija", code: "HR-08" },
      { name: "Sibensko-kninska zupanija", code: "HR-15" },
      { name: "Sisacko-moslavacka zupanija", code: "HR-03" },
      { name: "Splitsko-dalmatinska zupanija", code: "HR-17" },
      { name: "Varazdinska zupanija", code: "HR-05" },
      { name: "Viroviticko-podravska zupanija", code: "HR-10" },
      { name: "Vukovarsko-srijemska zupanija", code: "HR-16" },
      { name: "Zadarska zupanija", code: "HR-13" },
      { name: "Zagrebacka zupanija", code: "HR-01" }
    ]
  },
  [countryCodes.HAITI.alphaTwo]: {
    subdivisions: [
      { name: "Artibonite", code: "HT-AR" },
      { name: "Centre", code: "HT-CE" },
      { name: "Grande'Anse", code: "HT-GA" },
      { name: "Nippes", code: "HT-NI" },
      { name: "Nord", code: "HT-ND" },
      { name: "Nord-Est", code: "HT-NE" },
      { name: "Nord-Ouest", code: "HT-NO" },
      { name: "Ouest", code: "HT-OU" },
      { name: "Sud", code: "HT-SD" },
      { name: "Sud-Est", code: "HT-SE" }
    ]
  },
  [countryCodes.HUNGARY.alphaTwo]: {
    subdivisions: [
      { name: "Bacs-Kiskun", code: "HU-BK" },
      { name: "Baranya", code: "HU-BA" },
      { name: "Bekes", code: "HU-BE" },
      { name: "Borsod-Abauj-Zemplen", code: "HU-BZ" },
      { name: "Budapest", code: "HU-BU" },
      { name: "Csongrad-Csanad", code: "HU-CS" },
      { name: "Fejer", code: "HU-FE" },
      { name: "Gyor-Moson-Sopron", code: "HU-GS" },
      { name: "Hajdu-Bihar", code: "HU-HB" },
      { name: "Heves", code: "HU-HE" },
      { name: "Jasz-Nagykun-Szolnok", code: "HU-JN" },
      { name: "Komarom-Esztergom", code: "HU-KE" },
      { name: "Nograd", code: "HU-NO" },
      { name: "Pest", code: "HU-PE" },
      { name: "Somogy", code: "HU-SO" },
      { name: "Szabolcs-Szatmar-Bereg", code: "HU-SZ" },
      { name: "Tolna", code: "HU-TO" },
      { name: "Vas", code: "HU-VA" },
      { name: "Veszprem", code: "HU-VE" },
      { name: "Zala", code: "HU-ZA" },
      { name: "Bekescsaba", code: "HU-BC" },
      { name: "Debrecen", code: "HU-DE" },
      { name: "Dunaujvaros", code: "HU-DU" },
      { name: "Eger", code: "HU-EG" },
      { name: "Erd", code: "HU-ER" },
      { name: "Gyor", code: "HU-GY" },
      { name: "Hodmezovasarhely", code: "HU-HV" },
      { name: "Kecskemet", code: "HU-KM" },
      { name: "Kaposvar", code: "HU-KV" },
      { name: "Miskolc", code: "HU-MI" },
      { name: "Nagykanizsa", code: "HU-NK" },
      { name: "Nyiregyhaza", code: "HU-NY" },
      { name: "Pecs", code: "HU-PS" },
      { name: "Szeged", code: "HU-SD" },
      { name: "Szekesfehervar", code: "HU-SF" },
      { name: "Szombathely", code: "HU-SH" },
      { name: "Szolnok", code: "HU-SK" },
      { name: "Sopron", code: "HU-SN" },
      { name: "Szekszard", code: "HU-SS" },
      { name: "Salgotarjan", code: "HU-ST" },
      { name: "Tatabanya", code: "HU-TB" },
      { name: "Zalaegerszeg", code: "HU-ZE" }
    ]
  },
  [countryCodes.INDONESIA.alphaTwo]: {
    subdivisions: [
      { name: "Aceh", code: "ID-AC" },
      { name: "Bali", code: "ID-BA" },
      { name: "Banten", code: "ID-BT" },
      { name: "Bengkulu", code: "ID-BE" },
      { name: "Gorontalo", code: "ID-GO" },
      { name: "Jakarta Raya", code: "ID-JK" },
      { name: "Jambi", code: "ID-JA" },
      { name: "Jawa Barat", code: "ID-JB" },
      { name: "Jawa Tengah", code: "ID-JT" },
      { name: "Jawa Timur", code: "ID-JI" },
      { name: "Kalimantan Barat", code: "ID-KB" },
      { name: "Kalimantan Selatan", code: "ID-KS" },
      { name: "Kalimantan Tengah", code: "ID-KT" },
      { name: "Kalimantan Timur", code: "ID-KI" },
      { name: "Kalimantan Utara", code: "ID-KU" },
      { name: "Kepulauan Bangka Belitung", code: "ID-BB" },
      { name: "Kepulauan Riau", code: "ID-KR" },
      { name: "Lampung", code: "ID-LA" },
      { name: "Maluku", code: "ID-ML" },
      { name: "Maluku Utara", code: "ID-MU" },
      { name: "Nusa Tenggara Barat", code: "ID-NB" },
      { name: "Nusa Tenggara Timur", code: "ID-NT" },
      { name: "Papua", code: "ID-PP" },
      { name: "Papua Barat", code: "ID-PB" },
      { name: "Papua Barat Daya", code: "ID-PD" },
      { name: "Papua Pengunungan", code: "ID-PE" },
      { name: "Papua Selatan", code: "ID-PS" },
      { name: "Papua Tengah", code: "ID-PT" },
      { name: "Riau", code: "ID-RI" },
      { name: "Sulawesi Barat", code: "ID-SR" },
      { name: "Sulawesi Selatan", code: "ID-SN" },
      { name: "Sulawesi Tengah", code: "ID-ST" },
      { name: "Sulawesi Tenggara", code: "ID-SG" },
      { name: "Sulawesi Utara", code: "ID-SA" },
      { name: "Sumatera Barat", code: "ID-SB" },
      { name: "Sumatera Selatan", code: "ID-SS" },
      { name: "Sumatera Utara", code: "ID-SU" },
      { name: "Yogyakarta", code: "ID-YO" }
    ]
  },
  [countryCodes.IRELAND.alphaTwo]: {
    subdivisions: [
      { name: "Carlow", code: "IE-CW" },
      { name: "Cavan", code: "IE-CN" },
      { name: "Clare", code: "IE-CE" },
      { name: "Cork", code: "IE-CO" },
      { name: "Donegal", code: "IE-DL" },
      { name: "Dublin", code: "IE-D" },
      { name: "Galway", code: "IE-G" },
      { name: "Kerry", code: "IE-KY" },
      { name: "Kildare", code: "IE-KE" },
      { name: "Kilkenny", code: "IE-KK" },
      { name: "Laois", code: "IE-LS" },
      { name: "Leitrim", code: "IE-LM" },
      { name: "Limerick", code: "IE-LK" },
      { name: "Longford", code: "IE-LD" },
      { name: "Louth", code: "IE-LH" },
      { name: "Mayo", code: "IE-MO" },
      { name: "Meath", code: "IE-MH" },
      { name: "Monaghan", code: "IE-MN" },
      { name: "Offaly", code: "IE-OY" },
      { name: "Roscommon", code: "IE-RN" },
      { name: "Sligo", code: "IE-SO" },
      { name: "Tipperary", code: "IE-TA" },
      { name: "Waterford", code: "IE-WD" },
      { name: "Westmeath", code: "IE-WH" },
      { name: "Wexford", code: "IE-WX" },
      { name: "Wicklow", code: "IE-WW" }
    ]
  },
  [countryCodes.ISRAEL.alphaTwo]: {
    subdivisions: [
      { name: "Al Janubi", code: "IL-D" },
      { name: "Al Awsat", code: "IL-M" },
      { name: "HaTsafon", code: "IL-Z" },
      { name: "Hefa", code: "IL-HA" },
      { name: "Tel Aviv", code: "IL-TA" },
      { name: "Yerushalayim", code: "IL-JM" }
    ]
  },
  [countryCodes.ISLE_OF_MAN.alphaTwo]: { subdivisions: [{ name: "Isle of Man", code: "-" }] },
  [countryCodes.INDIA.alphaTwo]: {
    subdivisions: [
      { name: "Andaman and Nicobar Islands", code: "IN-AN" },
      { name: "Andhra Pradesh", code: "IN-AP" },
      { name: "Arunachal Pradesh", code: "IN-AR" },
      { name: "Assam", code: "IN-AS" },
      { name: "Bihar", code: "IN-BR" },
      { name: "Chandigarh", code: "IN-CH" },
      { name: "Chhattisgarh", code: "IN-CG" },
      { name: "Dadra and Nagar Haveli and Daman and Diu", code: "IN-DH" },
      { name: "Delhi", code: "IN-DL" },
      { name: "Goa", code: "IN-GA" },
      { name: "Gujarat", code: "IN-GJ" },
      { name: "Haryana", code: "IN-HR" },
      { name: "Himachal Pradesh", code: "IN-HP" },
      { name: "Jammu and Kashmir", code: "IN-JK" },
      { name: "Jharkhand", code: "IN-JH" },
      { name: "Karnataka", code: "IN-KA" },
      { name: "Kerala", code: "IN-KL" },
      { name: "Lakshadweep", code: "IN-LD" },
      { name: "Madhya Pradesh", code: "IN-MP" },
      { name: "Maharashtra", code: "IN-MH" },
      { name: "Manipur", code: "IN-MN" },
      { name: "Meghalaya", code: "IN-ML" },
      { name: "Mizoram", code: "IN-MZ" },
      { name: "Nagaland", code: "IN-NL" },
      { name: "Odisha", code: "IN-OD" },
      { name: "Puducherry", code: "IN-PY" },
      { name: "Punjab", code: "IN-PB" },
      { name: "Rajasthan", code: "IN-RJ" },
      { name: "Sikkim", code: "IN-SK" },
      { name: "Tamil Nadu", code: "IN-TN" },
      { name: "Telangana", code: "IN-TS" },
      { name: "Tripura", code: "IN-TR" },
      { name: "Uttar Pradesh", code: "IN-UP" },
      { name: "Uttarakhand", code: "IN-UK" },
      { name: "West Bengal", code: "IN-WB" },
      { name: "Ladakh", code: "IN-LA" }
    ]
  },
  [countryCodes.BRITISH_INDIAN_OCEAN_TERRITORY.alphaTwo]: {
    subdivisions: [{ name: "British Indian Ocean Territory", code: "-" }]
  },
  [countryCodes.IRAQ.alphaTwo]: {
    subdivisions: [
      { name: "Al Anbar", code: "IQ-AN" },
      { name: "Al Basrah", code: "IQ-BA" },
      { name: "Al Muthanna", code: "IQ-MU" },
      { name: "Al Qadisiyah", code: "IQ-QA" },
      { name: "An Najaf", code: "IQ-NA" },
      { name: "Arbil", code: "IQ-AR" },
      { name: "As Sulaymaniyah", code: "IQ-SU" },
      { name: "Babil", code: "IQ-BB" },
      { name: "Baghdad", code: "IQ-BG" },
      { name: "Dahuk", code: "IQ-DA" },
      { name: "Dhi Qar", code: "IQ-DQ" },
      { name: "Diyala", code: "IQ-DI" },
      { name: "Karbala'", code: "IQ-KA" },
      { name: "Kirkuk", code: "IQ-KI" },
      { name: "Maysan", code: "IQ-MA" },
      { name: "Ninawa", code: "IQ-NI" },
      { name: "Salah ad Din", code: "IQ-SD" },
      { name: "Wasit", code: "IQ-WA" }
    ]
  },
  [countryCodes.IRAN_ISLAMIC_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Alborz", code: "IR-30" },
      { name: "Ardabil", code: "IR-24" },
      { name: "Azarbayjan-e Gharbi", code: "IR-04" },
      { name: "Azarbayjan-e Sharqi", code: "IR-03" },
      { name: "Bushehr", code: "IR-18" },
      { name: "Chahar Mahal va Bakhtiari", code: "IR-14" },
      { name: "Esfahan", code: "IR-10" },
      { name: "Fars", code: "IR-07" },
      { name: "Gilan", code: "IR-01" },
      { name: "Golestan", code: "IR-27" },
      { name: "Hamadan", code: "IR-13" },
      { name: "Hormozgan", code: "IR-22" },
      { name: "Ilam", code: "IR-16" },
      { name: "Kerman", code: "IR-08" },
      { name: "Kermanshah", code: "IR-05" },
      { name: "Khorasan-e Jonubi", code: "IR-29" },
      { name: "Khorasan-e Razavi", code: "IR-09" },
      { name: "Khorasan-e Shomali", code: "IR-28" },
      { name: "Khuzestan", code: "IR-06" },
      { name: "Kohgiluyeh va Bowyer Ahmad", code: "IR-17" },
      { name: "Kordestan", code: "IR-12" },
      { name: "Lorestan", code: "IR-15" },
      { name: "Markazi", code: "IR-00" },
      { name: "Mazandaran", code: "IR-02" },
      { name: "Qazvin", code: "IR-26" },
      { name: "Qom", code: "IR-25" },
      { name: "Semnan", code: "IR-20" },
      { name: "Sistan va Baluchestan", code: "IR-11" },
      { name: "Tehran", code: "IR-23" },
      { name: "Yazd", code: "IR-21" },
      { name: "Zanjan", code: "IR-19" }
    ]
  },
  [countryCodes.ICELAND.alphaTwo]: {
    subdivisions: [
      { name: "Austurland", code: "IS-7" },
      { name: "Hofudborgarsvaedi", code: "IS-1" },
      { name: "Nordurland eystra", code: "IS-6" },
      { name: "Nordurland vestra", code: "IS-5" },
      { name: "Sudurland", code: "IS-8" },
      { name: "Sudurnes", code: "IS-2" },
      { name: "Vestfirdir", code: "IS-4" },
      { name: "Vesturland", code: "IS-3" }
    ]
  },
  [countryCodes.ITALY.alphaTwo]: {
    subdivisions: [
      { name: "Abruzzo", code: "IT-65" },
      { name: "Basilicata", code: "IT-77" },
      { name: "Calabria", code: "IT-78" },
      { name: "Campania", code: "IT-72" },
      { name: "Emilia-Romagna", code: "IT-45" },
      { name: "Friuli-Venezia Giulia", code: "IT-36" },
      { name: "Lazio", code: "IT-62" },
      { name: "Liguria", code: "IT-42" },
      { name: "Lombardia", code: "IT-25" },
      { name: "Marche", code: "IT-57" },
      { name: "Molise", code: "IT-67" },
      { name: "Piemonte", code: "IT-21" },
      { name: "Puglia", code: "IT-75" },
      { name: "Sardegna", code: "IT-88" },
      { name: "Sicilia", code: "IT-82" },
      { name: "Toscana", code: "IT-52" },
      { name: "Trentino-Alto Adige", code: "IT-32" },
      { name: "Umbria", code: "IT-55" },
      { name: "Valle d'Aosta", code: "IT-23" },
      { name: "Veneto", code: "IT-34" }
    ]
  },
  [countryCodes.JERSEY.alphaTwo]: { subdivisions: [{ name: "Jersey", code: "-" }] },
  [countryCodes.JAMAICA.alphaTwo]: {
    subdivisions: [
      { name: "Clarendon", code: "JM-13" },
      { name: "Hanover", code: "JM-09" },
      { name: "Kingston", code: "JM-01" },
      { name: "Manchester", code: "JM-12" },
      { name: "Portland", code: "JM-04" },
      { name: "Saint Andrew", code: "JM-02" },
      { name: "Saint Ann", code: "JM-06" },
      { name: "Saint Catherine", code: "JM-14" },
      { name: "Saint Elizabeth", code: "JM-11" },
      { name: "Saint James", code: "JM-08" },
      { name: "Saint Mary", code: "JM-05" },
      { name: "Saint Thomas", code: "JM-03" },
      { name: "Trelawny", code: "JM-07" },
      { name: "Westmoreland", code: "JM-10" }
    ]
  },
  [countryCodes.JORDAN.alphaTwo]: {
    subdivisions: [
      { name: "Ajlun", code: "JO-AJ" },
      { name: "Al 'Aqabah", code: "JO-AQ" },
      { name: "Al 'Asimah", code: "JO-AM" },
      { name: "Al Balqa'", code: "JO-BA" },
      { name: "Al Karak", code: "JO-KA" },
      { name: "Al Mafraq", code: "JO-MA" },
      { name: "At Tafilah", code: "JO-AT" },
      { name: "Az Zarqa'", code: "JO-AZ" },
      { name: "Irbid", code: "JO-IR" },
      { name: "Jarash", code: "JO-JA" },
      { name: "Ma'an", code: "JO-MN" },
      { name: "Madaba", code: "JO-MD" }
    ]
  },
  [countryCodes.JAPAN.alphaTwo]: {
    subdivisions: [
      { name: "Aichi", code: "JP-23" },
      { name: "Akita", code: "JP-05" },
      { name: "Aomori", code: "JP-02" },
      { name: "Chiba", code: "JP-12" },
      { name: "Ehime", code: "JP-38" },
      { name: "Fukui", code: "JP-18" },
      { name: "Fukuoka", code: "JP-40" },
      { name: "Fukushima", code: "JP-07" },
      { name: "Gifu", code: "JP-21" },
      { name: "Gunma", code: "JP-10" },
      { name: "Hiroshima", code: "JP-34" },
      { name: "Hokkaido", code: "JP-01" },
      { name: "Hyogo", code: "JP-28" },
      { name: "Ibaraki", code: "JP-08" },
      { name: "Ishikawa", code: "JP-17" },
      { name: "Iwate", code: "JP-03" },
      { name: "Kagawa", code: "JP-37" },
      { name: "Kagoshima", code: "JP-46" },
      { name: "Kanagawa", code: "JP-14" },
      { name: "Kochi", code: "JP-39" },
      { name: "Kumamoto", code: "JP-43" },
      { name: "Kyoto", code: "JP-26" },
      { name: "Mie", code: "JP-24" },
      { name: "Miyagi", code: "JP-04" },
      { name: "Miyazaki", code: "JP-45" },
      { name: "Nagano", code: "JP-20" },
      { name: "Nagasaki", code: "JP-42" },
      { name: "Nara", code: "JP-29" },
      { name: "Niigata", code: "JP-15" },
      { name: "Oita", code: "JP-44" },
      { name: "Okayama", code: "JP-33" },
      { name: "Okinawa", code: "JP-47" },
      { name: "Osaka", code: "JP-27" },
      { name: "Saga", code: "JP-41" },
      { name: "Saitama", code: "JP-11" },
      { name: "Shiga", code: "JP-25" },
      { name: "Shimane", code: "JP-32" },
      { name: "Shizuoka", code: "JP-22" },
      { name: "Tochigi", code: "JP-09" },
      { name: "Tokushima", code: "JP-36" },
      { name: "Tokyo", code: "JP-13" },
      { name: "Tottori", code: "JP-31" },
      { name: "Toyama", code: "JP-16" },
      { name: "Wakayama", code: "JP-30" },
      { name: "Yamagata", code: "JP-06" },
      { name: "Yamaguchi", code: "JP-35" },
      { name: "Yamanashi", code: "JP-19" }
    ]
  },
  [countryCodes.KENYA.alphaTwo]: {
    subdivisions: [
      { name: "Baringo", code: "KE-01" },
      { name: "Bomet", code: "KE-02" },
      { name: "Bungoma", code: "KE-03" },
      { name: "Busia", code: "KE-04" },
      { name: "Elgeyo/Marakwet", code: "KE-05" },
      { name: "Embu", code: "KE-06" },
      { name: "Garissa", code: "KE-07" },
      { name: "Homa Bay", code: "KE-08" },
      { name: "Isiolo", code: "KE-09" },
      { name: "Kajiado", code: "KE-10" },
      { name: "Kakamega", code: "KE-11" },
      { name: "Kericho", code: "KE-12" },
      { name: "Kiambu", code: "KE-13" },
      { name: "Kilifi", code: "KE-14" },
      { name: "Kirinyaga", code: "KE-15" },
      { name: "Kisii", code: "KE-16" },
      { name: "Kisumu", code: "KE-17" },
      { name: "Kitui", code: "KE-18" },
      { name: "Kwale", code: "KE-19" },
      { name: "Laikipia", code: "KE-20" },
      { name: "Lamu", code: "KE-21" },
      { name: "Machakos", code: "KE-22" },
      { name: "Makueni", code: "KE-23" },
      { name: "Mandera", code: "KE-24" },
      { name: "Marsabit", code: "KE-25" },
      { name: "Meru", code: "KE-26" },
      { name: "Migori", code: "KE-27" },
      { name: "Mombasa", code: "KE-28" },
      { name: "Murang'a", code: "KE-29" },
      { name: "Nairobi City", code: "KE-30" },
      { name: "Nakuru", code: "KE-31" },
      { name: "Nandi", code: "KE-32" },
      { name: "Narok", code: "KE-33" },
      { name: "Nyamira", code: "KE-34" },
      { name: "Nyandarua", code: "KE-35" },
      { name: "Nyeri", code: "KE-36" },
      { name: "Samburu", code: "KE-37" },
      { name: "Siaya", code: "KE-38" },
      { name: "Taita/Taveta", code: "KE-39" },
      { name: "Tana River", code: "KE-40" },
      { name: "Tharaka-Nithi", code: "KE-41" },
      { name: "Trans Nzoia", code: "KE-42" },
      { name: "Turkana", code: "KE-43" },
      { name: "Uasin Gishu", code: "KE-44" },
      { name: "Vihiga", code: "KE-45" },
      { name: "Wajir", code: "KE-46" },
      { name: "West Pokot", code: "KE-47" }
    ]
  },
  [countryCodes.KYRGYZSTAN.alphaTwo]: {
    subdivisions: [
      { name: "Batken", code: "KG-B" },
      { name: "Bishkek Shaary", code: "KG-GB" },
      { name: "Chuy", code: "KG-C" },
      { name: "Jalal-Abad", code: "KG-J" },
      { name: "Naryn", code: "KG-N" },
      { name: "Osh Shaary", code: "KG-GO" },
      { name: "Talas", code: "KG-T" },
      { name: "Ysyk-Kol", code: "KG-Y" },
      { name: "Osh", code: "KG-O" }
    ]
  },
  [countryCodes.CAMBODIA.alphaTwo]: {
    subdivisions: [
      { name: "Baat Dambang", code: "KH-2" },
      { name: "Banteay Mean Choay", code: "KH-1" },
      { name: "Kaeb", code: "KH-23" },
      { name: "Kampong Chaam", code: "KH-3" },
      { name: "Kampong Chhnang", code: "KH-4" },
      { name: "Kampong Spueu", code: "KH-5" },
      { name: "Kampong Thum", code: "KH-6" },
      { name: "Kampot", code: "KH-7" },
      { name: "Kandaal", code: "KH-8" },
      { name: "Kaoh Kong", code: "KH-9" },
      { name: "Kracheh", code: "KH-10" },
      { name: "Mondol Kiri", code: "KH-11" },
      { name: "Otdar Mean Chey", code: "KH-22" },
      { name: "Pailin", code: "KH-24" },
      { name: "Phnom Penh", code: "KH-12" },
      { name: "Pousaat", code: "KH-15" },
      { name: "Preah Sihanouk", code: "KH-18" },
      { name: "Preah Vihear", code: "KH-13" },
      { name: "Prey Veaeng", code: "KH-14" },
      { name: "Rotanak Kiri", code: "KH-16" },
      { name: "Siem Reab", code: "KH-17" },
      { name: "Stueng Traeng", code: "KH-19" },
      { name: "Svaay Rieng", code: "KH-20" },
      { name: "Taakaev", code: "KH-21" },
      { name: "Tbong Khmum", code: "KH-25" }
    ]
  },
  [countryCodes.KIRIBATI.alphaTwo]: {
    subdivisions: [
      { name: "Gilbert Islands", code: "KI-G" },
      { name: "Line Islands", code: "KI-L" },
      { name: "Phoenix Islands", code: "KI-P" }
    ]
  },
  [countryCodes.COMOROS.alphaTwo]: {
    subdivisions: [
      { name: "Anjouan", code: "KM-A" },
      { name: "Grande Comore", code: "KM-G" },
      { name: "Moheli", code: "KM-M" }
    ]
  },
  [countryCodes.SAINT_KITTS_AND_NEVIS.alphaTwo]: {
    subdivisions: [
      { name: "Christ Church Nichola Town", code: "KN-01" },
      { name: "Saint Anne Sandy Point", code: "KN-02" },
      { name: "Saint George Basseterre", code: "KN-03" },
      { name: "Saint James Windward", code: "KN-05" },
      { name: "Saint John Capisterre", code: "KN-06" },
      { name: "Saint Mary Cayon", code: "KN-08" },
      { name: "Saint Paul Charlestown", code: "KN-10" },
      { name: "Saint Peter Basseterre", code: "KN-11" },
      { name: "Saint Thomas Lowland", code: "KN-12" },
      { name: "Trinity Palmetto Point", code: "KN-15" },
      { name: "Saint George Gingerland", code: "KN-04" },
      { name: "Saint John Figtree", code: "KN-07" },
      { name: "Saint Paul Capisterre", code: "KN-09" },
      { name: "Saint Thomas Middle Island", code: "KN-13" }
    ]
  },
  [countryCodes.NORTH_KOREA.alphaTwo]: {
    subdivisions: [
      { name: "P'yongyang", code: "KP-01" },
      { name: "P'yongan-namdo", code: "KP-02" },
      { name: "P'yongan-bukto", code: "KP-03" },
      { name: "Chagang-do", code: "KP-04" },
      { name: "Hwanghae-namdo", code: "KP-05" },
      { name: "Hwanghae-bukto", code: "KP-06" },
      { name: "Kangweonto", code: "KP-07" },
      { name: "Hamgyong-namdo", code: "KP-08" },
      { name: "Hamgyong-bukto", code: "KP-09" },
      { name: "Ryanggang-do", code: "KP-10" },
      { name: "Raseon", code: "KP-13" },
      { name: "Nampho", code: "KP-14" },
      { name: "Kaeseong", code: "KP-15" }
    ]
  },
  [countryCodes.SOUTH_KOREA.alphaTwo]: {
    subdivisions: [
      { name: "Busan-gwangyeoksi", code: "KR-26" },
      { name: "Chungcheongbuk-do", code: "KR-43" },
      { name: "Chungcheongnam-do", code: "KR-44" },
      { name: "Daegu-gwangyeoksi", code: "KR-27" },
      { name: "Daejeon-gwangyeoksi", code: "KR-30" },
      { name: "Gangwon-teukbyeoljachido", code: "KR-42" },
      { name: "Gwangju-gwangyeoksi", code: "KR-29" },
      { name: "Gyeonggi-do", code: "KR-41" },
      { name: "Gyeongsangbuk-do", code: "KR-47" },
      { name: "Gyeongsangnam-do", code: "KR-48" },
      { name: "Incheon-gwangyeoksi", code: "KR-28" },
      { name: "Jeju-teukbyeoljachido", code: "KR-49" },
      { name: "Jeollabuk-do", code: "KR-45" },
      { name: "Jeollanam-do", code: "KR-46" },
      { name: "Sejong", code: "KR-50" },
      { name: "Seoul-teukbyeolsi", code: "KR-11" },
      { name: "Ulsan-gwangyeoksi", code: "KR-31" }
    ]
  },
  [countryCodes.KUWAIT.alphaTwo]: {
    subdivisions: [
      { name: "Al 'Asimah", code: "KW-KU" },
      { name: "Al Ahmadi", code: "KW-AH" },
      { name: "Al Farwaniyah", code: "KW-FA" },
      { name: "Al Jahra'", code: "KW-JA" },
      { name: "Hawalli", code: "KW-HA" },
      { name: "Mubarak al Kabir", code: "KW-MU" }
    ]
  },
  [countryCodes.CAYMAN_ISLANDS.alphaTwo]: { subdivisions: [{ name: "Cayman Islands", code: "-" }] },
  [countryCodes.KAZAKHSTAN.alphaTwo]: {
    subdivisions: [
      { name: "Abay oblysy", code: "KZ-10" },
      { name: "Almaty", code: "KZ-75" },
      { name: "Almaty oblysy", code: "KZ-19" },
      { name: "Aqmola oblysy", code: "KZ-11" },
      { name: "Aqtobe oblysy", code: "KZ-15" },
      { name: "Astana", code: "KZ-71" },
      { name: "Atyrau oblysy", code: "KZ-23" },
      { name: "Batys Qazaqstan oblysy", code: "KZ-27" },
      { name: "Mangghystau oblysy", code: "KZ-47" },
      { name: "Pavlodar oblysy", code: "KZ-55" },
      { name: "Qaraghandy oblysy", code: "KZ-35" },
      { name: "Qostanay oblysy", code: "KZ-39" },
      { name: "Qyzylorda oblysy", code: "KZ-43" },
      { name: "Shyghys Qazaqstan oblysy", code: "KZ-63" },
      { name: "Shymkent", code: "KZ-79" },
      { name: "Soltustik Qazaqstan oblysy", code: "KZ-59" },
      { name: "Turkistan oblysy", code: "KZ-61" },
      { name: "Ulytau oblysy", code: "KZ-62" },
      { name: "Zhambyl oblysy", code: "KZ-31" },
      { name: "Zhetisu oblysy", code: "KZ-33" }
    ]
  },
  [countryCodes.LAOS.alphaTwo]: {
    subdivisions: [
      { name: "Attapu", code: "LA-AT" },
      { name: "Bokeo", code: "LA-BK" },
      { name: "Bolikhamxai", code: "LA-BL" },
      { name: "Champasak", code: "LA-CH" },
      { name: "Houaphan", code: "LA-HO" },
      { name: "Khammouan", code: "LA-KH" },
      { name: "Louangphabang", code: "LA-LP" },
      { name: "Oudomxai", code: "LA-OU" },
      { name: "Savannakhet", code: "LA-SV" },
      { name: "Viangchan", code: "LA-VI" },
      { name: "Xaignabouli", code: "LA-XA" },
      { name: "Xekong", code: "LA-XE" },
      { name: "Xiangkhouang", code: "LA-XI" },
      { name: "Louang Namtha", code: "LA-LM" },
      { name: "Phongsali", code: "LA-PH" },
      { name: "Salavan", code: "LA-SL" },
      { name: "Xaisomboun", code: "LA-XS" }
    ]
  },
  [countryCodes.LEBANON.alphaTwo]: {
    subdivisions: [
      { name: "Aakkar", code: "LB-AK" },
      { name: "Baalbek-Hermel", code: "LB-BH" },
      { name: "Al Biqa", code: "LB-BI" },
      { name: "Beyrouth", code: "LB-BA" },
      { name: "Ash Shimal", code: "LB-AS" },
      { name: "Liban-Sud", code: "LB-JA" },
      { name: "Mont-Liban", code: "LB-JL" },
      { name: "Nabatiye", code: "LB-NA" }
    ]
  },
  [countryCodes.SAINT_LUCIA.alphaTwo]: {
    subdivisions: [
      { name: "Anse la Raye", code: "LC-01" },
      { name: "Castries", code: "LC-02" },
      { name: "Choiseul", code: "LC-03" },
      { name: "Dennery", code: "LC-05" },
      { name: "Gros Islet", code: "LC-06" },
      { name: "Laborie", code: "LC-07" },
      { name: "Micoud", code: "LC-08" },
      { name: "Soufriere", code: "LC-10" },
      { name: "Vieux Fort", code: "LC-11" },
      { name: "Canaries", code: "LC-12" }
    ]
  },
  [countryCodes.LIECHTENSTEIN.alphaTwo]: {
    subdivisions: [
      { name: "Balzers", code: "LI-01" },
      { name: "Eschen", code: "LI-02" },
      { name: "Gamprin", code: "LI-03" },
      { name: "Mauren", code: "LI-04" },
      { name: "Planken", code: "LI-05" },
      { name: "Ruggell", code: "LI-06" },
      { name: "Schaan", code: "LI-07" },
      { name: "Schellenberg", code: "LI-08" },
      { name: "Triesen", code: "LI-09" },
      { name: "Triesenberg", code: "LI-10" },
      { name: "Vaduz", code: "LI-11" }
    ]
  },
  [countryCodes.SRI_LANKA.alphaTwo]: {
    subdivisions: [
      { name: "Central Province", code: "LK-2" },
      { name: "Eastern Province", code: "LK-5" },
      { name: "North Central Province", code: "LK-7" },
      { name: "North Western Province", code: "LK-6" },
      { name: "Northern Province", code: "LK-4" },
      { name: "Sabaragamuwa Province", code: "LK-9" },
      { name: "Southern Province", code: "LK-3" },
      { name: "Uva Province", code: "LK-8" },
      { name: "Western Province", code: "LK-1" },
      { name: "Colombo", code: "LK-11" },
      { name: "Gampaha", code: "LK-12" },
      { name: "Kalutara", code: "LK-13" },
      { name: "Kandy", code: "LK-21" },
      { name: "Matale", code: "LK-22" },
      { name: "Nuwara Eliya", code: "LK-23" },
      { name: "Galle", code: "LK-31" },
      { name: "Matara", code: "LK-32" },
      { name: "Hambantota", code: "LK-33" },
      { name: "Jaffna", code: "LK-41" },
      { name: "Kilinochchi", code: "LK-42" },
      { name: "Mannar", code: "LK-43" },
      { name: "Vavuniya", code: "LK-44" },
      { name: "Mullaittivu", code: "LK-45" },
      { name: "Batticaloa", code: "LK-51" },
      { name: "Ampara", code: "LK-52" },
      { name: "Trincomalee", code: "LK-53" },
      { name: "Kurunegala", code: "LK-61" },
      { name: "Puttalam", code: "LK-62" },
      { name: "Anuradhapura", code: "LK-71" },
      { name: "Polonnaruwa", code: "LK-72" },
      { name: "Badulla", code: "LK-81" },
      { name: "Monaragala", code: "LK-82" },
      { name: "Ratnapura", code: "LK-91" },
      { name: "Kegalla", code: "LK-92" }
    ]
  },
  [countryCodes.LIBERIA.alphaTwo]: {
    subdivisions: [
      { name: "Bomi", code: "LR-BM" },
      { name: "Bong", code: "LR-BG" },
      { name: "Grand Bassa", code: "LR-GB" },
      { name: "Grand Cape Mount", code: "LR-CM" },
      { name: "Grand Gedeh", code: "LR-GG" },
      { name: "Margibi", code: "LR-MG" },
      { name: "Montserrado", code: "LR-MO" },
      { name: "Nimba", code: "LR-NI" },
      { name: "River Cess", code: "LR-RI" },
      { name: "River Gee", code: "LR-RG" },
      { name: "Sinoe", code: "LR-SI" },
      { name: "Grand Kru", code: "LR-GK" },
      { name: "Gbarpolu", code: "LR-GP" },
      { name: "Lofa", code: "LR-LO" },
      { name: "Maryland", code: "LR-MY" }
    ]
  },
  [countryCodes.LESOTHO.alphaTwo]: {
    subdivisions: [
      { name: "Berea", code: "LS-D" },
      { name: "Botha-Bothe", code: "LS-B" },
      { name: "Leribe", code: "LS-C" },
      { name: "Mafeteng", code: "LS-E" },
      { name: "Maseru", code: "LS-A" },
      { name: "Mokhotlong", code: "LS-J" },
      { name: "Qacha's Nek", code: "LS-H" },
      { name: "Quthing", code: "LS-G" },
      { name: "Thaba-Tseka", code: "LS-K" },
      { name: "Mohale's Hoek", code: "LS-F" }
    ]
  },
  [countryCodes.LITHUANIA.alphaTwo]: {
    subdivisions: [
      { name: "Alytaus apskritis", code: "LT-AL" },
      { name: "Kauno apskritis", code: "LT-KU" },
      { name: "Klaipedos apskritis", code: "LT-KL" },
      { name: "Marijampoles apskritis", code: "LT-MR" },
      { name: "Panevezio apskritis", code: "LT-PN" },
      { name: "Siauliu apskritis", code: "LT-SA" },
      { name: "Taurages apskritis", code: "LT-TA" },
      { name: "Telsiu apskritis", code: "LT-TE" },
      { name: "Utenos apskritis", code: "LT-UT" },
      { name: "Vilniaus apskritis", code: "LT-VL" }
    ]
  },
  [countryCodes.LUXEMBOURG.alphaTwo]: {
    subdivisions: [
      { name: "Capellen", code: "LU-CA" },
      { name: "Clervaux", code: "LU-CL" },
      { name: "Diekirch", code: "LU-DI" },
      { name: "Echternach", code: "LU-EC" },
      { name: "Esch-sur-Alzette", code: "LU-ES" },
      { name: "Grevenmacher", code: "LU-GR" },
      { name: "Luxembourg", code: "LU-LU" },
      { name: "Mersch", code: "LU-ME" },
      { name: "Redange", code: "LU-RD" },
      { name: "Remich", code: "LU-RM" },
      { name: "Vianden", code: "LU-VD" },
      { name: "Wiltz", code: "LU-WI" }
    ]
  },
  [countryCodes.LATVIA.alphaTwo]: {
    subdivisions: [
      { name: "Adazu novads", code: "LV-011" },
      { name: "Aizkraukles novads", code: "LV-002" },
      { name: "Aluksnes novads", code: "LV-007" },
      { name: "Augsdaugavas novads", code: "LV-111" },
      { name: "Balvu novads", code: "LV-015" },
      { name: "Bauskas novads", code: "LV-016" },
      { name: "Cesu novads", code: "LV-022" },
      { name: "Daugavpils", code: "LV-DGV" },
      { name: "Dienvidkurzemes novads", code: "LV-112" },
      { name: "Dobeles novads", code: "LV-026" },
      { name: "Gulbenes novads", code: "LV-033" },
      { name: "Jekabpils novads", code: "LV-042" },
      { name: "Jelgava", code: "LV-JEL" },
      { name: "Jelgavas novads", code: "LV-041" },
      { name: "Jurmala", code: "LV-JUR" },
      { name: "Kekavas novads", code: "LV-052" },
      { name: "Kraslavas novads", code: "LV-047" },
      { name: "Kuldigas novads", code: "LV-050" },
      { name: "Liepaja", code: "LV-LPX" },
      { name: "Limbazu novads", code: "LV-054" },
      { name: "Livanu novads", code: "LV-056" },
      { name: "Ludzas novads", code: "LV-058" },
      { name: "Madonas novads", code: "LV-059" },
      { name: "Marupes novads", code: "LV-062" },
      { name: "Ogres novads", code: "LV-067" },
      { name: "Olaines novads", code: "LV-068" },
      { name: "Preilu novads", code: "LV-073" },
      { name: "Rezeknes novads", code: "LV-077" },
      { name: "Riga", code: "LV-RIX" },
      { name: "Ropazu novads", code: "LV-080" },
      { name: "Salaspils novads", code: "LV-087" },
      { name: "Saldus novads", code: "LV-088" },
      { name: "Saulkrastu novads", code: "LV-089" },
      { name: "Siguldas novads", code: "LV-091" },
      { name: "Smiltenes novads", code: "LV-094" },
      { name: "Talsu novads", code: "LV-097" },
      { name: "Tukuma novads", code: "LV-099" },
      { name: "Valkas novads", code: "LV-101" },
      { name: "Valmieras novads", code: "LV-113" },
      { name: "Varaklanu novads", code: "LV-102" },
      { name: "Ventspils novads", code: "LV-106" },
      { name: "Rezekne", code: "LV-REZ" },
      { name: "Ventspils", code: "LV-VEN" }
    ]
  },
  [countryCodes.LIBYA.alphaTwo]: {
    subdivisions: [
      { name: "Al Butnan", code: "LY-BU" },
      { name: "Al Jabal al Akhdar", code: "LY-JA" },
      { name: "Al Jabal al Gharbi", code: "LY-JG" },
      { name: "Al Jafarah", code: "LY-JI" },
      { name: "Al Jufrah", code: "LY-JU" },
      { name: "Al Marj", code: "LY-MJ" },
      { name: "Al Marqab", code: "LY-MB" },
      { name: "Al Wahat", code: "LY-WA" },
      { name: "An Nuqat al Khams", code: "LY-NQ" },
      { name: "Az Zawiyah", code: "LY-ZA" },
      { name: "Banghazi", code: "LY-BA" },
      { name: "Darnah", code: "LY-DR" },
      { name: "Misratah", code: "LY-MI" },
      { name: "Murzuq", code: "LY-MQ" },
      { name: "Nalut", code: "LY-NL" },
      { name: "Sabha", code: "LY-SB" },
      { name: "Surt", code: "LY-SR" },
      { name: "Tarabulus", code: "LY-TB" },
      { name: "Wadi al Hayat", code: "LY-WD" },
      { name: "Wadi ash Shati'", code: "LY-WS" },
      { name: "Ghat", code: "LY-GT" },
      { name: "Al Kufrah", code: "LY-KF" }
    ]
  },
  [countryCodes.MOROCCO.alphaTwo]: {
    subdivisions: [
      { name: "Beni-Mellal-Khenifra", code: "MA-05" },
      { name: "Casablanca-Settat", code: "MA-06" },
      { name: "Draa-Tafilalet", code: "MA-08" },
      { name: "Fes- Meknes", code: "MA-03" },
      { name: "Guelmim-Oued Noun (EH-partial)", code: "MA-10" },
      { name: "L'Oriental", code: "MA-02" },
      { name: "Laayoune-Sakia El Hamra (EH-partial)", code: "MA-11" },
      { name: "Marrakech-Safi", code: "MA-07" },
      { name: "Rabat-Sale-Kenitra", code: "MA-04" },
      { name: "Souss-Massa", code: "MA-09" },
      { name: "Tanger-Tetouan-Al Hoceima", code: "MA-01" },
      { name: "Dakhla-Oued Ed-Dahab (EH)", code: "MA-12" }
    ]
  },
  [countryCodes.MONACO.alphaTwo]: {
    subdivisions: [
      { name: "Fontvieille", code: "MC-FO" },
      { name: "La Condamine", code: "MC-CO" },
      { name: "Monaco-Ville", code: "MC-MO" },
      { name: "Moneghetti", code: "MC-MG" },
      { name: "Monte-Carlo", code: "MC-MC" },
      { name: "Saint-Roman", code: "MC-SR" },
      { name: "La Colle", code: "MC-CL" },
      { name: "La Gare", code: "MC-GA" },
      { name: "Jardin Exotique", code: "MC-JE" },
      { name: "Larvotto", code: "MC-LA" },
      { name: "Malbousquet", code: "MC-MA" },
      { name: "Moulins", code: "MC-MU" },
      { name: "Port-Hercule", code: "MC-PH" },
      { name: "Sainte-Devote", code: "MC-SD" },
      { name: "La Source", code: "MC-SO" },
      { name: "Spelugues", code: "MC-SP" },
      { name: "Vallon de la Rousse", code: "MC-VR" }
    ]
  },
  [countryCodes.MOLDOVA_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Anenii Noi", code: "MD-AN" },
      { name: "Balti", code: "MD-BA" },
      { name: "Basarabeasca", code: "MD-BS" },
      { name: "Bender", code: "MD-BD" },
      { name: "Briceni", code: "MD-BR" },
      { name: "Cahul", code: "MD-CA" },
      { name: "Calarasi", code: "MD-CL" },
      { name: "Cantemir", code: "MD-CT" },
      { name: "Causeni", code: "MD-CS" },
      { name: "Chisinau", code: "MD-CU" },
      { name: "Cimislia", code: "MD-CM" },
      { name: "Criuleni", code: "MD-CR" },
      { name: "Donduseni", code: "MD-DO" },
      { name: "Drochia", code: "MD-DR" },
      { name: "Dubasari", code: "MD-DU" },
      { name: "Edinet", code: "MD-ED" },
      { name: "Falesti", code: "MD-FA" },
      { name: "Floresti", code: "MD-FL" },
      { name: "Gagauzia, Unitatea teritoriala autonoma", code: "MD-GA" },
      { name: "Glodeni", code: "MD-GL" },
      { name: "Hincesti", code: "MD-HI" },
      { name: "Ialoveni", code: "MD-IA" },
      { name: "Leova", code: "MD-LE" },
      { name: "Nisporeni", code: "MD-NI" },
      { name: "Ocnita", code: "MD-OC" },
      { name: "Orhei", code: "MD-OR" },
      { name: "Rezina", code: "MD-RE" },
      { name: "Riscani", code: "MD-RI" },
      { name: "Singerei", code: "MD-SI" },
      { name: "Soldanesti", code: "MD-SD" },
      { name: "Soroca", code: "MD-SO" },
      { name: "Stefan Voda", code: "MD-SV" },
      { name: "Stinga Nistrului, unitatea teritoriala din", code: "MD-SN" },
      { name: "Straseni", code: "MD-ST" },
      { name: "Taraclia", code: "MD-TA" },
      { name: "Telenesti", code: "MD-TE" },
      { name: "Ungheni", code: "MD-UN" }
    ]
  },
  [countryCodes.MONTENEGRO.alphaTwo]: {
    subdivisions: [
      { name: "Andrijevica", code: "ME-01" },
      { name: "Bar", code: "ME-02" },
      { name: "Berane", code: "ME-03" },
      { name: "Bijelo Polje", code: "ME-04" },
      { name: "Budva", code: "ME-05" },
      { name: "Cetinje", code: "ME-06" },
      { name: "Danilovgrad", code: "ME-07" },
      { name: "Herceg-Novi", code: "ME-08" },
      { name: "Kolasin", code: "ME-09" },
      { name: "Kotor", code: "ME-10" },
      { name: "Mojkovac", code: "ME-11" },
      { name: "Niksic", code: "ME-12" },
      { name: "Plav", code: "ME-13" },
      { name: "Pljevlja", code: "ME-14" },
      { name: "Pluzine", code: "ME-15" },
      { name: "Podgorica", code: "ME-16" },
      { name: "Rozaje", code: "ME-17" },
      { name: "Savnik", code: "ME-18" },
      { name: "Tivat", code: "ME-19" },
      { name: "Tuzi", code: "ME-24" },
      { name: "Ulcinj", code: "ME-20" },
      { name: "Zabljak", code: "ME-21" },
      { name: "Zeta", code: "ME-25" },
      { name: "Gusinje", code: "ME-22" },
      { name: "Petnjica", code: "ME-23" }
    ]
  },
  [countryCodes.SAINT_MARTIN_FRANCE.alphaTwo]: {
    subdivisions: [{ name: "Saint Martin (French Part)", code: "-" }]
  },
  [countryCodes.MADAGASCAR.alphaTwo]: {
    subdivisions: [
      { name: "Antananarivo", code: "MG-T" },
      { name: "Antsiranana", code: "MG-D" },
      { name: "Fianarantsoa", code: "MG-F" },
      { name: "Mahajanga", code: "MG-M" },
      { name: "Toamasina", code: "MG-A" },
      { name: "Toliara", code: "MG-U" }
    ]
  },
  [countryCodes.MARSHALL_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Kwajalein", code: "MH-KWA" },
      { name: "Majuro", code: "MH-MAJ" },
      { name: "Ailuk", code: "MH-ALK" },
      { name: "Ailinglaplap", code: "MH-ALL" },
      { name: "Arno", code: "MH-ARN" },
      { name: "Aur", code: "MH-AUR" },
      { name: "Ebon", code: "MH-EBO" },
      { name: "Enewetak & Ujelang", code: "MH-ENI" },
      { name: "Jabat", code: "MH-JAB" },
      { name: "Jaluit", code: "MH-JAL" },
      { name: "Bikini & Kili", code: "MH-KIL" },
      { name: "Lae", code: "MH-LAE" },
      { name: "Lib", code: "MH-LIB" },
      { name: "Likiep", code: "MH-LIK" },
      { name: "Maloelap", code: "MH-MAL" },
      { name: "Mejit", code: "MH-MEJ" },
      { name: "Mili", code: "MH-MIL" },
      { name: "Namdrik", code: "MH-NMK" },
      { name: "Namu", code: "MH-NMU" },
      { name: "Rongelap", code: "MH-RON" },
      { name: "Ujae", code: "MH-UJA" },
      { name: "Utrik", code: "MH-UTI" },
      { name: "Wotho", code: "MH-WTH" },
      { name: "Wotje", code: "MH-WTJ" }
    ]
  },
  [countryCodes.NORTH_MACEDONIA_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Aracinovo", code: "MK-802" },
      { name: "Berovo", code: "MK-201" },
      { name: "Bitola", code: "MK-501" },
      { name: "Bogdanci", code: "MK-401" },
      { name: "Bogovinje", code: "MK-601" },
      { name: "Bosilovo", code: "MK-402" },
      { name: "Brvenica", code: "MK-602" },
      { name: "Butel", code: "MK-803" },
      { name: "Caska", code: "MK-109" },
      { name: "Centar", code: "MK-814" },
      { name: "Cesinovo-Oblesevo", code: "MK-210" },
      { name: "Cucer Sandevo", code: "MK-816" },
      { name: "Debar", code: "MK-303" },
      { name: "Delcevo", code: "MK-203" },
      { name: "Demir Hisar", code: "MK-502" },
      { name: "Demir Kapija", code: "MK-103" },
      { name: "Dojran", code: "MK-406" },
      { name: "Gazi Baba", code: "MK-804" },
      { name: "Gevgelija", code: "MK-405" },
      { name: "Gostivar", code: "MK-604" },
      { name: "Gradsko", code: "MK-102" },
      { name: "Ilinden", code: "MK-807" },
      { name: "Jegunovce", code: "MK-606" },
      { name: "Kavadarci", code: "MK-104" },
      { name: "Kicevo", code: "MK-307" },
      { name: "Kisela Voda", code: "MK-809" },
      { name: "Kocani", code: "MK-206" },
      { name: "Kratovo", code: "MK-701" },
      { name: "Kriva Palanka", code: "MK-702" },
      { name: "Krivogastani", code: "MK-504" },
      { name: "Krusevo", code: "MK-505" },
      { name: "Kumanovo", code: "MK-703" },
      { name: "Lipkovo", code: "MK-704" },
      { name: "Lozovo", code: "MK-105" },
      { name: "Makedonska Kamenica", code: "MK-207" },
      { name: "Makedonski Brod", code: "MK-308" },
      { name: "Mavrovo i Rostusa", code: "MK-607" },
      { name: "Mogila", code: "MK-506" },
      { name: "Negotino", code: "MK-106" },
      { name: "Novo Selo", code: "MK-408" },
      { name: "Ohrid", code: "MK-310" },
      { name: "Pehcevo", code: "MK-208" },
      { name: "Petrovec", code: "MK-810" },
      { name: "Plasnica", code: "MK-311" },
      { name: "Prilep", code: "MK-508" },
      { name: "Probistip", code: "MK-209" },
      { name: "Radovis", code: "MK-409" },
      { name: "Rankovce", code: "MK-705" },
      { name: "Resen", code: "MK-509" },
      { name: "Saraj", code: "MK-811" },
      { name: "Sopiste", code: "MK-812" },
      { name: "Stip", code: "MK-211" },
      { name: "Struga", code: "MK-312" },
      { name: "Strumica", code: "MK-410" },
      { name: "Studenicani", code: "MK-813" },
      { name: "Sveti Nikole", code: "MK-108" },
      { name: "Tearce", code: "MK-608" },
      { name: "Tetovo", code: "MK-609" },
      { name: "Valandovo", code: "MK-403" },
      { name: "Vasilevo", code: "MK-404" },
      { name: "Veles", code: "MK-101" },
      { name: "Vevcani", code: "MK-301" },
      { name: "Vinica", code: "MK-202" },
      { name: "Vrapciste", code: "MK-603" },
      { name: "Zelenikovo", code: "MK-806" },
      { name: "Zelino", code: "MK-605" },
      { name: "Zrnovci", code: "MK-204" },
      { name: "Rosoman", code: "MK-107" },
      { name: "Karbinci", code: "MK-205" },
      { name: "Debrca", code: "MK-304" },
      { name: "Centar Zupa", code: "MK-313" },
      { name: "Konce", code: "MK-407" },
      { name: "Dolneni", code: "MK-503" },
      { name: "Novaci", code: "MK-507" },
      { name: "Staro Nagoricane", code: "MK-706" },
      { name: "Aerodrom", code: "MK-801" },
      { name: "Gjorce Petrov", code: "MK-805" },
      { name: "Karpos", code: "MK-808" },
      { name: "Cair", code: "MK-815" },
      { name: "Suto Orizari", code: "MK-817" }
    ]
  },
  [countryCodes.MALI.alphaTwo]: {
    subdivisions: [
      { name: "Bamako", code: "ML-BKO" },
      { name: "Gao", code: "ML-7" },
      { name: "Kayes", code: "ML-1" },
      { name: "Kidal", code: "ML-8" },
      { name: "Koulikoro", code: "ML-2" },
      { name: "Mopti", code: "ML-5" },
      { name: "Segou", code: "ML-4" },
      { name: "Sikasso", code: "ML-3" },
      { name: "Tombouctou", code: "ML-6" },
      { name: "Taoudenit", code: "ML-10" },
      { name: "Menaka", code: "ML-9" }
    ]
  },
  [countryCodes.MYANMAR.alphaTwo]: {
    subdivisions: [
      { name: "Ayeyarwady", code: "MM-07" },
      { name: "Bago", code: "MM-02" },
      { name: "Chin", code: "MM-14" },
      { name: "Kachin", code: "MM-11" },
      { name: "Kayah", code: "MM-12" },
      { name: "Kayin", code: "MM-13" },
      { name: "Magway", code: "MM-03" },
      { name: "Mandalay", code: "MM-04" },
      { name: "Mon", code: "MM-15" },
      { name: "Nay Pyi Taw", code: "MM-18" },
      { name: "Rakhine", code: "MM-16" },
      { name: "Sagaing", code: "MM-01" },
      { name: "Shan", code: "MM-17" },
      { name: "Tanintharyi", code: "MM-05" },
      { name: "Yangon", code: "MM-06" }
    ]
  },
  [countryCodes.MONGOLIA.alphaTwo]: {
    subdivisions: [
      { name: "Arhangay", code: "MN-073" },
      { name: "Bayan-Olgiy", code: "MN-071" },
      { name: "Bayanhongor", code: "MN-069" },
      { name: "Bulgan", code: "MN-067" },
      { name: "Darhan uul", code: "MN-037" },
      { name: "Dundgovi", code: "MN-059" },
      { name: "Dzavhan", code: "MN-057" },
      { name: "Govi-Altay", code: "MN-065" },
      { name: "Hovd", code: "MN-043" },
      { name: "Hovsgol", code: "MN-041" },
      { name: "Omnogovi", code: "MN-053" },
      { name: "Orhon", code: "MN-035" },
      { name: "Ovorhangay", code: "MN-055" },
      { name: "Selenge", code: "MN-049" },
      { name: "Tov", code: "MN-047" },
      { name: "Ulaanbaatar", code: "MN-1" },
      { name: "Uvs", code: "MN-046" },
      { name: "Hentiy", code: "MN-039" },
      { name: "Suhbaatar", code: "MN-051" },
      { name: "Dornod", code: "MN-061" },
      { name: "Dornogovi", code: "MN-063" },
      { name: "Govi-Sumber", code: "MN-064" }
    ]
  },
  [countryCodes.MACAU.alphaTwo]: { subdivisions: [{ name: "Macao", code: "-" }] },
  [countryCodes.NORTHERN_MARIANA_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Northern Mariana Islands", code: "-" }]
  },
  [countryCodes.MARTINIQUE.alphaTwo]: { subdivisions: [{ name: "Martinique", code: "-" }] },
  [countryCodes.MAURITANIA.alphaTwo]: {
    subdivisions: [
      { name: "Adrar", code: "MR-07" },
      { name: "Brakna", code: "MR-05" },
      { name: "Dakhlet Nouadhibou", code: "MR-08" },
      { name: "Gorgol", code: "MR-04" },
      { name: "Guidimaka", code: "MR-10" },
      { name: "Hodh ech Chargui", code: "MR-01" },
      { name: "Hodh el Gharbi", code: "MR-02" },
      { name: "Inchiri", code: "MR-12" },
      { name: "Nouakchott Ouest", code: "MR-13" },
      { name: "Tiris Zemmour", code: "MR-11" },
      { name: "Trarza", code: "MR-06" },
      { name: "Assaba", code: "MR-03" },
      { name: "Tagant", code: "MR-09" },
      { name: "Nouakchott Nord", code: "MR-14" },
      { name: "Nouakchott Sud", code: "MR-15" }
    ]
  },
  [countryCodes.MONTSERRAT.alphaTwo]: {
    subdivisions: [
      { name: "Saint Anthony", code: "-" },
      { name: "Saint Peter", code: "-" }
    ]
  },
  [countryCodes.MALTA.alphaTwo]: {
    subdivisions: [
      { name: "Attard", code: "MT-01" },
      { name: "Balzan", code: "MT-02" },
      { name: "Birgu", code: "MT-03" },
      { name: "Birkirkara", code: "MT-04" },
      { name: "Birzebbuga", code: "MT-05" },
      { name: "Bormla", code: "MT-06" },
      { name: "Dingli", code: "MT-07" },
      { name: "Fgura", code: "MT-08" },
      { name: "Floriana", code: "MT-09" },
      { name: "Fontana", code: "MT-10" },
      { name: "Ghajnsielem", code: "MT-13" },
      { name: "Gharb", code: "MT-14" },
      { name: "Gharghur", code: "MT-15" },
      { name: "Ghasri", code: "MT-16" },
      { name: "Ghaxaq", code: "MT-17" },
      { name: "Gudja", code: "MT-11" },
      { name: "Gzira", code: "MT-12" },
      { name: "Hamrun", code: "MT-18" },
      { name: "Iklin", code: "MT-19" },
      { name: "Isla", code: "MT-20" },
      { name: "Kalkara", code: "MT-21" },
      { name: "Kercem", code: "MT-22" },
      { name: "Kirkop", code: "MT-23" },
      { name: "Lija", code: "MT-24" },
      { name: "Luqa", code: "MT-25" },
      { name: "Marsa", code: "MT-26" },
      { name: "Marsaskala", code: "MT-27" },
      { name: "Marsaxlokk", code: "MT-28" },
      { name: "Mdina", code: "MT-29" },
      { name: "Mellieha", code: "MT-30" },
      { name: "Mgarr", code: "MT-31" },
      { name: "Mosta", code: "MT-32" },
      { name: "Mqabba", code: "MT-33" },
      { name: "Msida", code: "MT-34" },
      { name: "Mtarfa", code: "MT-35" },
      { name: "Munxar", code: "MT-36" },
      { name: "Nadur", code: "MT-37" },
      { name: "Naxxar", code: "MT-38" },
      { name: "Paola", code: "MT-39" },
      { name: "Pembroke", code: "MT-40" },
      { name: "Pieta", code: "MT-41" },
      { name: "Qala", code: "MT-42" },
      { name: "Qormi", code: "MT-43" },
      { name: "Qrendi", code: "MT-44" },
      { name: "Rabat Gozo", code: "MT-45" },
      { name: "Rabat Malta", code: "MT-46" },
      { name: "Safi", code: "MT-47" },
      { name: "Saint John", code: "MT-49" },
      { name: "Saint Julian's", code: "MT-48" },
      { name: "Saint Lucia's", code: "MT-53" },
      { name: "Saint Paul's Bay", code: "MT-51" },
      { name: "Sannat", code: "MT-52" },
      { name: "Santa Venera", code: "MT-54" },
      { name: "Siggiewi", code: "MT-55" },
      { name: "Sliema", code: "MT-56" },
      { name: "Swieqi", code: "MT-57" },
      { name: "Ta' Xbiex", code: "MT-58" },
      { name: "Tarxien", code: "MT-59" },
      { name: "Valletta", code: "MT-60" },
      { name: "Xaghra", code: "MT-61" },
      { name: "Xewkija", code: "MT-62" },
      { name: "Xghajra", code: "MT-63" },
      { name: "Zabbar", code: "MT-64" },
      { name: "Zebbug Gozo", code: "MT-65" },
      { name: "Zejtun", code: "MT-67" },
      { name: "Zurrieq", code: "MT-68" },
      { name: "Saint Lawrence", code: "MT-50" },
      { name: "Zebbug Malta", code: "MT-66" }
    ]
  },
  [countryCodes.MAURITIUS.alphaTwo]: {
    subdivisions: [
      { name: "Black River", code: "MU-BL" },
      { name: "Flacq", code: "MU-FL" },
      { name: "Grand Port", code: "MU-GP" },
      { name: "Moka", code: "MU-MO" },
      { name: "Pamplemousses", code: "MU-PA" },
      { name: "Plaines Wilhems", code: "MU-PW" },
      { name: "Port Louis", code: "MU-PL" },
      { name: "Riviere du Rempart", code: "MU-RR" },
      { name: "Rodrigues Islands", code: "MU-RO" },
      { name: "Savanne", code: "MU-SA" },
      { name: "Agalega Islands", code: "MU-AG" },
      { name: "Cargados Carajos Shoals", code: "MU-CC" }
    ]
  },
  [countryCodes.MALDIVES.alphaTwo]: {
    subdivisions: [
      { name: "Addu City", code: "MV-01" },
      { name: "Faadhippolhu", code: "MV-03" },
      { name: "Felidhu Atoll", code: "MV-04" },
      { name: "Fuvammulah", code: "MV-29" },
      { name: "Hahdhunmathi", code: "MV-05" },
      { name: "Kolhumadulu", code: "MV-08" },
      { name: "Male", code: "MV-MLE" },
      { name: "Mulaku Atoll", code: "MV-12" },
      { name: "North Ari Atoll", code: "MV-02" },
      { name: "North Huvadhu Atoll", code: "MV-27" },
      { name: "North Miladhunmadulu", code: "MV-24" },
      { name: "North Nilandhe Atoll", code: "MV-14" },
      { name: "North Thiladhunmathi", code: "MV-07" },
      { name: "South Ari Atoll", code: "MV-00" },
      { name: "South Huvadhu Atoll", code: "MV-28" },
      { name: "South Maalhosmadulu", code: "MV-20" },
      { name: "South Miladhunmadulu", code: "MV-25" },
      { name: "South Nilandhe Atoll", code: "MV-17" },
      { name: "South Thiladhunmathi", code: "MV-23" },
      { name: "North Maalhosmadulu", code: "MV-13" },
      { name: "Male Atoll", code: "MV-26" }
    ]
  },
  [countryCodes.MALAWI.alphaTwo]: {
    subdivisions: [
      { name: "Balaka", code: "MW-BA" },
      { name: "Blantyre", code: "MW-BL" },
      { name: "Chikwawa", code: "MW-CK" },
      { name: "Chiradzulu", code: "MW-CR" },
      { name: "Dedza", code: "MW-DE" },
      { name: "Dowa", code: "MW-DO" },
      { name: "Karonga", code: "MW-KR" },
      { name: "Kasungu", code: "MW-KS" },
      { name: "Lilongwe", code: "MW-LI" },
      { name: "Machinga", code: "MW-MH" },
      { name: "Mangochi", code: "MW-MG" },
      { name: "Mwanza", code: "MW-MW" },
      { name: "Mzimba", code: "MW-MZ" },
      { name: "Nkhotakota", code: "MW-NK" },
      { name: "Ntcheu", code: "MW-NU" },
      { name: "Ntchisi", code: "MW-NI" },
      { name: "Salima", code: "MW-SA" },
      { name: "Zomba", code: "MW-ZO" },
      { name: "Chitipa", code: "MW-CT" },
      { name: "Likoma", code: "MW-LK" },
      { name: "Mchinji", code: "MW-MC" },
      { name: "Mulanje", code: "MW-MU" },
      { name: "Nkhata Bay", code: "MW-NB" },
      { name: "Neno", code: "MW-NE" },
      { name: "Nsanje", code: "MW-NS" },
      { name: "Phalombe", code: "MW-PH" },
      { name: "Rumphi", code: "MW-RU" },
      { name: "Thyolo", code: "MW-TH" }
    ]
  },
  [countryCodes.MEXICO.alphaTwo]: {
    subdivisions: [
      { name: "Aguascalientes", code: "MX-AGU" },
      { name: "Baja California", code: "MX-BCN" },
      { name: "Baja California Sur", code: "MX-BCS" },
      { name: "Campeche", code: "MX-CAM" },
      { name: "Chiapas", code: "MX-CHP" },
      { name: "Chihuahua", code: "MX-CHH" },
      { name: "Ciudad de Mexico", code: "MX-CMX" },
      { name: "Coahuila de Zaragoza", code: "MX-COA" },
      { name: "Colima", code: "MX-COL" },
      { name: "Durango", code: "MX-DUR" },
      { name: "Guanajuato", code: "MX-GUA" },
      { name: "Guerrero", code: "MX-GRO" },
      { name: "Hidalgo", code: "MX-HID" },
      { name: "Jalisco", code: "MX-JAL" },
      { name: "Mexico", code: "MX-MEX" },
      { name: "Michoacan de Ocampo", code: "MX-MIC" },
      { name: "Morelos", code: "MX-MOR" },
      { name: "Nayarit", code: "MX-NAY" },
      { name: "Nuevo Leon", code: "MX-NLE" },
      { name: "Oaxaca", code: "MX-OAX" },
      { name: "Puebla", code: "MX-PUE" },
      { name: "Queretaro", code: "MX-QUE" },
      { name: "Quintana Roo", code: "MX-ROO" },
      { name: "San Luis Potosi", code: "MX-SLP" },
      { name: "Sinaloa", code: "MX-SIN" },
      { name: "Sonora", code: "MX-SON" },
      { name: "Tabasco", code: "MX-TAB" },
      { name: "Tamaulipas", code: "MX-TAM" },
      { name: "Tlaxcala", code: "MX-TLA" },
      { name: "Veracruz de Ignacio de la Llave", code: "MX-VER" },
      { name: "Yucatan", code: "MX-YUC" },
      { name: "Zacatecas", code: "MX-ZAC" }
    ]
  },
  [countryCodes.MALAYSIA.alphaTwo]: {
    subdivisions: [
      { name: "Johor", code: "MY-01" },
      { name: "Kedah", code: "MY-02" },
      { name: "Kelantan", code: "MY-03" },
      { name: "Melaka", code: "MY-04" },
      { name: "Negeri Sembilan", code: "MY-05" },
      { name: "Pahang", code: "MY-06" },
      { name: "Perak", code: "MY-08" },
      { name: "Perlis", code: "MY-09" },
      { name: "Pulau Pinang", code: "MY-07" },
      { name: "Sabah", code: "MY-12" },
      { name: "Sarawak", code: "MY-13" },
      { name: "Selangor", code: "MY-10" },
      { name: "Terengganu", code: "MY-11" },
      { name: "Wilayah Persekutuan Kuala Lumpur", code: "MY-14" },
      { name: "Wilayah Persekutuan Labuan", code: "MY-15" },
      { name: "Wilayah Persekutuan Putrajaya", code: "MY-16" }
    ]
  },
  [countryCodes.MOZAMBIQUE.alphaTwo]: {
    subdivisions: [
      { name: "Cabo Delgado", code: "MZ-P" },
      { name: "Gaza", code: "MZ-G" },
      { name: "Inhambane", code: "MZ-I" },
      { name: "Manica", code: "MZ-B" },
      { name: "Maputo", code: "MZ-L" },
      { name: "Nampula", code: "MZ-N" },
      { name: "Niassa", code: "MZ-A" },
      { name: "Sofala", code: "MZ-S" },
      { name: "Tete", code: "MZ-T" },
      { name: "Zambezia", code: "MZ-Q" }
    ]
  },
  [countryCodes.NAMIBIA.alphaTwo]: {
    subdivisions: [
      { name: "Erongo", code: "NA-ER" },
      { name: "Hardap", code: "NA-HA" },
      { name: "Karas", code: "NA-KA" },
      { name: "Kavango East", code: "NA-KE" },
      { name: "Khomas", code: "NA-KH" },
      { name: "Kunene", code: "NA-KU" },
      { name: "Ohangwena", code: "NA-OW" },
      { name: "Omaheke", code: "NA-OH" },
      { name: "Omusati", code: "NA-OS" },
      { name: "Oshana", code: "NA-ON" },
      { name: "Oshikoto", code: "NA-OT" },
      { name: "Otjozondjupa", code: "NA-OD" },
      { name: "Zambezi", code: "NA-CA" }
    ]
  },
  [countryCodes.NEW_CALEDONIA.alphaTwo]: {
    subdivisions: [
      { name: "Province Nord", code: "-" },
      { name: "Province Sud", code: "-" },
      { name: "Province des iles Loyaute", code: "-" }
    ]
  },
  [countryCodes.NIGER.alphaTwo]: {
    subdivisions: [
      { name: "Agadez", code: "NE-1" },
      { name: "Diffa", code: "NE-2" },
      { name: "Dosso", code: "NE-3" },
      { name: "Maradi", code: "NE-4" },
      { name: "Niamey", code: "NE-8" },
      { name: "Tahoua", code: "NE-5" },
      { name: "Tillaberi", code: "NE-6" },
      { name: "Zinder", code: "NE-7" }
    ]
  },
  [countryCodes.NORFOLK_ISLAND.alphaTwo]: { subdivisions: [{ name: "Norfolk Island", code: "-" }] },
  [countryCodes.NIGERIA.alphaTwo]: {
    subdivisions: [
      { name: "Abia", code: "NG-AB" },
      { name: "Abuja Federal Capital Territory", code: "NG-FC" },
      { name: "Adamawa", code: "NG-AD" },
      { name: "Akwa Ibom", code: "NG-AK" },
      { name: "Anambra", code: "NG-AN" },
      { name: "Bauchi", code: "NG-BA" },
      { name: "Bayelsa", code: "NG-BY" },
      { name: "Benue", code: "NG-BE" },
      { name: "Borno", code: "NG-BO" },
      { name: "Cross River", code: "NG-CR" },
      { name: "Delta", code: "NG-DE" },
      { name: "Ebonyi", code: "NG-EB" },
      { name: "Edo", code: "NG-ED" },
      { name: "Ekiti", code: "NG-EK" },
      { name: "Enugu", code: "NG-EN" },
      { name: "Gombe", code: "NG-GO" },
      { name: "Imo", code: "NG-IM" },
      { name: "Jigawa", code: "NG-JI" },
      { name: "Kaduna", code: "NG-KD" },
      { name: "Kano", code: "NG-KN" },
      { name: "Katsina", code: "NG-KT" },
      { name: "Kebbi", code: "NG-KE" },
      { name: "Kogi", code: "NG-KO" },
      { name: "Kwara", code: "NG-KW" },
      { name: "Lagos", code: "NG-LA" },
      { name: "Nasarawa", code: "NG-NA" },
      { name: "Niger", code: "NG-NI" },
      { name: "Ogun", code: "NG-OG" },
      { name: "Ondo", code: "NG-ON" },
      { name: "Osun", code: "NG-OS" },
      { name: "Oyo", code: "NG-OY" },
      { name: "Plateau", code: "NG-PL" },
      { name: "Rivers", code: "NG-RI" },
      { name: "Sokoto", code: "NG-SO" },
      { name: "Taraba", code: "NG-TA" },
      { name: "Yobe", code: "NG-YO" },
      { name: "Zamfara", code: "NG-ZA" }
    ]
  },
  [countryCodes.NICARAGUA.alphaTwo]: {
    subdivisions: [
      { name: "Boaco", code: "NI-BO" },
      { name: "Carazo", code: "NI-CA" },
      { name: "Chinandega", code: "NI-CI" },
      { name: "Chontales", code: "NI-CO" },
      { name: "Costa Caribe Norte", code: "NI-AN" },
      { name: "Costa Caribe Sur", code: "NI-AS" },
      { name: "Esteli", code: "NI-ES" },
      { name: "Granada", code: "NI-GR" },
      { name: "Jinotega", code: "NI-JI" },
      { name: "Leon", code: "NI-LE" },
      { name: "Madriz", code: "NI-MD" },
      { name: "Managua", code: "NI-MN" },
      { name: "Masaya", code: "NI-MS" },
      { name: "Matagalpa", code: "NI-MT" },
      { name: "Nueva Segovia", code: "NI-NS" },
      { name: "Rio San Juan", code: "NI-SJ" },
      { name: "Rivas", code: "NI-RI" }
    ]
  },
  [countryCodes.NETHERLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Drenthe", code: "NL-DR" },
      { name: "Flevoland", code: "NL-FL" },
      { name: "Fryslan", code: "NL-FR" },
      { name: "Gelderland", code: "NL-GE" },
      { name: "Groningen", code: "NL-GR" },
      { name: "Limburg", code: "NL-LI" },
      { name: "Noord-Brabant", code: "NL-NB" },
      { name: "Noord-Holland", code: "NL-NH" },
      { name: "Overijssel", code: "NL-OV" },
      { name: "Utrecht", code: "NL-UT" },
      { name: "Zeeland", code: "NL-ZE" },
      { name: "Zuid-Holland", code: "NL-ZH" }
    ]
  },
  [countryCodes.NORWAY.alphaTwo]: {
    subdivisions: [
      { name: "Agder", code: "NO-42" },
      { name: "Innlandet", code: "NO-34" },
      { name: "More og Romsdal", code: "NO-15" },
      { name: "Nordland", code: "NO-18" },
      { name: "Oslo", code: "NO-03" },
      { name: "Rogaland", code: "NO-11" },
      { name: "Troms og Finnmark", code: "NO-54" },
      { name: "Trondelag", code: "NO-50" },
      { name: "Vestfold og Telemark", code: "NO-38" },
      { name: "Vestland", code: "NO-46" },
      { name: "Viken", code: "NO-30" }
    ]
  },
  [countryCodes.NEPAL.alphaTwo]: {
    subdivisions: [
      { name: "Bagmati", code: "NP-P3" },
      { name: "Gandaki", code: "NP-P4" },
      { name: "Karnali", code: "NP-P6" },
      { name: "Koshi", code: "NP-P1" },
      { name: "Lumbini", code: "NP-P5" },
      { name: "Madhesh", code: "NP-P2" },
      { name: "Sudurpashchim", code: "NP-P7" }
    ]
  },
  [countryCodes.NAURU.alphaTwo]: {
    subdivisions: [
      { name: "Aiwo", code: "NR-01" },
      { name: "Yaren", code: "NR-14" },
      { name: "Anabar", code: "NR-02" },
      { name: "Anetan", code: "NR-03" },
      { name: "Anibare", code: "NR-04" },
      { name: "Baitsi", code: "NR-05" },
      { name: "Boe", code: "NR-06" },
      { name: "Buada", code: "NR-07" },
      { name: "Denigomodu", code: "NR-08" },
      { name: "Ewa", code: "NR-09" },
      { name: "Ijuw", code: "NR-10" },
      { name: "Meneng", code: "NR-11" },
      { name: "Nibok", code: "NR-12" },
      { name: "Uaboe", code: "NR-13" }
    ]
  },
  [countryCodes.NIUE.alphaTwo]: { subdivisions: [{ name: "Niue", code: "-" }] },
  [countryCodes.NEW_ZEALAND.alphaTwo]: {
    subdivisions: [
      { name: "Auckland", code: "NZ-AUK" },
      { name: "Bay of Plenty", code: "NZ-BOP" },
      { name: "Canterbury", code: "NZ-CAN" },
      { name: "Chatham Islands Territory", code: "NZ-CIT" },
      { name: "Gisborne", code: "NZ-GIS" },
      { name: "Greater Wellington", code: "NZ-WGN" },
      { name: "Hawke's Bay", code: "NZ-HKB" },
      { name: "Manawatu-Whanganui", code: "NZ-MWT" },
      { name: "Marlborough", code: "NZ-MBH" },
      { name: "Nelson", code: "NZ-NSN" },
      { name: "Northland", code: "NZ-NTL" },
      { name: "Otago", code: "NZ-OTA" },
      { name: "Southland", code: "NZ-STL" },
      { name: "Taranaki", code: "NZ-TKI" },
      { name: "Tasman", code: "NZ-TAS" },
      { name: "Waikato", code: "NZ-WKO" },
      { name: "West Coast", code: "NZ-WTC" }
    ]
  },
  [countryCodes.OMAN.alphaTwo]: {
    subdivisions: [
      { name: "Ad Dakhiliyah", code: "OM-DA" },
      { name: "Al Buraymi", code: "OM-BU" },
      { name: "Al Wusta", code: "OM-WU" },
      { name: "Az Zahirah", code: "OM-ZA" },
      { name: "Janub al Batinah", code: "OM-BJ" },
      { name: "Janub ash Sharqiyah", code: "OM-SJ" },
      { name: "Masqat", code: "OM-MA" },
      { name: "Musandam", code: "OM-MU" },
      { name: "Shamal al Batinah", code: "OM-BS" },
      { name: "Shamal ash Sharqiyah", code: "OM-SS" },
      { name: "Zufar", code: "OM-ZU" }
    ]
  },
  [countryCodes.PANAMA.alphaTwo]: {
    subdivisions: [
      { name: "Bocas del Toro", code: "PA-1" },
      { name: "Chiriqui", code: "PA-4" },
      { name: "Cocle", code: "PA-2" },
      { name: "Colon", code: "PA-3" },
      { name: "Darien", code: "PA-5" },
      { name: "Herrera", code: "PA-6" },
      { name: "Los Santos", code: "PA-7" },
      { name: "Ngobe-Bugle", code: "PA-NB" },
      { name: "Panama", code: "PA-8" },
      { name: "Veraguas", code: "PA-9" },
      { name: "Panama Oeste", code: "PA-10" },
      { name: "Embera", code: "PA-EM" },
      { name: "Guna Yala", code: "PA-KY" },
      { name: "Naso Tjer Di", code: "PA-NT" }
    ]
  },
  [countryCodes.PERU.alphaTwo]: {
    subdivisions: [
      { name: "Amazonas", code: "PE-AMA" },
      { name: "Ancash", code: "PE-ANC" },
      { name: "Apurimac", code: "PE-APU" },
      { name: "Arequipa", code: "PE-ARE" },
      { name: "Ayacucho", code: "PE-AYA" },
      { name: "Cajamarca", code: "PE-CAJ" },
      { name: "Cusco", code: "PE-CUS" },
      { name: "El Callao", code: "PE-CAL" },
      { name: "Huancavelica", code: "PE-HUV" },
      { name: "Huanuco", code: "PE-HUC" },
      { name: "Ica", code: "PE-ICA" },
      { name: "Junin", code: "PE-JUN" },
      { name: "La Libertad", code: "PE-LAL" },
      { name: "Lambayeque", code: "PE-LAM" },
      { name: "Lima", code: "PE-LIM" },
      { name: "Loreto", code: "PE-LOR" },
      { name: "Madre de Dios", code: "PE-MDD" },
      { name: "Moquegua", code: "PE-MOQ" },
      { name: "Pasco", code: "PE-PAS" },
      { name: "Piura", code: "PE-PIU" },
      { name: "Puno", code: "PE-PUN" },
      { name: "San Martin", code: "PE-SAM" },
      { name: "Tacna", code: "PE-TAC" },
      { name: "Tumbes", code: "PE-TUM" },
      { name: "Ucayali", code: "PE-UCA" },
      { name: "Municipalidad Metropolitana de Lima", code: "PE-LMA" }
    ]
  },
  [countryCodes.FRENCH_POLYNESIA.alphaTwo]: {
    subdivisions: [
      { name: "Iles Australes", code: "-" },
      { name: "Iles Marquises", code: "-" },
      { name: "Iles Sous-le-Vent", code: "-" },
      { name: "Iles Tuamotu-Gambier", code: "-" },
      { name: "Iles du Vent", code: "-" }
    ]
  },
  [countryCodes.PAPUA_NEW_GUINEA.alphaTwo]: {
    subdivisions: [
      { name: "Bougainville", code: "PG-NSB" },
      { name: "Central", code: "PG-CPM" },
      { name: "East New Britain", code: "PG-EBR" },
      { name: "Eastern Highlands", code: "PG-EHG" },
      { name: "Enga", code: "PG-EPW" },
      { name: "Madang", code: "PG-MPM" },
      { name: "Manus", code: "PG-MRL" },
      { name: "Milne Bay", code: "PG-MBA" },
      { name: "Morobe", code: "PG-MPL" },
      { name: "National Capital District (Port Moresby)", code: "PG-NCD" },
      { name: "New Ireland", code: "PG-NIK" },
      { name: "Northern", code: "PG-NPP" },
      { name: "Southern Highlands", code: "PG-SHM" },
      { name: "Western", code: "PG-WPD" },
      { name: "Western Highlands", code: "PG-WHM" },
      { name: "Chimbu", code: "PG-CPK" },
      { name: "East Sepik", code: "PG-ESW" },
      { name: "Gulf", code: "PG-GPK" },
      { name: "Hela", code: "PG-HLA" },
      { name: "Jiwaka", code: "PG-JWK" },
      { name: "West Sepik", code: "PG-SAN" },
      { name: "West New Britain", code: "PG-WBK" }
    ]
  },
  [countryCodes.PHILIPPINES.alphaTwo]: {
    subdivisions: [
      { name: "Abra", code: "PH-ABR" },
      { name: "Agusan del Norte", code: "PH-AGN" },
      { name: "Agusan del Sur", code: "PH-AGS" },
      { name: "Aklan", code: "PH-AKL" },
      { name: "Albay", code: "PH-ALB" },
      { name: "Antique", code: "PH-ANT" },
      { name: "Apayao", code: "PH-APA" },
      { name: "Aurora", code: "PH-AUR" },
      { name: "Basilan", code: "PH-BAS" },
      { name: "Bataan", code: "PH-BAN" },
      { name: "Batanes", code: "PH-BTN" },
      { name: "Batangas", code: "PH-BTG" },
      { name: "Benguet", code: "PH-BEN" },
      { name: "Biliran", code: "PH-BIL" },
      { name: "Bohol", code: "PH-BOH" },
      { name: "Bukidnon", code: "PH-BUK" },
      { name: "Bulacan", code: "PH-BUL" },
      { name: "Cagayan", code: "PH-CAG" },
      { name: "Camarines Norte", code: "PH-CAN" },
      { name: "Camarines Sur", code: "PH-CAS" },
      { name: "Camiguin", code: "PH-CAM" },
      { name: "Capiz", code: "PH-CAP" },
      { name: "Catanduanes", code: "PH-CAT" },
      { name: "Cavite", code: "PH-CAV" },
      { name: "Cebu", code: "PH-CEB" },
      { name: "Cotabato", code: "PH-NCO" },
      { name: "Davao Oriental", code: "PH-DAO" },
      { name: "Davao de Oro", code: "PH-COM" },
      { name: "Davao del Norte", code: "PH-DAV" },
      { name: "Davao del Sur", code: "PH-DAS" },
      { name: "Dinagat Islands", code: "PH-DIN" },
      { name: "Eastern Samar", code: "PH-EAS" },
      { name: "Guimaras", code: "PH-GUI" },
      { name: "Ifugao", code: "PH-IFU" },
      { name: "Ilocos Norte", code: "PH-ILN" },
      { name: "Ilocos Sur", code: "PH-ILS" },
      { name: "Iloilo", code: "PH-ILI" },
      { name: "Isabela", code: "PH-ISA" },
      { name: "Kalinga", code: "PH-KAL" },
      { name: "La Union", code: "PH-LUN" },
      { name: "Laguna", code: "PH-LAG" },
      { name: "Lanao del Norte", code: "PH-LAN" },
      { name: "Lanao del Sur", code: "PH-LAS" },
      { name: "Leyte", code: "PH-LEY" },
      { name: "Maguindanao del Norte", code: "PH-MGN" },
      { name: "Maguindanao del Sur", code: "PH-MGS" },
      { name: "Marinduque", code: "PH-MAD" },
      { name: "Masbate", code: "PH-MAS" },
      { name: "Mindoro Occidental", code: "PH-MDC" },
      { name: "Mindoro Oriental", code: "PH-MDR" },
      { name: "Misamis Occidental", code: "PH-MSC" },
      { name: "Misamis Oriental", code: "PH-MSR" },
      { name: "Mountain Province", code: "PH-MOU" },
      { name: "National Capital Region", code: "PH-00" },
      { name: "Negros Occidental", code: "PH-NEC" },
      { name: "Negros Oriental", code: "PH-NER" },
      { name: "Northern Samar", code: "PH-NSA" },
      { name: "Nueva Ecija", code: "PH-NUE" },
      { name: "Nueva Vizcaya", code: "PH-NUV" },
      { name: "Palawan", code: "PH-PLW" },
      { name: "Pampanga", code: "PH-PAM" },
      { name: "Pangasinan", code: "PH-PAN" },
      { name: "Quezon", code: "PH-QUE" },
      { name: "Quirino", code: "PH-QUI" },
      { name: "Rizal", code: "PH-RIZ" },
      { name: "Romblon", code: "PH-ROM" },
      { name: "Samar", code: "PH-WSA" },
      { name: "Sarangani", code: "PH-SAR" },
      { name: "Siquijor", code: "PH-SIG" },
      { name: "Sorsogon", code: "PH-SOR" },
      { name: "South Cotabato", code: "PH-SCO" },
      { name: "Southern Leyte", code: "PH-SLE" },
      { name: "Sultan Kudarat", code: "PH-SUK" },
      { name: "Sulu", code: "PH-SLU" },
      { name: "Surigao del Norte", code: "PH-SUN" },
      { name: "Surigao del Sur", code: "PH-SUR" },
      { name: "Tarlac", code: "PH-TAR" },
      { name: "Tawi-Tawi", code: "PH-TAW" },
      { name: "Zambales", code: "PH-ZMB" },
      { name: "Zamboanga Sibugay", code: "PH-ZSI" },
      { name: "Zamboanga del Norte", code: "PH-ZAN" },
      { name: "Zamboanga del Sur", code: "PH-ZAS" },
      { name: "Davao Occidental", code: "PH-DVO" }
    ]
  },
  [countryCodes.PAKISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Azad Jammu and Kashmir", code: "PK-JK" },
      { name: "Balochistan", code: "PK-BA" },
      { name: "Gilgit-Baltistan", code: "PK-GB" },
      { name: "Islamabad", code: "PK-IS" },
      { name: "Khyber Pakhtunkhwa", code: "PK-KP" },
      { name: "Punjab", code: "PK-PB" },
      { name: "Sindh", code: "PK-SD" }
    ]
  },
  [countryCodes.POLAND.alphaTwo]: {
    subdivisions: [
      { name: "Dolnoslaskie", code: "PL-02" },
      { name: "Kujawsko-Pomorskie", code: "PL-04" },
      { name: "Lodzkie", code: "PL-10" },
      { name: "Lubelskie", code: "PL-06" },
      { name: "Lubuskie", code: "PL-08" },
      { name: "Malopolskie", code: "PL-12" },
      { name: "Mazowieckie", code: "PL-14" },
      { name: "Opolskie", code: "PL-16" },
      { name: "Podkarpackie", code: "PL-18" },
      { name: "Podlaskie", code: "PL-20" },
      { name: "Pomorskie", code: "PL-22" },
      { name: "Slaskie", code: "PL-24" },
      { name: "Swietokrzyskie", code: "PL-26" },
      { name: "Warminsko-Mazurskie", code: "PL-28" },
      { name: "Wielkopolskie", code: "PL-30" },
      { name: "Zachodniopomorskie", code: "PL-32" }
    ]
  },
  [countryCodes.SAINT_PIERRE_AND_MIQUELON.alphaTwo]: {
    subdivisions: [{ name: "Saint Pierre and Miquelon", code: "-" }]
  },
  [countryCodes.PITCAIRN.alphaTwo]: { subdivisions: [{ name: "Pitcairn", code: "-" }] },
  [countryCodes.PUERTO_RICO.alphaTwo]: {
    subdivisions: [
      { name: "Adjuntas", code: "-" },
      { name: "Aguada", code: "-" },
      { name: "Aguadilla", code: "-" },
      { name: "Aguas Buenas", code: "-" },
      { name: "Aibonito", code: "-" },
      { name: "Anasco", code: "-" },
      { name: "Arecibo", code: "-" },
      { name: "Arroyo", code: "-" },
      { name: "Barceloneta", code: "-" },
      { name: "Barranquitas", code: "-" },
      { name: "Bayamon", code: "-" },
      { name: "Cabo Rojo", code: "-" },
      { name: "Caguas", code: "-" },
      { name: "Camuy", code: "-" },
      { name: "Canovanas", code: "-" },
      { name: "Carolina", code: "-" },
      { name: "Catano", code: "-" },
      { name: "Cayey", code: "-" },
      { name: "Ceiba", code: "-" },
      { name: "Ciales", code: "-" },
      { name: "Cidra", code: "-" },
      { name: "Coamo", code: "-" },
      { name: "Comerio", code: "-" },
      { name: "Corozal", code: "-" },
      { name: "Culebra", code: "-" },
      { name: "Dorado", code: "-" },
      { name: "Fajardo", code: "-" },
      { name: "Florida", code: "-" },
      { name: "Guanica", code: "-" },
      { name: "Guayama", code: "-" },
      { name: "Guayanilla", code: "-" },
      { name: "Guaynabo", code: "-" },
      { name: "Gurabo", code: "-" },
      { name: "Hatillo", code: "-" },
      { name: "Hormigueros", code: "-" },
      { name: "Humacao", code: "-" },
      { name: "Isabela", code: "-" },
      { name: "Juana Diaz", code: "-" },
      { name: "Lajas", code: "-" },
      { name: "Lares", code: "-" },
      { name: "Las Marias", code: "-" },
      { name: "Las Piedras", code: "-" },
      { name: "Loiza", code: "-" },
      { name: "Luquillo", code: "-" },
      { name: "Manati", code: "-" },
      { name: "Maunabo", code: "-" },
      { name: "Mayaguez", code: "-" },
      { name: "Moca", code: "-" },
      { name: "Morovis", code: "-" },
      { name: "Municipio de Jayuya", code: "-" },
      { name: "Municipio de Juncos", code: "-" },
      { name: "Naguabo", code: "-" },
      { name: "Naranjito", code: "-" },
      { name: "Patillas", code: "-" },
      { name: "Penuelas", code: "-" },
      { name: "Ponce", code: "-" },
      { name: "Quebradillas", code: "-" },
      { name: "Rincon", code: "-" },
      { name: "Rio Grande", code: "-" },
      { name: "Sabana Grande", code: "-" },
      { name: "Salinas", code: "-" },
      { name: "San German", code: "-" },
      { name: "San Juan", code: "-" },
      { name: "San Lorenzo", code: "-" },
      { name: "San Sebastian", code: "-" },
      { name: "Santa Isabel Municipio", code: "-" },
      { name: "Toa Alta", code: "-" },
      { name: "Toa Baja", code: "-" },
      { name: "Trujillo Alto", code: "-" },
      { name: "Utuado", code: "-" },
      { name: "Vega Alta", code: "-" },
      { name: "Vega Baja", code: "-" },
      { name: "Vieques", code: "-" },
      { name: "Villalba", code: "-" },
      { name: "Yabucoa", code: "-" },
      { name: "Yauco", code: "-" }
    ]
  },
  [countryCodes.PALESTINE.alphaTwo]: {
    subdivisions: [
      { name: "Bethlehem", code: "PS-BTH" },
      { name: "Deir El Balah", code: "PS-DEB" },
      { name: "Gaza", code: "PS-GZA" },
      { name: "Hebron", code: "PS-HBN" },
      { name: "Jenin", code: "PS-JEN" },
      { name: "Jericho and Al Aghwar", code: "PS-JRH" },
      { name: "Jerusalem", code: "PS-JEM" },
      { name: "Khan Yunis", code: "PS-KYS" },
      { name: "Nablus", code: "PS-NBS" },
      { name: "Rafah", code: "PS-RFH" },
      { name: "Ramallah", code: "PS-RBH" },
      { name: "Salfit", code: "PS-SLT" },
      { name: "Tubas", code: "PS-TBS" },
      { name: "Tulkarm", code: "PS-TKM" },
      { name: "North Gaza", code: "PS-NGZ" },
      { name: "Qalqilya", code: "PS-QQA" }
    ]
  },
  [countryCodes.PORTUGAL.alphaTwo]: {
    subdivisions: [
      { name: "Aveiro", code: "PT-01" },
      { name: "Beja", code: "PT-02" },
      { name: "Braga", code: "PT-03" },
      { name: "Braganca", code: "PT-04" },
      { name: "Castelo Branco", code: "PT-05" },
      { name: "Coimbra", code: "PT-06" },
      { name: "Evora", code: "PT-07" },
      { name: "Faro", code: "PT-08" },
      { name: "Guarda", code: "PT-09" },
      { name: "Leiria", code: "PT-10" },
      { name: "Lisboa", code: "PT-11" },
      { name: "Portalegre", code: "PT-12" },
      { name: "Porto", code: "PT-13" },
      { name: "Regiao Autonoma da Madeira", code: "PT-30" },
      { name: "Regiao Autonoma dos Acores", code: "PT-20" },
      { name: "Santarem", code: "PT-14" },
      { name: "Setubal", code: "PT-15" },
      { name: "Viana do Castelo", code: "PT-16" },
      { name: "Vila Real", code: "PT-17" },
      { name: "Viseu", code: "PT-18" }
    ]
  },
  [countryCodes.PALAU.alphaTwo]: {
    subdivisions: [
      { name: "Airai", code: "PW-004" },
      { name: "Koror", code: "PW-150" },
      { name: "Melekeok", code: "PW-212" },
      { name: "Ngardmau", code: "PW-222" },
      { name: "Ngchesar", code: "PW-226" },
      { name: "Sonsorol", code: "PW-370" },
      { name: "Aimeliik", code: "PW-002" },
      { name: "Angaur", code: "PW-010" },
      { name: "Hatohobei", code: "PW-050" },
      { name: "Kayangel", code: "PW-100" },
      { name: "Ngaraard", code: "PW-214" },
      { name: "Ngarchelong", code: "PW-218" },
      { name: "Ngatpang", code: "PW-224" },
      { name: "Ngeremlengui", code: "PW-227" },
      { name: "Ngiwal", code: "PW-228" },
      { name: "Peleliu", code: "PW-350" }
    ]
  },
  [countryCodes.PARAGUAY.alphaTwo]: {
    subdivisions: [
      { name: "Alto Parana", code: "PY-10" },
      { name: "Amambay", code: "PY-13" },
      { name: "Asuncion", code: "PY-ASU" },
      { name: "Boqueron", code: "PY-19" },
      { name: "Caaguazu", code: "PY-5" },
      { name: "Caazapa", code: "PY-6" },
      { name: "Canindeyu", code: "PY-14" },
      { name: "Central", code: "PY-11" },
      { name: "Concepcion", code: "PY-1" },
      { name: "Cordillera", code: "PY-3" },
      { name: "Guaira", code: "PY-4" },
      { name: "Itapua", code: "PY-7" },
      { name: "Misiones", code: "PY-8" },
      { name: "Neembucu", code: "PY-12" },
      { name: "Paraguari", code: "PY-9" },
      { name: "Presidente Hayes", code: "PY-15" },
      { name: "San Pedro", code: "PY-2" },
      { name: "Alto Paraguay", code: "PY-16" }
    ]
  },
  [countryCodes.QATAR.alphaTwo]: {
    subdivisions: [
      { name: "Ad Dawhah", code: "QA-DA" },
      { name: "Al Khawr wa adh Dhakhirah", code: "QA-KH" },
      { name: "Al Wakrah", code: "QA-WA" },
      { name: "Ar Rayyan", code: "QA-RA" },
      { name: "Ash Shamal", code: "QA-MS" },
      { name: "Az Za'ayin", code: "QA-ZA" },
      { name: "Umm Salal", code: "QA-US" },
      { name: "Ash Shihaniyah", code: "QA-SH" }
    ]
  },
  [countryCodes.REUNION.alphaTwo]: { subdivisions: [{ name: "Reunion", code: "-" }] },
  [countryCodes.ROMANIA.alphaTwo]: {
    subdivisions: [
      { name: "Alba", code: "RO-AB" },
      { name: "Arad", code: "RO-AR" },
      { name: "Arges", code: "RO-AG" },
      { name: "Bacau", code: "RO-BC" },
      { name: "Bihor", code: "RO-BH" },
      { name: "Bistrita-Nasaud", code: "RO-BN" },
      { name: "Botosani", code: "RO-BT" },
      { name: "Braila", code: "RO-BR" },
      { name: "Brasov", code: "RO-BV" },
      { name: "Bucuresti", code: "RO-B" },
      { name: "Buzau", code: "RO-BZ" },
      { name: "Calarasi", code: "RO-CL" },
      { name: "Caras-Severin", code: "RO-CS" },
      { name: "Cluj", code: "RO-CJ" },
      { name: "Constanta", code: "RO-CT" },
      { name: "Covasna", code: "RO-CV" },
      { name: "Dambovita", code: "RO-DB" },
      { name: "Dolj", code: "RO-DJ" },
      { name: "Galati", code: "RO-GL" },
      { name: "Giurgiu", code: "RO-GR" },
      { name: "Gorj", code: "RO-GJ" },
      { name: "Harghita", code: "RO-HR" },
      { name: "Hunedoara", code: "RO-HD" },
      { name: "Ialomita", code: "RO-IL" },
      { name: "Iasi", code: "RO-IS" },
      { name: "Ilfov", code: "RO-IF" },
      { name: "Maramures", code: "RO-MM" },
      { name: "Mehedinti", code: "RO-MH" },
      { name: "Mures", code: "RO-MS" },
      { name: "Neamt", code: "RO-NT" },
      { name: "Olt", code: "RO-OT" },
      { name: "Prahova", code: "RO-PH" },
      { name: "Salaj", code: "RO-SJ" },
      { name: "Satu Mare", code: "RO-SM" },
      { name: "Sibiu", code: "RO-SB" },
      { name: "Suceava", code: "RO-SV" },
      { name: "Teleorman", code: "RO-TR" },
      { name: "Timis", code: "RO-TM" },
      { name: "Tulcea", code: "RO-TL" },
      { name: "Valcea", code: "RO-VL" },
      { name: "Vaslui", code: "RO-VS" },
      { name: "Vrancea", code: "RO-VN" }
    ]
  },
  [countryCodes.SERBIA.alphaTwo]: {
    subdivisions: [
      { name: "Beograd", code: "RS-00" },
      { name: "Borski okrug", code: "RS-14" },
      { name: "Branicevski okrug", code: "RS-11" },
      { name: "Jablanicki okrug", code: "RS-23" },
      { name: "Juznobacki okrug", code: "RS-06" },
      { name: "Juznobanatski okrug", code: "RS-04" },
      { name: "Kolubarski okrug", code: "RS-09" },
      { name: "Kosovsko-Mitrovacki okrug", code: "RS-28" },
      { name: "Macvanski okrug", code: "RS-08" },
      { name: "Moravicki okrug", code: "RS-17" },
      { name: "Nisavski okrug", code: "RS-20" },
      { name: "Pcinjski okrug", code: "RS-24" },
      { name: "Pecki okrug", code: "RS-26" },
      { name: "Pirotski okrug", code: "RS-22" },
      { name: "Podunavski okrug", code: "RS-10" },
      { name: "Pomoravski okrug", code: "RS-13" },
      { name: "Prizrenski okrug", code: "RS-27" },
      { name: "Rasinski okrug", code: "RS-19" },
      { name: "Raski okrug", code: "RS-18" },
      { name: "Severnobacki okrug", code: "RS-01" },
      { name: "Severnobanatski okrug", code: "RS-03" },
      { name: "Srednjebanatski okrug", code: "RS-02" },
      { name: "Sremski okrug", code: "RS-07" },
      { name: "Sumadijski okrug", code: "RS-12" },
      { name: "Toplicki okrug", code: "RS-21" },
      { name: "Zajecarski okrug", code: "RS-15" },
      { name: "Zapadnobacki okrug", code: "RS-05" },
      { name: "Zlatiborski okrug", code: "RS-16" }
    ]
  },
  [countryCodes.RUSSIA.alphaTwo]: {
    subdivisions: [
      { name: "Adygeya, Respublika", code: "RU-AD" },
      { name: "Altay, Respublika", code: "RU-AL" },
      { name: "Altayskiy kray", code: "RU-ALT" },
      { name: "Amurskaya oblast'", code: "RU-AMU" },
      { name: "Arkhangel'skaya oblast'", code: "RU-ARK" },
      { name: "Astrakhanskaya oblast'", code: "RU-AST" },
      { name: "Bashkortostan, Respublika", code: "RU-BA" },
      { name: "Belgorodskaya oblast'", code: "RU-BEL" },
      { name: "Bryanskaya oblast'", code: "RU-BRY" },
      { name: "Buryatiya, Respublika", code: "RU-BU" },
      { name: "Chechenskaya Respublika", code: "RU-CE" },
      { name: "Chelyabinskaya oblast'", code: "RU-CHE" },
      { name: "Chukotskiy avtonomnyy okrug", code: "RU-CHU" },
      { name: "Chuvashskaya Respublika", code: "RU-CU" },
      { name: "Dagestan, Respublika", code: "RU-DA" },
      { name: "Ingushetiya, Respublika", code: "RU-IN" },
      { name: "Irkutskaya oblast'", code: "RU-IRK" },
      { name: "Ivanovskaya oblast'", code: "RU-IVA" },
      { name: "Kabardino-Balkarskaya Respublika", code: "RU-KB" },
      { name: "Kaliningradskaya oblast'", code: "RU-KGD" },
      { name: "Kalmykiya, Respublika", code: "RU-KL" },
      { name: "Kaluzhskaya oblast'", code: "RU-KLU" },
      { name: "Kamchatskiy kray", code: "RU-KAM" },
      { name: "Karachayevo-Cherkesskaya Respublika", code: "RU-KC" },
      { name: "Kareliya, Respublika", code: "RU-KR" },
      { name: "Kemerovskaya oblast'", code: "RU-KEM" },
      { name: "Khabarovskiy kray", code: "RU-KHA" },
      { name: "Khakasiya, Respublika", code: "RU-KK" },
      { name: "Khanty-Mansiyskiy avtonomnyy okrug", code: "RU-KHM" },
      { name: "Kirovskaya oblast'", code: "RU-KIR" },
      { name: "Komi, Respublika", code: "RU-KO" },
      { name: "Kostromskaya oblast'", code: "RU-KOS" },
      { name: "Krasnodarskiy kray", code: "RU-KDA" },
      { name: "Krasnoyarskiy kray", code: "RU-KYA" },
      { name: "Kurganskaya oblast'", code: "RU-KGN" },
      { name: "Kurskaya oblast'", code: "RU-KRS" },
      { name: "Leningradskaya oblast'", code: "RU-LEN" },
      { name: "Lipetskaya oblast'", code: "RU-LIP" },
      { name: "Magadanskaya oblast'", code: "RU-MAG" },
      { name: "Mariy El, Respublika", code: "RU-ME" },
      { name: "Mordoviya, Respublika", code: "RU-MO" },
      { name: "Moskovskaya oblast'", code: "RU-MOS" },
      { name: "Moskva", code: "RU-MOW" },
      { name: "Murmanskaya oblast'", code: "RU-MUR" },
      { name: "Nenetskiy avtonomnyy okrug", code: "RU-NEN" },
      { name: "Nizhegorodskaya oblast'", code: "RU-NIZ" },
      { name: "Novgorodskaya oblast'", code: "RU-NGR" },
      { name: "Novosibirskaya oblast'", code: "RU-NVS" },
      { name: "Omskaya oblast'", code: "RU-OMS" },
      { name: "Orenburgskaya oblast'", code: "RU-ORE" },
      { name: "Orlovskaya oblast'", code: "RU-ORL" },
      { name: "Penzenskaya oblast'", code: "RU-PNZ" },
      { name: "Permskiy kray", code: "RU-PER" },
      { name: "Primorskiy kray", code: "RU-PRI" },
      { name: "Pskovskaya oblast'", code: "RU-PSK" },
      { name: "Rostovskaya oblast'", code: "RU-ROS" },
      { name: "Ryazanskaya oblast'", code: "RU-RYA" },
      { name: "Saha, Respublika", code: "RU-SA" },
      { name: "Sakhalinskaya oblast'", code: "RU-SAK" },
      { name: "Samarskaya oblast'", code: "RU-SAM" },
      { name: "Sankt-Peterburg", code: "RU-SPE" },
      { name: "Saratovskaya oblast'", code: "RU-SAR" },
      { name: "Severnaya Osetiya, Respublika", code: "RU-SE" },
      { name: "Smolenskaya oblast'", code: "RU-SMO" },
      { name: "Stavropol'skiy kray", code: "RU-STA" },
      { name: "Sverdlovskaya oblast'", code: "RU-SVE" },
      { name: "Tambovskaya oblast'", code: "RU-TAM" },
      { name: "Tatarstan, Respublika", code: "RU-TA" },
      { name: "Tomskaya oblast'", code: "RU-TOM" },
      { name: "Tul'skaya oblast'", code: "RU-TUL" },
      { name: "Tverskaya oblast'", code: "RU-TVE" },
      { name: "Tyumenskaya oblast'", code: "RU-TYU" },
      { name: "Tyva, Respublika", code: "RU-TY" },
      { name: "Udmurtskaya Respublika", code: "RU-UD" },
      { name: "Ul'yanovskaya oblast'", code: "RU-ULY" },
      { name: "Vladimirskaya oblast'", code: "RU-VLA" },
      { name: "Volgogradskaya oblast'", code: "RU-VGG" },
      { name: "Vologodskaya oblast'", code: "RU-VLG" },
      { name: "Voronezhskaya oblast'", code: "RU-VOR" },
      { name: "Yamalo-Nenetskiy avtonomnyy okrug", code: "RU-YAN" },
      { name: "Yaroslavskaya oblast'", code: "RU-YAR" },
      { name: "Yevreyskaya avtonomnaya oblast'", code: "RU-YEV" },
      { name: "Zabaykal'skiy kray", code: "RU-ZAB" }
    ]
  },
  [countryCodes.RWANDA.alphaTwo]: {
    subdivisions: [
      { name: "Est", code: "RW-02" },
      { name: "Nord", code: "RW-03" },
      { name: "Ouest", code: "RW-04" },
      { name: "Sud", code: "RW-05" },
      { name: "Ville de Kigali", code: "RW-01" }
    ]
  },
  [countryCodes.SAUDI_ARABIA.alphaTwo]: {
    subdivisions: [
      { name: "Asir", code: "SA-14" },
      { name: "Al Bahah", code: "SA-11" },
      { name: "Al Hudud ash Shamaliyah", code: "SA-08" },
      { name: "Al Jawf", code: "SA-12" },
      { name: "Al Madinah al Munawwarah", code: "SA-03" },
      { name: "Al Qasim", code: "SA-05" },
      { name: "Ar Riyad", code: "SA-01" },
      { name: "Ash Sharqiyah", code: "SA-04" },
      { name: "Ha'il", code: "SA-06" },
      { name: "Jazan", code: "SA-09" },
      { name: "Makkah al Mukarramah", code: "SA-02" },
      { name: "Najran", code: "SA-10" },
      { name: "Tabuk", code: "SA-07" }
    ]
  },
  [countryCodes.SOLOMON_ISLANDS.alphaTwo]: {
    subdivisions: [
      { name: "Choiseul", code: "SB-CH" },
      { name: "Guadalcanal", code: "SB-GU" },
      { name: "Makira-Ulawa", code: "SB-MK" },
      { name: "Malaita", code: "SB-ML" },
      { name: "Western", code: "SB-WE" }
    ]
  },
  [countryCodes.SEYCHELLES.alphaTwo]: {
    subdivisions: [
      { name: "Anse Boileau", code: "SC-02" },
      { name: "Anse Royale", code: "SC-05" },
      { name: "Anse aux Pins", code: "SC-01" },
      { name: "Baie Lazare", code: "SC-06" },
      { name: "Baie Sainte Anne", code: "SC-07" },
      { name: "Beau Vallon", code: "SC-08" },
      { name: "Bel Ombre", code: "SC-10" },
      { name: "Cascade", code: "SC-11" },
      { name: "English River", code: "SC-16" },
      { name: "Grand Anse Mahe", code: "SC-13" },
      { name: "Grand Anse Praslin", code: "SC-14" },
      { name: "La Digue", code: "SC-15" },
      { name: "Pointe Larue", code: "SC-20" },
      { name: "Takamaka", code: "SC-23" }
    ]
  },
  [countryCodes.SUDAN.alphaTwo]: {
    subdivisions: [
      { name: "Blue Nile", code: "SD-NB" },
      { name: "Central Darfur", code: "SD-DC" },
      { name: "Gedaref", code: "SD-GD" },
      { name: "Gezira", code: "SD-GZ" },
      { name: "Kassala", code: "SD-KA" },
      { name: "Khartoum", code: "SD-KH" },
      { name: "North Darfur", code: "SD-DN" },
      { name: "North Kordofan", code: "SD-KN" },
      { name: "Northern", code: "SD-NO" },
      { name: "Red Sea", code: "SD-RS" },
      { name: "River Nile", code: "SD-NR" },
      { name: "Sennar", code: "SD-SI" },
      { name: "South Darfur", code: "SD-DS" },
      { name: "South Kordofan", code: "SD-KS" },
      { name: "West Darfur", code: "SD-DW" },
      { name: "West Kordofan", code: "SD-GK" },
      { name: "White Nile", code: "SD-NW" }
    ]
  },
  [countryCodes.SWEDEN.alphaTwo]: {
    subdivisions: [
      { name: "Blekinge lan", code: "SE-K" },
      { name: "Dalarnas lan", code: "SE-W" },
      { name: "Gavleborgs lan", code: "SE-X" },
      { name: "Gotlands lan", code: "SE-I" },
      { name: "Hallands lan", code: "SE-N" },
      { name: "Jamtlands lan", code: "SE-Z" },
      { name: "Jonkopings lan", code: "SE-F" },
      { name: "Kalmar lan", code: "SE-H" },
      { name: "Kronobergs lan", code: "SE-G" },
      { name: "Norrbottens lan", code: "SE-BD" },
      { name: "Orebro lan", code: "SE-T" },
      { name: "Ostergotlands lan", code: "SE-E" },
      { name: "Skane lan", code: "SE-M" },
      { name: "Sodermanlands lan", code: "SE-D" },
      { name: "Stockholms lan", code: "SE-AB" },
      { name: "Uppsala lan", code: "SE-C" },
      { name: "Varmlands lan", code: "SE-S" },
      { name: "Vasterbottens lan", code: "SE-AC" },
      { name: "Vasternorrlands lan", code: "SE-Y" },
      { name: "Vastmanlands lan", code: "SE-U" },
      { name: "Vastra Gotalands lan", code: "SE-O" }
    ]
  },
  [countryCodes.SINGAPORE.alphaTwo]: { subdivisions: [{ name: "Singapore", code: "-" }] },
  [countryCodes.SAINT_HELENA.alphaTwo]: { subdivisions: [{ name: "Saint Helena", code: "SH-HL" }] },
  [countryCodes.SLOVENIA.alphaTwo]: {
    subdivisions: [
      { name: "Ajdovscina", code: "SI-001" },
      { name: "Ankaran", code: "SI-213" },
      { name: "Apace", code: "SI-195" },
      { name: "Beltinci", code: "SI-002" },
      { name: "Benedikt", code: "SI-148" },
      { name: "Bistrica ob Sotli", code: "SI-149" },
      { name: "Bled", code: "SI-003" },
      { name: "Bloke", code: "SI-150" },
      { name: "Bohinj", code: "SI-004" },
      { name: "Borovnica", code: "SI-005" },
      { name: "Bovec", code: "SI-006" },
      { name: "Braslovce", code: "SI-151" },
      { name: "Brda", code: "SI-007" },
      { name: "Brezice", code: "SI-009" },
      { name: "Brezovica", code: "SI-008" },
      { name: "Cankova", code: "SI-152" },
      { name: "Celje", code: "SI-011" },
      { name: "Cerklje na Gorenjskem", code: "SI-012" },
      { name: "Cerknica", code: "SI-013" },
      { name: "Cerkno", code: "SI-014" },
      { name: "Cirkulane", code: "SI-196" },
      { name: "Crensovci", code: "SI-015" },
      { name: "Crnomelj", code: "SI-017" },
      { name: "Destrnik", code: "SI-018" },
      { name: "Divaca", code: "SI-019" },
      { name: "Dobje", code: "SI-154" },
      { name: "Dobrepolje", code: "SI-020" },
      { name: "Dobrna", code: "SI-155" },
      { name: "Dobrova-Polhov Gradec", code: "SI-021" },
      { name: "Dobrovnik", code: "SI-156" },
      { name: "Domzale", code: "SI-023" },
      { name: "Dornava", code: "SI-024" },
      { name: "Dravograd", code: "SI-025" },
      { name: "Duplek", code: "SI-026" },
      { name: "Gorje", code: "SI-207" },
      { name: "Gornja Radgona", code: "SI-029" },
      { name: "Gornji Petrovci", code: "SI-031" },
      { name: "Grad", code: "SI-158" },
      { name: "Grosuplje", code: "SI-032" },
      { name: "Hajdina", code: "SI-159" },
      { name: "Hoce-Slivnica", code: "SI-160" },
      { name: "Hodos", code: "SI-161" },
      { name: "Horjul", code: "SI-162" },
      { name: "Hrastnik", code: "SI-034" },
      { name: "Hrpelje-Kozina", code: "SI-035" },
      { name: "Idrija", code: "SI-036" },
      { name: "Ig", code: "SI-037" },
      { name: "Ilirska Bistrica", code: "SI-038" },
      { name: "Ivancna Gorica", code: "SI-039" },
      { name: "Izola", code: "SI-040" },
      { name: "Jesenice", code: "SI-041" },
      { name: "Jursinci", code: "SI-042" },
      { name: "Kamnik", code: "SI-043" },
      { name: "Kanal ob Soci", code: "SI-044" },
      { name: "Kidricevo", code: "SI-045" },
      { name: "Kobarid", code: "SI-046" },
      { name: "Kobilje", code: "SI-047" },
      { name: "Kocevje", code: "SI-048" },
      { name: "Komen", code: "SI-049" },
      { name: "Komenda", code: "SI-164" },
      { name: "Koper", code: "SI-050" },
      { name: "Kosanjevica na Krki", code: "SI-197" },
      { name: "Kostel", code: "SI-165" },
      { name: "Kranj", code: "SI-052" },
      { name: "Kranjska Gora", code: "SI-053" },
      { name: "Krizevci", code: "SI-166" },
      { name: "Krsko", code: "SI-054" },
      { name: "Kungota", code: "SI-055" },
      { name: "Kuzma", code: "SI-056" },
      { name: "Lasko", code: "SI-057" },
      { name: "Lenart", code: "SI-058" },
      { name: "Lendava", code: "SI-059" },
      { name: "Litija", code: "SI-060" },
      { name: "Ljubljana", code: "SI-061" },
      { name: "Ljutomer", code: "SI-063" },
      { name: "Log-Dragomer", code: "SI-208" },
      { name: "Logatec", code: "SI-064" },
      { name: "Loska dolina", code: "SI-065" },
      { name: "Loski Potok", code: "SI-066" },
      { name: "Lovrenc na Pohorju", code: "SI-167" },
      { name: "Luce", code: "SI-067" },
      { name: "Lukovica", code: "SI-068" },
      { name: "Majsperk", code: "SI-069" },
      { name: "Makole", code: "SI-198" },
      { name: "Maribor", code: "SI-070" },
      { name: "Markovci", code: "SI-168" },
      { name: "Medvode", code: "SI-071" },
      { name: "Menges", code: "SI-072" },
      { name: "Metlika", code: "SI-073" },
      { name: "Mezica", code: "SI-074" },
      { name: "Miklavz na Dravskem polju", code: "SI-169" },
      { name: "Miren-Kostanjevica", code: "SI-075" },
      { name: "Mirna", code: "SI-212" },
      { name: "Mirna Pec", code: "SI-170" },
      { name: "Mislinja", code: "SI-076" },
      { name: "Mokronog-Trebelno", code: "SI-199" },
      { name: "Moravce", code: "SI-077" },
      { name: "Mozirje", code: "SI-079" },
      { name: "Murska Sobota", code: "SI-080" },
      { name: "Muta", code: "SI-081" },
      { name: "Naklo", code: "SI-082" },
      { name: "Nazarje", code: "SI-083" },
      { name: "Nova Gorica", code: "SI-084" },
      { name: "Novo Mesto", code: "SI-085" },
      { name: "Odranci", code: "SI-086" },
      { name: "Oplotnica", code: "SI-171" },
      { name: "Ormoz", code: "SI-087" },
      { name: "Piran", code: "SI-090" },
      { name: "Pivka", code: "SI-091" },
      { name: "Podcetrtek", code: "SI-092" },
      { name: "Podlehnik", code: "SI-172" },
      { name: "Poljcane", code: "SI-200" },
      { name: "Polzela", code: "SI-173" },
      { name: "Postojna", code: "SI-094" },
      { name: "Prebold", code: "SI-174" },
      { name: "Preddvor", code: "SI-095" },
      { name: "Prevalje", code: "SI-175" },
      { name: "Ptuj", code: "SI-096" },
      { name: "Puconci", code: "SI-097" },
      { name: "Race-Fram", code: "SI-098" },
      { name: "Radece", code: "SI-099" },
      { name: "Radenci", code: "SI-100" },
      { name: "Radlje ob Dravi", code: "SI-101" },
      { name: "Radovljica", code: "SI-102" },
      { name: "Ravne na Koroskem", code: "SI-103" },
      { name: "Razkrizje", code: "SI-176" },
      { name: "Recica ob Savinji", code: "SI-209" },
      { name: "Rence-Vogrsko", code: "SI-201" },
      { name: "Ribnica", code: "SI-104" },
      { name: "Rogaska Slatina", code: "SI-106" },
      { name: "Rogasovci", code: "SI-105" },
      { name: "Ruse", code: "SI-108" },
      { name: "Salovci", code: "SI-033" },
      { name: "Semic", code: "SI-109" },
      { name: "Sempeter-Vrtojba", code: "SI-183" },
      { name: "Sencur", code: "SI-117" },
      { name: "Sentilj", code: "SI-118" },
      { name: "Sentjernej", code: "SI-119" },
      { name: "Sentjur", code: "SI-120" },
      { name: "Sentrupert", code: "SI-211" },
      { name: "Sevnica", code: "SI-110" },
      { name: "Sezana", code: "SI-111" },
      { name: "Skocjan", code: "SI-121" },
      { name: "Skofja Loka", code: "SI-122" },
      { name: "Skofljica", code: "SI-123" },
      { name: "Slovenj Gradec", code: "SI-112" },
      { name: "Slovenska Bistrica", code: "SI-113" },
      { name: "Slovenske Konjice", code: "SI-114" },
      { name: "Smarje pri Jelsah", code: "SI-124" },
      { name: "Smarjeske Toplice", code: "SI-206" },
      { name: "Smartno ob Paki", code: "SI-125" },
      { name: "Smartno pri Litiji", code: "SI-194" },
      { name: "Sodrazica", code: "SI-179" },
      { name: "Solcava", code: "SI-180" },
      { name: "Sostanj", code: "SI-126" },
      { name: "Starse", code: "SI-115" },
      { name: "Store", code: "SI-127" },
      { name: "Straza", code: "SI-203" },
      { name: "Sveta Trojica v Slovenskih goricah", code: "SI-204" },
      { name: "Sveti Andraz v Slovenskih Goricah", code: "SI-182" },
      { name: "Sveti Jurij ob Scavnici", code: "SI-116" },
      { name: "Sveti Jurij v Slovenskih goricah", code: "SI-210" },
      { name: "Sveti Tomaz", code: "SI-205" },
      { name: "Tabor", code: "SI-184" },
      { name: "Tisina", code: "SI-010" },
      { name: "Tolmin", code: "SI-128" },
      { name: "Trbovlje", code: "SI-129" },
      { name: "Trebnje", code: "SI-130" },
      { name: "Trnovska Vas", code: "SI-185" },
      { name: "Trzic", code: "SI-131" },
      { name: "Trzin", code: "SI-186" },
      { name: "Turnisce", code: "SI-132" },
      { name: "Velenje", code: "SI-133" },
      { name: "Velika Polana", code: "SI-187" },
      { name: "Velike Lasce", code: "SI-134" },
      { name: "Verzej", code: "SI-188" },
      { name: "Videm", code: "SI-135" },
      { name: "Vipava", code: "SI-136" },
      { name: "Vitanje", code: "SI-137" },
      { name: "Vodice", code: "SI-138" },
      { name: "Vojnik", code: "SI-139" },
      { name: "Vransko", code: "SI-189" },
      { name: "Vrhnika", code: "SI-140" },
      { name: "Vuzenica", code: "SI-141" },
      { name: "Zagorje ob Savi", code: "SI-142" },
      { name: "Zalec", code: "SI-190" },
      { name: "Zavrc", code: "SI-143" },
      { name: "Zelezniki", code: "SI-146" },
      { name: "Zetale", code: "SI-191" },
      { name: "Ziri", code: "SI-147" },
      { name: "Zrece", code: "SI-144" },
      { name: "Zuzemberk", code: "SI-193" }
    ]
  },
  [countryCodes.SVALBARD_AND_JAN_MAYEN.alphaTwo]: {
    subdivisions: [{ name: "Svalbard and Jan Mayen", code: "-" }]
  },
  [countryCodes.SLOVAKIA.alphaTwo]: {
    subdivisions: [
      { name: "Banskobystricky kraj", code: "SK-BC" },
      { name: "Bratislavsky kraj", code: "SK-BL" },
      { name: "Kosicky kraj", code: "SK-KI" },
      { name: "Nitriansky kraj", code: "SK-NI" },
      { name: "Presovsky kraj", code: "SK-PV" },
      { name: "Trenciansky kraj", code: "SK-TC" },
      { name: "Trnavsky kraj", code: "SK-TA" },
      { name: "Zilinsky kraj", code: "SK-ZI" }
    ]
  },
  [countryCodes.SIERRA_LEONE.alphaTwo]: {
    subdivisions: [
      { name: "Eastern", code: "SL-E" },
      { name: "North Western", code: "SL-NW" },
      { name: "Northern", code: "SL-N" },
      { name: "Southern", code: "SL-S" },
      { name: "Western Area", code: "SL-W" }
    ]
  },
  [countryCodes.SAN_MARINO.alphaTwo]: {
    subdivisions: [
      { name: "Borgo Maggiore", code: "SM-06" },
      { name: "Chiesanuova", code: "SM-02" },
      { name: "Citta di San Marino", code: "SM-07" },
      { name: "Faetano", code: "SM-04" },
      { name: "Serravalle", code: "SM-09" }
    ]
  },
  [countryCodes.SENEGAL.alphaTwo]: {
    subdivisions: [
      { name: "Dakar", code: "SN-DK" },
      { name: "Diourbel", code: "SN-DB" },
      { name: "Fatick", code: "SN-FK" },
      { name: "Kaffrine", code: "SN-KA" },
      { name: "Kaolack", code: "SN-KL" },
      { name: "Kedougou", code: "SN-KE" },
      { name: "Kolda", code: "SN-KD" },
      { name: "Louga", code: "SN-LG" },
      { name: "Matam", code: "SN-MT" },
      { name: "Saint-Louis", code: "SN-SL" },
      { name: "Tambacounda", code: "SN-TC" },
      { name: "Thies", code: "SN-TH" },
      { name: "Ziguinchor", code: "SN-ZG" }
    ]
  },
  [countryCodes.SOMALIA.alphaTwo]: {
    subdivisions: [
      { name: "Awdal", code: "SO-AW" },
      { name: "Banaadir", code: "SO-BN" },
      { name: "Bari", code: "SO-BR" },
      { name: "Bay", code: "SO-BY" },
      { name: "Galguduud", code: "SO-GA" },
      { name: "Hiiraan", code: "SO-HI" },
      { name: "Jubbada Hoose", code: "SO-JH" },
      { name: "Mudug", code: "SO-MU" },
      { name: "Nugaal", code: "SO-NU" },
      { name: "Sanaag", code: "SO-SA" },
      { name: "Shabeellaha Dhexe", code: "SO-SD" },
      { name: "Shabeellaha Hoose", code: "SO-SH" },
      { name: "Sool", code: "SO-SO" },
      { name: "Togdheer", code: "SO-TO" },
      { name: "Woqooyi Galbeed", code: "SO-WO" }
    ]
  },
  [countryCodes.SURINAME.alphaTwo]: {
    subdivisions: [
      { name: "Brokopondo", code: "SR-BR" },
      { name: "Commewijne", code: "SR-CM" },
      { name: "Coronie", code: "SR-CR" },
      { name: "Nickerie", code: "SR-NI" },
      { name: "Para", code: "SR-PR" },
      { name: "Paramaribo", code: "SR-PM" },
      { name: "Saramacca", code: "SR-SA" },
      { name: "Sipaliwini", code: "SR-SI" },
      { name: "Wanica", code: "SR-WA" }
    ]
  },
  [countryCodes.SOUTH_SUDAN.alphaTwo]: {
    subdivisions: [
      { name: "Central Equatoria", code: "SS-EC" },
      { name: "Eastern Equatoria", code: "SS-EE" },
      { name: "Jonglei", code: "SS-JG" },
      { name: "Lakes", code: "SS-LK" },
      { name: "Northern Bahr el Ghazal", code: "SS-BN" },
      { name: "Unity", code: "SS-UY" },
      { name: "Upper Nile", code: "SS-NU" },
      { name: "Warrap", code: "SS-WR" },
      { name: "Western Equatoria", code: "SS-EW" }
    ]
  },
  [countryCodes.SAO_TOME_AND_PRINCIPE.alphaTwo]: {
    subdivisions: [
      { name: "Agua Grande", code: "ST-01" },
      { name: "Principe", code: "ST-P" }
    ]
  },
  [countryCodes.EL_SALVADOR.alphaTwo]: {
    subdivisions: [
      { name: "Ahuachapan", code: "SV-AH" },
      { name: "Cabanas", code: "SV-CA" },
      { name: "Chalatenango", code: "SV-CH" },
      { name: "Cuscatlan", code: "SV-CU" },
      { name: "La Libertad", code: "SV-LI" },
      { name: "La Paz", code: "SV-PA" },
      { name: "La Union", code: "SV-UN" },
      { name: "Morazan", code: "SV-MO" },
      { name: "San Miguel", code: "SV-SM" },
      { name: "San Salvador", code: "SV-SS" },
      { name: "San Vicente", code: "SV-SV" },
      { name: "Santa Ana", code: "SV-SA" },
      { name: "Sonsonate", code: "SV-SO" },
      { name: "Usulutan", code: "SV-US" }
    ]
  },
  [countryCodes.SINT_MAARTEN_DUTCH.alphaTwo]: {
    subdivisions: [{ name: "Sint Maarten (Dutch Part)", code: "-" }]
  },
  [countryCodes.SYRIA.alphaTwo]: {
    subdivisions: [
      { name: "Al Hasakah", code: "SY-HA" },
      { name: "Al Ladhiqiyah", code: "SY-LA" },
      { name: "Al Qunaytirah", code: "SY-QU" },
      { name: "As Suwayda'", code: "SY-SU" },
      { name: "Dar'a", code: "SY-DR" },
      { name: "Dayr az Zawr", code: "SY-DY" },
      { name: "Dimashq", code: "SY-DI" },
      { name: "Halab", code: "SY-HL" },
      { name: "Hamah", code: "SY-HM" },
      { name: "Hims", code: "SY-HI" },
      { name: "Idlib", code: "SY-ID" },
      { name: "Rif Dimashq", code: "SY-RD" },
      { name: "Tartus", code: "SY-TA" }
    ]
  },
  [countryCodes.SWAZILAND.alphaTwo]: {
    subdivisions: [
      { name: "Hhohho", code: "SZ-HH" },
      { name: "Lubombo", code: "SZ-LU" },
      { name: "Manzini", code: "SZ-MA" },
      { name: "Shiselweni", code: "SZ-SH" }
    ]
  },
  [countryCodes.TURKS_AND_CAICOS_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Turks and Caicos Islands", code: "-" }]
  },
  [countryCodes.CHAD.alphaTwo]: {
    subdivisions: [
      { name: "Bahr el Ghazal", code: "TD-BG" },
      { name: "Borkou", code: "TD-BO" },
      { name: "Chari-Baguirmi", code: "TD-CB" },
      { name: "Guera", code: "TD-GR" },
      { name: "Lac", code: "TD-LC" },
      { name: "Logone-Occidental", code: "TD-LO" },
      { name: "Ouaddai", code: "TD-OD" },
      { name: "Sila", code: "TD-SI" },
      { name: "Ville de Ndjamena", code: "TD-ND" },
      { name: "Wadi Fira", code: "TD-WF" }
    ]
  },
  [countryCodes.FRENCH_SOUTHERN_TERRITORIES.alphaTwo]: {
    subdivisions: [{ name: "French Southern Territories", code: "-" }]
  },
  [countryCodes.TOGO.alphaTwo]: {
    subdivisions: [
      { name: "Centrale", code: "TG-C" },
      { name: "Kara", code: "TG-K" },
      { name: "Maritime", code: "TG-M" },
      { name: "Plateaux", code: "TG-P" },
      { name: "Savanes", code: "TG-S" }
    ]
  },
  [countryCodes.THAILAND.alphaTwo]: {
    subdivisions: [
      { name: "Amnat Charoen", code: "TH-37" },
      { name: "Ang Thong", code: "TH-15" },
      { name: "Bueng Kan", code: "TH-38" },
      { name: "Buri Ram", code: "TH-31" },
      { name: "Chachoengsao", code: "TH-24" },
      { name: "Chai Nat", code: "TH-18" },
      { name: "Chaiyaphum", code: "TH-36" },
      { name: "Chanthaburi", code: "TH-22" },
      { name: "Chiang Mai", code: "TH-50" },
      { name: "Chiang Rai", code: "TH-57" },
      { name: "Chon Buri", code: "TH-20" },
      { name: "Chumphon", code: "TH-86" },
      { name: "Kalasin", code: "TH-46" },
      { name: "Kamphaeng Phet", code: "TH-62" },
      { name: "Kanchanaburi", code: "TH-71" },
      { name: "Khon Kaen", code: "TH-40" },
      { name: "Krabi", code: "TH-81" },
      { name: "Krung Thep Maha Nakhon", code: "TH-10" },
      { name: "Lampang", code: "TH-52" },
      { name: "Lamphun", code: "TH-51" },
      { name: "Loei", code: "TH-42" },
      { name: "Lop Buri", code: "TH-16" },
      { name: "Mae Hong Son", code: "TH-58" },
      { name: "Maha Sarakham", code: "TH-44" },
      { name: "Mukdahan", code: "TH-49" },
      { name: "Nakhon Nayok", code: "TH-26" },
      { name: "Nakhon Pathom", code: "TH-73" },
      { name: "Nakhon Phanom", code: "TH-48" },
      { name: "Nakhon Ratchasima", code: "TH-30" },
      { name: "Nakhon Sawan", code: "TH-60" },
      { name: "Nakhon Si Thammarat", code: "TH-80" },
      { name: "Nan", code: "TH-55" },
      { name: "Narathiwat", code: "TH-96" },
      { name: "Nong Bua Lam Phu", code: "TH-39" },
      { name: "Nong Khai", code: "TH-43" },
      { name: "Nonthaburi", code: "TH-12" },
      { name: "Pathum Thani", code: "TH-13" },
      { name: "Pattani", code: "TH-94" },
      { name: "Phangnga", code: "TH-82" },
      { name: "Phatthalung", code: "TH-93" },
      { name: "Phayao", code: "TH-56" },
      { name: "Phetchabun", code: "TH-67" },
      { name: "Phetchaburi", code: "TH-76" },
      { name: "Phichit", code: "TH-66" },
      { name: "Phitsanulok", code: "TH-65" },
      { name: "Phra Nakhon Si Ayutthaya", code: "TH-14" },
      { name: "Phrae", code: "TH-54" },
      { name: "Phuket", code: "TH-83" },
      { name: "Prachin Buri", code: "TH-25" },
      { name: "Prachuap Khiri Khan", code: "TH-77" },
      { name: "Ranong", code: "TH-85" },
      { name: "Ratchaburi", code: "TH-70" },
      { name: "Rayong", code: "TH-21" },
      { name: "Roi Et", code: "TH-45" },
      { name: "Sa Kaeo", code: "TH-27" },
      { name: "Sakon Nakhon", code: "TH-47" },
      { name: "Samut Prakan", code: "TH-11" },
      { name: "Samut Sakhon", code: "TH-74" },
      { name: "Samut Songkhram", code: "TH-75" },
      { name: "Saraburi", code: "TH-19" },
      { name: "Satun", code: "TH-91" },
      { name: "Si Sa Ket", code: "TH-33" },
      { name: "Sing Buri", code: "TH-17" },
      { name: "Songkhla", code: "TH-90" },
      { name: "Sukhothai", code: "TH-64" },
      { name: "Suphan Buri", code: "TH-72" },
      { name: "Surat Thani", code: "TH-84" },
      { name: "Surin", code: "TH-32" },
      { name: "Tak", code: "TH-63" },
      { name: "Trang", code: "TH-92" },
      { name: "Trat", code: "TH-23" },
      { name: "Ubon Ratchathani", code: "TH-34" },
      { name: "Udon Thani", code: "TH-41" },
      { name: "Uthai Thani", code: "TH-61" },
      { name: "Uttaradit", code: "TH-53" },
      { name: "Yala", code: "TH-95" },
      { name: "Yasothon", code: "TH-35" }
    ]
  },
  [countryCodes.TAJIKISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Dushanbe", code: "TJ-DU" },
      { name: "Khatlon", code: "TJ-KT" },
      { name: "Kuhistoni Badakhshon", code: "TJ-GB" },
      { name: "Nohiyahoi Tobei Jumhuri", code: "TJ-RA" },
      { name: "Sughd", code: "TJ-SU" }
    ]
  },
  [countryCodes.TOKELAU.alphaTwo]: { subdivisions: [{ name: "Tokelau", code: "-" }] },
  [countryCodes.TIMOR_LESTE.alphaTwo]: {
    subdivisions: [
      { name: "Aileu", code: "TL-AL" },
      { name: "Ainaro", code: "TL-AN" },
      { name: "Baucau", code: "TL-BA" },
      { name: "Bobonaro", code: "TL-BO" },
      { name: "Cova Lima", code: "TL-CO" },
      { name: "Dili", code: "TL-DI" },
      { name: "Liquica", code: "TL-LI" },
      { name: "Manufahi", code: "TL-MF" },
      { name: "Oecussi", code: "TL-OE" }
    ]
  },
  [countryCodes.TURKMENISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Ahal", code: "TM-A" },
      { name: "Balkan", code: "TM-B" },
      { name: "Dasoguz", code: "TM-D" },
      { name: "Lebap", code: "TM-L" },
      { name: "Mary", code: "TM-M" }
    ]
  },
  [countryCodes.TUNISIA.alphaTwo]: {
    subdivisions: [
      { name: "Beja", code: "TN-31" },
      { name: "Ben Arous", code: "TN-13" },
      { name: "Bizerte", code: "TN-23" },
      { name: "Gabes", code: "TN-81" },
      { name: "Gafsa", code: "TN-71" },
      { name: "Jendouba", code: "TN-32" },
      { name: "Kairouan", code: "TN-41" },
      { name: "Kasserine", code: "TN-42" },
      { name: "Kebili", code: "TN-73" },
      { name: "L'Ariana", code: "TN-12" },
      { name: "La Manouba", code: "TN-14" },
      { name: "Le Kef", code: "TN-33" },
      { name: "Mahdia", code: "TN-53" },
      { name: "Medenine", code: "TN-82" },
      { name: "Monastir", code: "TN-52" },
      { name: "Nabeul", code: "TN-21" },
      { name: "Sfax", code: "TN-61" },
      { name: "Sidi Bouzid", code: "TN-43" },
      { name: "Siliana", code: "TN-34" },
      { name: "Sousse", code: "TN-51" },
      { name: "Tataouine", code: "TN-83" },
      { name: "Tozeur", code: "TN-72" },
      { name: "Tunis", code: "TN-11" },
      { name: "Zaghouan", code: "TN-22" }
    ]
  },
  [countryCodes.TONGA.alphaTwo]: {
    subdivisions: [
      { name: "Eua", code: "TO-01" },
      { name: "Ha'apai", code: "TO-02" },
      { name: "Niuas", code: "TO-03" },
      { name: "Tongatapu", code: "TO-04" },
      { name: "Vava'u", code: "TO-05" }
    ]
  },
  [countryCodes.TURKEY.alphaTwo]: {
    subdivisions: [
      { name: "Adana", code: "TR-01" },
      { name: "Adiyaman", code: "TR-02" },
      { name: "Afyonkarahisar", code: "TR-03" },
      { name: "Agri", code: "TR-04" },
      { name: "Aksaray", code: "TR-68" },
      { name: "Amasya", code: "TR-05" },
      { name: "Ankara", code: "TR-06" },
      { name: "Antalya", code: "TR-07" },
      { name: "Ardahan", code: "TR-75" },
      { name: "Artvin", code: "TR-08" },
      { name: "Aydin", code: "TR-09" },
      { name: "Balikesir", code: "TR-10" },
      { name: "Bartin", code: "TR-74" },
      { name: "Batman", code: "TR-72" },
      { name: "Bayburt", code: "TR-69" },
      { name: "Bilecik", code: "TR-11" },
      { name: "Bingol", code: "TR-12" },
      { name: "Bitlis", code: "TR-13" },
      { name: "Bolu", code: "TR-14" },
      { name: "Burdur", code: "TR-15" },
      { name: "Bursa", code: "TR-16" },
      { name: "Canakkale", code: "TR-17" },
      { name: "Cankiri", code: "TR-18" },
      { name: "Corum", code: "TR-19" },
      { name: "Denizli", code: "TR-20" },
      { name: "Diyarbakir", code: "TR-21" },
      { name: "Duzce", code: "TR-81" },
      { name: "Edirne", code: "TR-22" },
      { name: "Elazig", code: "TR-23" },
      { name: "Erzincan", code: "TR-24" },
      { name: "Erzurum", code: "TR-25" },
      { name: "Eskisehir", code: "TR-26" },
      { name: "Gaziantep", code: "TR-27" },
      { name: "Giresun", code: "TR-28" },
      { name: "Gumushane", code: "TR-29" },
      { name: "Hakkari", code: "TR-30" },
      { name: "Hatay", code: "TR-31" },
      { name: "Igdir", code: "TR-76" },
      { name: "Isparta", code: "TR-32" },
      { name: "Istanbul", code: "TR-34" },
      { name: "Izmir", code: "TR-35" },
      { name: "Kahramanmaras", code: "TR-46" },
      { name: "Karabuk", code: "TR-78" },
      { name: "Karaman", code: "TR-70" },
      { name: "Kars", code: "TR-36" },
      { name: "Kastamonu", code: "TR-37" },
      { name: "Kayseri", code: "TR-38" },
      { name: "Kilis", code: "TR-79" },
      { name: "Kirikkale", code: "TR-71" },
      { name: "Kirklareli", code: "TR-39" },
      { name: "Kirsehir", code: "TR-40" },
      { name: "Kocaeli", code: "TR-41" },
      { name: "Konya", code: "TR-42" },
      { name: "Kutahya", code: "TR-43" },
      { name: "Malatya", code: "TR-44" },
      { name: "Manisa", code: "TR-45" },
      { name: "Mardin", code: "TR-47" },
      { name: "Mersin", code: "TR-33" },
      { name: "Mugla", code: "TR-48" },
      { name: "Mus", code: "TR-49" },
      { name: "Nevsehir", code: "TR-50" },
      { name: "Nigde", code: "TR-51" },
      { name: "Ordu", code: "TR-52" },
      { name: "Osmaniye", code: "TR-80" },
      { name: "Rize", code: "TR-53" },
      { name: "Sakarya", code: "TR-54" },
      { name: "Samsun", code: "TR-55" },
      { name: "Sanliurfa", code: "TR-63" },
      { name: "Siirt", code: "TR-56" },
      { name: "Sinop", code: "TR-57" },
      { name: "Sirnak", code: "TR-73" },
      { name: "Sivas", code: "TR-58" },
      { name: "Tekirdag", code: "TR-59" },
      { name: "Tokat", code: "TR-60" },
      { name: "Trabzon", code: "TR-61" },
      { name: "Tunceli", code: "TR-62" },
      { name: "Usak", code: "TR-64" },
      { name: "Van", code: "TR-65" },
      { name: "Yalova", code: "TR-77" },
      { name: "Yozgat", code: "TR-66" },
      { name: "Zonguldak", code: "TR-67" }
    ]
  },
  [countryCodes.TRINIDAD_AND_TOBAGO.alphaTwo]: {
    subdivisions: [
      { name: "Arima", code: "TT-ARI" },
      { name: "Chaguanas", code: "TT-CHA" },
      { name: "Couva-Tabaquite-Talparo", code: "TT-CTT" },
      { name: "Diego Martin", code: "TT-DMN" },
      { name: "Mayaro-Rio Claro", code: "TT-MRC" },
      { name: "Penal-Debe", code: "TT-PED" },
      { name: "Point Fortin", code: "TT-PTF" },
      { name: "Port of Spain", code: "TT-POS" },
      { name: "Princes Town", code: "TT-PRT" },
      { name: "San Fernando", code: "TT-SFO" },
      { name: "San Juan-Laventille", code: "TT-SJL" },
      { name: "Sangre Grande", code: "TT-SGE" },
      { name: "Siparia", code: "TT-SIP" },
      { name: "Tobago", code: "TT-TOB" },
      { name: "Tunapuna-Piarco", code: "TT-TUP" }
    ]
  },
  [countryCodes.TUVALU.alphaTwo]: { subdivisions: [{ name: "Funafuti", code: "TV-FUN" }] },
  [countryCodes.TAIWAN.alphaTwo]: {
    subdivisions: [
      { name: "Changhua", code: "TW-CHA" },
      { name: "Chiayi", code: "TW-CYQ" },
      { name: "Hsinchu", code: "TW-HSQ" },
      { name: "Hualien", code: "TW-HUA" },
      { name: "Kaohsiung", code: "TW-KHH" },
      { name: "Keelung", code: "TW-KEE" },
      { name: "Kinmen", code: "TW-KIN" },
      { name: "Lienchiang", code: "TW-LIE" },
      { name: "Miaoli", code: "TW-MIA" },
      { name: "Nantou", code: "TW-NAN" },
      { name: "New Taipei", code: "TW-NWT" },
      { name: "Penghu", code: "TW-PEN" },
      { name: "Pingtung", code: "TW-PIF" },
      { name: "Taichung", code: "TW-TXG" },
      { name: "Tainan", code: "TW-TNN" },
      { name: "Taipei", code: "TW-TPE" },
      { name: "Taitung", code: "TW-TTT" },
      { name: "Taoyuan", code: "TW-TAO" },
      { name: "Yilan", code: "TW-ILA" },
      { name: "Yunlin", code: "TW-YUN" }
    ]
  },
  [countryCodes.TANZANIA_UNITED_REPUBLIC_OF.alphaTwo]: {
    subdivisions: [
      { name: "Arusha", code: "TZ-01" },
      { name: "Dar es Salaam", code: "TZ-02" },
      { name: "Dodoma", code: "TZ-03" },
      { name: "Geita", code: "TZ-27" },
      { name: "Iringa", code: "TZ-04" },
      { name: "Kagera", code: "TZ-05" },
      { name: "Kaskazini Unguja", code: "TZ-07" },
      { name: "Katavi", code: "TZ-28" },
      { name: "Kigoma", code: "TZ-08" },
      { name: "Kilimanjaro", code: "TZ-09" },
      { name: "Kusini Pemba", code: "TZ-10" },
      { name: "Kusini Unguja", code: "TZ-11" },
      { name: "Lindi", code: "TZ-12" },
      { name: "Manyara", code: "TZ-26" },
      { name: "Mara", code: "TZ-13" },
      { name: "Mbeya", code: "TZ-14" },
      { name: "Mjini Magharibi", code: "TZ-15" },
      { name: "Morogoro", code: "TZ-16" },
      { name: "Mtwara", code: "TZ-17" },
      { name: "Mwanza", code: "TZ-18" },
      { name: "Njombe", code: "TZ-29" },
      { name: "Pwani", code: "TZ-19" },
      { name: "Rukwa", code: "TZ-20" },
      { name: "Ruvuma", code: "TZ-21" },
      { name: "Shinyanga", code: "TZ-22" },
      { name: "Simiyu", code: "TZ-30" },
      { name: "Singida", code: "TZ-23" },
      { name: "Songwe", code: "TZ-31" },
      { name: "Tabora", code: "TZ-24" },
      { name: "Tanga", code: "TZ-25" }
    ]
  },
  [countryCodes.UKRAINE.alphaTwo]: {
    subdivisions: [
      { name: "Avtonomna Respublika Krym", code: "UA-43" },
      { name: "Cherkaska oblast", code: "UA-71" },
      { name: "Chernihivska oblast", code: "UA-74" },
      { name: "Chernivetska oblast", code: "UA-77" },
      { name: "Dnipropetrovska oblast", code: "UA-12" },
      { name: "Donetska oblast", code: "UA-14" },
      { name: "Ivano-Frankivska oblast", code: "UA-26" },
      { name: "Kharkivska oblast", code: "UA-63" },
      { name: "Khersonska oblast", code: "UA-65" },
      { name: "Khmelnytska oblast", code: "UA-68" },
      { name: "Kirovohradska oblast", code: "UA-35" },
      { name: "Kyiv", code: "UA-30" },
      { name: "Kyivska oblast", code: "UA-32" },
      { name: "Luhanska oblast", code: "UA-09" },
      { name: "Lvivska oblast", code: "UA-46" },
      { name: "Mykolaivska oblast", code: "UA-48" },
      { name: "Odeska oblast", code: "UA-51" },
      { name: "Poltavska oblast", code: "UA-53" },
      { name: "Rivnenska oblast", code: "UA-56" },
      { name: "Sevastopol", code: "UA-40" },
      { name: "Sumska oblast", code: "UA-59" },
      { name: "Ternopilska oblast", code: "UA-61" },
      { name: "Vinnytska oblast", code: "UA-05" },
      { name: "Volynska oblast", code: "UA-07" },
      { name: "Zakarpatska oblast", code: "UA-21" },
      { name: "Zaporizka oblast", code: "UA-23" },
      { name: "Zhytomyrska oblast", code: "UA-18" }
    ]
  },
  [countryCodes.UGANDA.alphaTwo]: {
    subdivisions: [
      { name: "Abim", code: "UG-314" },
      { name: "Agago", code: "UG-322" },
      { name: "Amuria", code: "UG-216" },
      { name: "Apac", code: "UG-302" },
      { name: "Arua", code: "UG-303" },
      { name: "Budaka", code: "UG-217" },
      { name: "Bududa", code: "UG-218" },
      { name: "Bugiri", code: "UG-201" },
      { name: "Buhweju", code: "UG-420" },
      { name: "Buikwe", code: "UG-117" },
      { name: "Bukedea", code: "UG-219" },
      { name: "Bukomansibi", code: "UG-118" },
      { name: "Bulambuli", code: "UG-225" },
      { name: "Buliisa", code: "UG-416" },
      { name: "Bundibugyo", code: "UG-401" },
      { name: "Bushenyi", code: "UG-402" },
      { name: "Busia", code: "UG-202" },
      { name: "Butaleja", code: "UG-221" },
      { name: "Buvuma", code: "UG-120" },
      { name: "Buyende", code: "UG-226" },
      { name: "Dokolo", code: "UG-317" },
      { name: "Gomba", code: "UG-121" },
      { name: "Gulu", code: "UG-304" },
      { name: "Hoima", code: "UG-403" },
      { name: "Ibanda", code: "UG-417" },
      { name: "Iganga", code: "UG-203" },
      { name: "Isingiro", code: "UG-418" },
      { name: "Jinja", code: "UG-204" },
      { name: "Kaabong", code: "UG-318" },
      { name: "Kabale", code: "UG-404" },
      { name: "Kabarole", code: "UG-405" },
      { name: "Kalangala", code: "UG-101" },
      { name: "Kaliro", code: "UG-222" },
      { name: "Kalungu", code: "UG-122" },
      { name: "Kampala", code: "UG-102" },
      { name: "Kamuli", code: "UG-205" },
      { name: "Kamwenge", code: "UG-413" },
      { name: "Kanungu", code: "UG-414" },
      { name: "Kapchorwa", code: "UG-206" },
      { name: "Kasese", code: "UG-406" },
      { name: "Kayunga", code: "UG-112" },
      { name: "Kibaale", code: "UG-407" },
      { name: "Kiboga", code: "UG-103" },
      { name: "Kiruhura", code: "UG-419" },
      { name: "Kiryandongo", code: "UG-421" },
      { name: "Kisoro", code: "UG-408" },
      { name: "Kitgum", code: "UG-305" },
      { name: "Koboko", code: "UG-319" },
      { name: "Kole", code: "UG-325" },
      { name: "Kumi", code: "UG-208" },
      { name: "Kween", code: "UG-228" },
      { name: "Kyankwanzi", code: "UG-123" },
      { name: "Kyegegwa", code: "UG-422" },
      { name: "Kyenjojo", code: "UG-415" },
      { name: "Lamwo", code: "UG-326" },
      { name: "Lira", code: "UG-307" },
      { name: "Luuka", code: "UG-229" },
      { name: "Luwero", code: "UG-104" },
      { name: "Lwengo", code: "UG-124" },
      { name: "Lyantonde", code: "UG-114" },
      { name: "Maracha", code: "UG-320" },
      { name: "Masaka", code: "UG-105" },
      { name: "Masindi", code: "UG-409" },
      { name: "Mayuge", code: "UG-214" },
      { name: "Mbale", code: "UG-209" },
      { name: "Mbarara", code: "UG-410" },
      { name: "Mitooma", code: "UG-423" },
      { name: "Mityana", code: "UG-115" },
      { name: "Moroto", code: "UG-308" },
      { name: "Moyo", code: "UG-309" },
      { name: "Mpigi", code: "UG-106" },
      { name: "Mubende", code: "UG-107" },
      { name: "Mukono", code: "UG-108" },
      { name: "Nakapiripirit", code: "UG-311" },
      { name: "Nakaseke", code: "UG-116" },
      { name: "Nakasongola", code: "UG-109" },
      { name: "Namutumba", code: "UG-224" },
      { name: "Napak", code: "UG-327" },
      { name: "Nebbi", code: "UG-310" },
      { name: "Ntoroko", code: "UG-424" },
      { name: "Ntungamo", code: "UG-411" },
      { name: "Nwoya", code: "UG-328" },
      { name: "Oyam", code: "UG-321" },
      { name: "Pader", code: "UG-312" },
      { name: "Pallisa", code: "UG-210" },
      { name: "Rakai", code: "UG-110" },
      { name: "Rubirizi", code: "UG-425" },
      { name: "Rukungiri", code: "UG-412" },
      { name: "Sembabule", code: "UG-111" },
      { name: "Sheema", code: "UG-426" },
      { name: "Sironko", code: "UG-215" },
      { name: "Soroti", code: "UG-211" },
      { name: "Tororo", code: "UG-212" },
      { name: "Wakiso", code: "UG-113" },
      { name: "Yumbe", code: "UG-313" },
      { name: "Zombo", code: "UG-330" }
    ]
  },
  [countryCodes.UNITED_STATES_MINOR_OUTLYING_ISLANDS.alphaTwo]: {
    subdivisions: [{ name: "Palmyra Atoll", code: "UM-95" }]
  },
  [countryCodes.UNITED_STATES_OF_AMERICA.alphaTwo]: {
    subdivisions: [
      { name: "Alabama", code: "US-AL" },
      { name: "Alaska", code: "US-AK" },
      { name: "Arizona", code: "US-AZ" },
      { name: "Arkansas", code: "US-AR" },
      { name: "California", code: "US-CA" },
      { name: "Colorado", code: "US-CO" },
      { name: "Connecticut", code: "US-CT" },
      { name: "Delaware", code: "US-DE" },
      { name: "District of Columbia", code: "US-DC" },
      { name: "Florida", code: "US-FL" },
      { name: "Georgia", code: "US-GA" },
      { name: "Hawaii", code: "US-HI" },
      { name: "Idaho", code: "US-ID" },
      { name: "Illinois", code: "US-IL" },
      { name: "Indiana", code: "US-IN" },
      { name: "Iowa", code: "US-IA" },
      { name: "Kansas", code: "US-KS" },
      { name: "Kentucky", code: "US-KY" },
      { name: "Louisiana", code: "US-LA" },
      { name: "Maine", code: "US-ME" },
      { name: "Maryland", code: "US-MD" },
      { name: "Massachusetts", code: "US-MA" },
      { name: "Michigan", code: "US-MI" },
      { name: "Minnesota", code: "US-MN" },
      { name: "Mississippi", code: "US-MS" },
      { name: "Missouri", code: "US-MO" },
      { name: "Montana", code: "US-MT" },
      { name: "Nebraska", code: "US-NE" },
      { name: "Nevada", code: "US-NV" },
      { name: "New Hampshire", code: "US-NH" },
      { name: "New Jersey", code: "US-NJ" },
      { name: "New Mexico", code: "US-NM" },
      { name: "New York", code: "US-NY" },
      { name: "North Carolina", code: "US-NC" },
      { name: "North Dakota", code: "US-ND" },
      { name: "Ohio", code: "US-OH" },
      { name: "Oklahoma", code: "US-OK" },
      { name: "Oregon", code: "US-OR" },
      { name: "Pennsylvania", code: "US-PA" },
      { name: "Rhode Island", code: "US-RI" },
      { name: "South Carolina", code: "US-SC" },
      { name: "South Dakota", code: "US-SD" },
      { name: "Tennessee", code: "US-TN" },
      { name: "Texas", code: "US-TX" },
      { name: "Utah", code: "US-UT" },
      { name: "Vermont", code: "US-VT" },
      { name: "Virginia", code: "US-VA" },
      { name: "Washington", code: "US-WA" },
      { name: "West Virginia", code: "US-WV" },
      { name: "Wisconsin", code: "US-WI" },
      { name: "Wyoming", code: "US-WY" }
    ]
  },
  [countryCodes.URUGUAY.alphaTwo]: {
    subdivisions: [
      { name: "Artigas", code: "UY-AR" },
      { name: "Canelones", code: "UY-CA" },
      { name: "Cerro Largo", code: "UY-CL" },
      { name: "Colonia", code: "UY-CO" },
      { name: "Durazno", code: "UY-DU" },
      { name: "Flores", code: "UY-FS" },
      { name: "Florida", code: "UY-FD" },
      { name: "Lavalleja", code: "UY-LA" },
      { name: "Maldonado", code: "UY-MA" },
      { name: "Montevideo", code: "UY-MO" },
      { name: "Paysandu", code: "UY-PA" },
      { name: "Rio Negro", code: "UY-RN" },
      { name: "Rivera", code: "UY-RV" },
      { name: "Rocha", code: "UY-RO" },
      { name: "Salto", code: "UY-SA" },
      { name: "San Jose", code: "UY-SJ" },
      { name: "Soriano", code: "UY-SO" },
      { name: "Tacuarembo", code: "UY-TA" },
      { name: "Treinta y Tres", code: "UY-TT" }
    ]
  },
  [countryCodes.UZBEKISTAN.alphaTwo]: {
    subdivisions: [
      { name: "Andijon", code: "UZ-AN" },
      { name: "Buxoro", code: "UZ-BU" },
      { name: "Farg'ona", code: "UZ-FA" },
      { name: "Jizzax", code: "UZ-JI" },
      { name: "Namangan", code: "UZ-NG" },
      { name: "Navoiy", code: "UZ-NW" },
      { name: "Qashqadaryo", code: "UZ-QA" },
      { name: "Qoraqalpog'iston Respublikasi", code: "UZ-QR" },
      { name: "Samarqand", code: "UZ-SA" },
      { name: "Sirdaryo", code: "UZ-SI" },
      { name: "Surxondaryo", code: "UZ-SU" },
      { name: "Toshkent", code: "UZ-TK" },
      { name: "Xorazm", code: "UZ-XO" }
    ]
  },
  [countryCodes.VATICAN.alphaTwo]: { subdivisions: [{ name: "Vatican City", code: "-" }] },
  [countryCodes.SAINT_VINCENT_AND_THE_GRENADINES.alphaTwo]: {
    subdivisions: [
      { name: "Charlotte", code: "VC-01" },
      { name: "Grenadines", code: "VC-06" },
      { name: "Saint George", code: "VC-04" },
      { name: "Saint Patrick", code: "VC-05" }
    ]
  },
  [countryCodes.VENEZUELA.alphaTwo]: {
    subdivisions: [
      { name: "Amazonas", code: "VE-Z" },
      { name: "Anzoategui", code: "VE-B" },
      { name: "Apure", code: "VE-C" },
      { name: "Aragua", code: "VE-D" },
      { name: "Barinas", code: "VE-E" },
      { name: "Bolivar", code: "VE-F" },
      { name: "Carabobo", code: "VE-G" },
      { name: "Cojedes", code: "VE-H" },
      { name: "Delta Amacuro", code: "VE-Y" },
      { name: "Dependencias Federales", code: "VE-W" },
      { name: "Distrito Capital", code: "VE-A" },
      { name: "Falcon", code: "VE-I" },
      { name: "Guarico", code: "VE-J" },
      { name: "La Guaira", code: "VE-X" },
      { name: "Lara", code: "VE-K" },
      { name: "Merida", code: "VE-L" },
      { name: "Miranda", code: "VE-M" },
      { name: "Monagas", code: "VE-N" },
      { name: "Nueva Esparta", code: "VE-O" },
      { name: "Portuguesa", code: "VE-P" },
      { name: "Sucre", code: "VE-R" },
      { name: "Tachira", code: "VE-S" },
      { name: "Trujillo", code: "VE-T" },
      { name: "Yaracuy", code: "VE-U" },
      { name: "Zulia", code: "VE-V" }
    ]
  },
  [countryCodes.VIRGIN_ISLANDS_BRITISH.alphaTwo]: {
    subdivisions: [{ name: "Virgin Islands, British", code: "-" }]
  },
  [countryCodes.VIRGIN_ISLANDS_US.alphaTwo]: {
    subdivisions: [{ name: "Virgin Islands, U.S.", code: "-" }]
  },
  [countryCodes.VIETNAM.alphaTwo]: {
    subdivisions: [
      { name: "An Giang", code: "VN-44" },
      { name: "Ba Ria - Vung Tau", code: "VN-43" },
      { name: "Bac Giang", code: "VN-54" },
      { name: "Bac Kan", code: "VN-53" },
      { name: "Bac Lieu", code: "VN-55" },
      { name: "Bac Ninh", code: "VN-56" },
      { name: "Ben Tre", code: "VN-50" },
      { name: "Binh Dinh", code: "VN-31" },
      { name: "Binh Duong", code: "VN-57" },
      { name: "Binh Phuoc", code: "VN-58" },
      { name: "Binh Thuan", code: "VN-40" },
      { name: "Ca Mau", code: "VN-59" },
      { name: "Can Tho", code: "VN-CT" },
      { name: "Cao Bang", code: "VN-04" },
      { name: "Da Nang", code: "VN-DN" },
      { name: "Dak Lak", code: "VN-33" },
      { name: "Dak Nong", code: "VN-72" },
      { name: "Dien Bien", code: "VN-71" },
      { name: "Dong Nai", code: "VN-39" },
      { name: "Dong Thap", code: "VN-45" },
      { name: "Gia Lai", code: "VN-30" },
      { name: "Ha Giang", code: "VN-03" },
      { name: "Ha Nam", code: "VN-63" },
      { name: "Ha Noi", code: "VN-HN" },
      { name: "Ha Tinh", code: "VN-23" },
      { name: "Hai Duong", code: "VN-61" },
      { name: "Hai Phong", code: "VN-HP" },
      { name: "Hau Giang", code: "VN-73" },
      { name: "Ho Chi Minh", code: "VN-SG" },
      { name: "Hoa Binh", code: "VN-14" },
      { name: "Hung Yen", code: "VN-66" },
      { name: "Khanh Hoa", code: "VN-34" },
      { name: "Kien Giang", code: "VN-47" },
      { name: "Kon Tum", code: "VN-28" },
      { name: "Lai Chau", code: "VN-01" },
      { name: "Lam Dong", code: "VN-35" },
      { name: "Lang Son", code: "VN-09" },
      { name: "Lao Cai", code: "VN-02" },
      { name: "Long An", code: "VN-41" },
      { name: "Nam Dinh", code: "VN-67" },
      { name: "Nghe An", code: "VN-22" },
      { name: "Ninh Binh", code: "VN-18" },
      { name: "Ninh Thuan", code: "VN-36" },
      { name: "Phu Tho", code: "VN-68" },
      { name: "Phu Yen", code: "VN-32" },
      { name: "Quang Binh", code: "VN-24" },
      { name: "Quang Nam", code: "VN-27" },
      { name: "Quang Ngai", code: "VN-29" },
      { name: "Quang Ninh", code: "VN-13" },
      { name: "Quang Tri", code: "VN-25" },
      { name: "Soc Trang", code: "VN-52" },
      { name: "Son La", code: "VN-05" },
      { name: "Tay Ninh", code: "VN-37" },
      { name: "Thai Binh", code: "VN-20" },
      { name: "Thai Nguyen", code: "VN-69" },
      { name: "Thanh Hoa", code: "VN-21" },
      { name: "Thua Thien-Hue", code: "VN-26" },
      { name: "Tien Giang", code: "VN-46" },
      { name: "Tra Vinh", code: "VN-51" },
      { name: "Tuyen Quang", code: "VN-07" },
      { name: "Vinh Long", code: "VN-49" },
      { name: "Vinh Phuc", code: "VN-70" },
      { name: "Yen Bai", code: "VN-06" }
    ]
  },
  [countryCodes.VANUATU.alphaTwo]: {
    subdivisions: [
      { name: "Sanma", code: "VU-SAM" },
      { name: "Shefa", code: "VU-SEE" },
      { name: "Tafea", code: "VU-TAE" }
    ]
  },
  [countryCodes.WALLIS_AND_FUTUNA.alphaTwo]: { subdivisions: [{ name: "Uvea", code: "WF-UV" }] },
  [countryCodes.SAMOA.alphaTwo]: {
    subdivisions: [
      { name: "Atua", code: "WS-AT" },
      { name: "Fa'asaleleaga", code: "WS-FA" },
      { name: "Tuamasaga", code: "WS-TU" }
    ]
  },
  [countryCodes.YEMEN.alphaTwo]: {
    subdivisions: [
      { name: "Adan", code: "YE-AD" },
      { name: "Amran", code: "YE-AM" },
      { name: "Abyan", code: "YE-AB" },
      { name: "Ad Dali'", code: "YE-DA" },
      { name: "Al Bayda'", code: "YE-BA" },
      { name: "Al Hudaydah", code: "YE-HU" },
      { name: "Al Jawf", code: "YE-JA" },
      { name: "Al Mahwit", code: "YE-MW" },
      { name: "Amanat al 'Asimah", code: "YE-SA" },
      { name: "Dhamar", code: "YE-DH" },
      { name: "Hadramawt", code: "YE-HD" },
      { name: "Hajjah", code: "YE-HJ" },
      { name: "Ibb", code: "YE-IB" },
      { name: "Lahij", code: "YE-LA" },
      { name: "Ma'rib", code: "YE-MA" },
      { name: "Sa'dah", code: "YE-SD" },
      { name: "San'a'", code: "YE-SN" },
      { name: "Shabwah", code: "YE-SH" },
      { name: "Ta'izz", code: "YE-TA" }
    ]
  },
  [countryCodes.MAYOTTE.alphaTwo]: {
    subdivisions: [
      { name: "Bandrele", code: "-" },
      { name: "Kani-Keli", code: "-" },
      { name: "Koungou", code: "-" },
      { name: "Mamoudzou", code: "-" },
      { name: "Ouangani", code: "-" },
      { name: "Pamandzi", code: "-" },
      { name: "Sada", code: "-" },
      { name: "Tsingoni", code: "-" }
    ]
  },
  [countryCodes.SOUTH_AFRICA.alphaTwo]: {
    subdivisions: [
      { name: "Eastern Cape", code: "ZA-EC" },
      { name: "Free State", code: "ZA-FS" },
      { name: "Gauteng", code: "ZA-GP" },
      { name: "Kwazulu-Natal", code: "ZA-KZN" },
      { name: "Limpopo", code: "ZA-LP" },
      { name: "Mpumalanga", code: "ZA-MP" },
      { name: "North-West", code: "ZA-NW" },
      { name: "Northern Cape", code: "ZA-NC" },
      { name: "Western Cape", code: "ZA-WC" }
    ]
  },
  [countryCodes.ZAMBIA.alphaTwo]: {
    subdivisions: [
      { name: "Central", code: "ZM-02" },
      { name: "Copperbelt", code: "ZM-08" },
      { name: "Eastern", code: "ZM-03" },
      { name: "Luapula", code: "ZM-04" },
      { name: "Lusaka", code: "ZM-09" },
      { name: "Muchinga", code: "ZM-10" },
      { name: "North-Western", code: "ZM-06" },
      { name: "Northern", code: "ZM-05" },
      { name: "Southern", code: "ZM-07" },
      { name: "Western", code: "ZM-01" }
    ]
  },
  [countryCodes.ZIMBABWE.alphaTwo]: {
    subdivisions: [
      { name: "Bulawayo", code: "ZW-BU" },
      { name: "Harare", code: "ZW-HA" },
      { name: "Manicaland", code: "ZW-MA" },
      { name: "Mashonaland Central", code: "ZW-MC" },
      { name: "Mashonaland East", code: "ZW-ME" },
      { name: "Mashonaland West", code: "ZW-MW" },
      { name: "Masvingo", code: "ZW-MV" },
      { name: "Matabeleland North", code: "ZW-MN" },
      { name: "Matabeleland South", code: "ZW-MS" },
      { name: "Midlands", code: "ZW-MI" }
    ]
  }
};

// src/dates.ts
function deepFreeze3(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze3(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var months = deepFreeze3([
  { name: "January", value: "01" },
  { name: "February", value: "02" },
  { name: "March", value: "03" },
  { name: "April", value: "04" },
  { name: "May", value: "05" },
  { name: "June", value: "06" },
  { name: "July", value: "07" },
  { name: "August", value: "08" },
  { name: "September", value: "09" },
  { name: "October", value: "10" },
  { name: "November", value: "11" },
  { name: "December", value: "12" }
]);

// src/import-student-fields.ts
import { ImportFieldTypes, EStudentImportAttributeFieldNames as Field } from "platform-types";
function deepFreeze4(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze4(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var importStudentFields = deepFreeze4({
  // GENERAL FIELDS
  [Field.ADDRESS_LINE_1]: {
    summaryField: null,
    name: "addressLine1",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.ADDRESS_LINE_2]: {
    summaryField: null,
    name: "addressLine2",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.ADDRESS_LINE_3]: {
    summaryField: null,
    name: "addressLine3",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_COMPANY]: {
    summaryField: null,
    name: "agentCompany",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_COMPANY_EMAIL]: {
    summaryField: null,
    name: "agentCompanyEmail",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_EMAIL]: {
    summaryField: null,
    name: "agentEmail",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.AGENT_NAME]: {
    summaryField: "agentName",
    summaryFieldType: "string",
    name: "agentName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Agent Name"
  },
  [Field.AGENT_OFFICE]: {
    summaryField: null,
    name: "agentOffice",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.APPLICATION_DATE]: {
    summaryField: null,
    name: "applicationDate",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.APPLICATION_ID]: {
    summaryField: null,
    name: "applicationId",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.BRANCH_OFFICE]: {
    summaryField: null,
    name: "branchOffice",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Office"
  },
  [Field.CITY]: {
    summaryField: "city",
    summaryFieldType: "string",
    name: "city",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "City"
  },
  [Field.CONFIRMED]: {
    summaryField: null,
    name: "confirmed",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.COUNSELLOR_EMAIL]: {
    summaryField: null,
    name: "counsellorEmail",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Counsellor Email"
  },
  [Field.COUNSELLOR_NAME]: {
    summaryField: null,
    name: "counsellorName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Counsellor Name"
  },
  [Field.COUNTRY]: {
    summaryField: "country",
    summaryFieldType: "string",
    name: "country",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Country"
  },
  [Field.COUNTRY_OF_BIRTH]: {
    summaryField: null,
    name: "countryOfBirth",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.CRIMINAL_CONVICTIONS]: {
    summaryField: "criminalConvictions",
    summaryFieldType: "boolean",
    name: "criminalConvictions",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Criminal Convictions"
  },
  [Field.DOB]: {
    summaryField: "dob",
    summaryFieldType: "string",
    name: "dob",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Date of Birth"
  },
  [Field.EMAIL]: {
    summaryField: "email",
    summaryFieldType: "string",
    name: "email",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Email"
  },
  [Field.ENGLISH_LEVEL_ATTAINED]: {
    summaryField: null,
    name: "englishLevelAttained",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.ENGLISH_TEST_PROVIDER]: {
    summaryField: null,
    name: "englishTestProvider",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.FAMILY_NAME]: {
    summaryField: "surname",
    summaryFieldType: "string",
    name: "familyName",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Family Name"
  },
  [Field.GENDER]: {
    summaryField: null,
    name: "gender",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.GIVEN_NAME]: {
    summaryField: "givenName",
    summaryFieldType: "string",
    name: "givenName",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Given Name"
  },
  [Field.NATIONALITY]: {
    summaryField: "nationality",
    summaryFieldType: "string",
    name: "nationality",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Nationality"
  },
  [Field.OTHER_NAME]: {
    summaryField: null,
    name: "otherName",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PASSPORT_EXPIRY]: {
    summaryField: null,
    name: "passportExpiry",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PASSPORT_NUMBER]: {
    summaryField: null,
    name: "passportNumber",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PHONE]: {
    summaryField: "phone",
    summaryFieldType: "string",
    name: "phone",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Phone"
  },
  [Field.PLACE_OF_BIRTH]: {
    summaryField: null,
    name: "placeOfBirth",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.POSTCODE]: {
    summaryField: "postcode",
    summaryFieldType: "string",
    name: "postcode",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Postcode"
  },
  [Field.PREVIOUS_COURSE_COMPLETION]: {
    summaryField: null,
    name: "previousCourseCompletion",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.PREV_UK_STUDY]: {
    summaryField: null,
    name: "prevUKStudy",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_LISTENING]: {
    summaryField: null,
    name: "seltListening",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_READING]: {
    summaryField: null,
    name: "seltReading",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_SPEAKING]: {
    summaryField: null,
    name: "seltSpeaking",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.SELT_WRITING]: {
    summaryField: null,
    name: "seltWriting",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ""
  },
  [Field.STUDENT_NO]: {
    summaryField: "studentNo",
    summaryFieldType: "string",
    name: "studentNo",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Student Number"
  },
  [Field.UCAS_ID]: {
    summaryField: "ucasId",
    summaryFieldType: "string",
    name: "ucasId",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "UCAS ID"
  },
  [Field.WITH_AGENT]: {
    summaryField: "withAgent",
    summaryFieldType: "boolean",
    name: "withAgent",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "With Agent"
  },
  [Field.ADMISSIONS_OFFICE]: {
    summaryField: "admissionsOffice",
    summaryFieldType: "string",
    name: "admissionsOffice",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Uni Office"
  },
  [Field.SERVICES_ASSIGNED]: {
    summaryField: "partners",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Services"
  },
  [Field.TAGS_ASSIGNED]: {
    summaryField: "tags",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Tags"
  },
  [Field.STAGE]: {
    summaryField: "cas_status",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Stage"
  },
  [Field.AGE]: {
    summaryField: "age",
    summaryFieldType: "number",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Age"
  },
  [Field.VISA_APPLICATION_COUNTRY]: {
    summaryField: "countryOfVisaApplication",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Country of Visa Application"
  },
  [Field.RISK_REGION]: {
    summaryField: "regionConfigId",
    summaryFieldType: "string",
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Risk Region"
  },
  // OFFER FIELDS
  [Field.COURSE_FEE_PAID_TO_DATE]: {
    summaryField: "courseFeePaidToDate",
    summaryFieldType: "number",
    name: "courseFeePaidToDate",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.ACCOM_FEE_PAID_TO_DATE]: {
    summaryField: null,
    name: "accomFeePaidToDate",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.IS_SELT_REQD]: {
    summaryField: null,
    name: "isSELTReqd",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.REASON_SELT_NOT_REQD]: {
    summaryField: null,
    name: "reasonSELTNotReqd",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.PREVIOUS_COURSE_LEVEL]: {
    summaryField: null,
    name: "previousCourseLevel",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.COURSE_PROGRESSION]: {
    summaryField: null,
    name: "courseProgression",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.PROGRESSION_TEXT]: {
    summaryField: null,
    name: "progressionText",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  [Field.DOCS_USED_TO_OBTAIN_OFFER]: {
    summaryField: null,
    name: "docsUsedToObtainOffer",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ""
  },
  // COURSE FIELDS
  [Field.IS_ACCOM_PROVIDED]: {
    summaryField: null,
    name: "isAccomProvided",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.IS_ACCOM_INCLUDED_COURSE_FEE]: {
    summaryField: null,
    name: "isAccomIncludedCourseFee",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.IS_WORK_PLACEMENT]: {
    summaryField: null,
    name: "isWorkPlacement",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_PERC]: {
    summaryField: null,
    name: "workPlacementPerc",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_TEXT]: {
    summaryField: null,
    name: "workPlacementText",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_1]: {
    summaryField: null,
    name: "workPlacementAddressLine1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_2]: {
    summaryField: null,
    name: "workPlacementAddressLine2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_3]: {
    summaryField: null,
    name: "workPlacementAddressLine3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_ID]: {
    summaryField: "id",
    summaryFieldType: "string",
    name: "id",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: "Course ID"
  },
  [Field.OFFERS_PRESESSIONAL_TITLE]: {
    summaryField: "title",
    summaryFieldType: "string",
    name: "title",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: "PSE Course Title"
  },
  [Field.OFFERS_COURSES_TITLE]: {
    summaryField: "title",
    summaryFieldType: "string",
    name: "title",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: "Course Title"
  },
  [Field.OFFERS_COURSES_CONDITIONAL]: {
    summaryField: null,
    name: "conditional",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_DECLINED]: {
    summaryField: null,
    name: "isDeclined",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CAH3]: {
    summaryField: null,
    name: "cah3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_LEVEL]: {
    summaryField: "level",
    summaryFieldType: "string",
    name: "level",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: "Course Level"
  },
  [Field.OFFERS_COURSES_SECONDARY_LEVEL]: {
    summaryField: null,
    name: "secondaryLevel",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_PRESESSIONAL_START_DATE]: {
    summaryField: "startDate",
    summaryFieldType: "string",
    name: "startDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: "PSE Course Start Date"
  },
  [Field.OFFERS_COURSES_START_DATE]: {
    summaryField: "startDate",
    summaryFieldType: "string",
    name: "startDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: "Course Start Date"
  },
  [Field.OFFERS_PRESESSIONAL_END_DATE]: {
    summaryField: null,
    name: "endDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: ""
  },
  [Field.OFFERS_COURSES_END_DATE]: {
    summaryField: null,
    name: "endDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: ""
  },
  [Field.OFFERS_PRESESSIONAL_FEE]: {
    summaryField: null,
    name: "courseFeeFirstYear",
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: ""
  },
  [Field.OFFERS_COURSES_FEE]: {
    summaryField: null,
    name: "courseFeeFirstYear",
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: ""
  },
  [Field.OFFERS_COURSES_SCHOLARSHIP_AMOUNT1]: {
    summaryField: null,
    name: "courseScholarshipAmount1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_SCHOLARSHIP_TITLE1]: {
    summaryField: null,
    name: "courseScholarshipTitle1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_INNER_LONDON]: {
    summaryField: "innerLondon",
    name: "innerLondon",
    type: ImportFieldTypes.COURSE,
    summaryFieldType: "boolean",
    isPresessional: null,
    label: "Inner London"
  },
  [Field.OFFERS_COURSES_LAST_ACCEPTANCE_DATE]: {
    summaryField: null,
    name: "lastAcceptanceDate",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_IS_FULL_TIME]: {
    summaryField: null,
    name: "isFullTime",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_HOURS_PER_WEEK]: {
    summaryField: null,
    name: "hoursPerWeek",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_ATAS]: {
    summaryField: null,
    name: "isATASRequired",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT1]: {
    summaryField: null,
    name: "conditionText1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT2]: {
    summaryField: null,
    name: "conditionText2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT3]: {
    summaryField: null,
    name: "conditionText3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT4]: {
    summaryField: null,
    name: "conditionText4",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT5]: {
    summaryField: null,
    name: "conditionText5",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT6]: {
    summaryField: null,
    name: "conditionText6",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT7]: {
    summaryField: null,
    name: "conditionText7",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT8]: {
    summaryField: null,
    name: "conditionText8",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT9]: {
    summaryField: null,
    name: "conditionText9",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_FACULTY]: {
    summaryField: "faculty",
    summaryFieldType: "string",
    name: "faculty",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: "Faculty"
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_1]: {
    summaryField: null,
    name: "studyAddressLine1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_2]: {
    summaryField: null,
    name: "studyAddressLine2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_3]: {
    summaryField: null,
    name: "studyAddressLine3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_CITY]: {
    summaryField: null,
    name: "studyCity",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_COUNTRY]: {
    summaryField: null,
    name: "studyCountry",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.MAIN_STUDY_ADDRESS_POSTCODE]: {
    summaryField: null,
    name: "studyPostcode",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_CITY]: {
    summaryField: null,
    name: "workPlacementCity",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_COUNTRY]: {
    summaryField: null,
    name: "workPlacementCountry",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.WORK_PLACEMENT_ADDRESS_POSTCODE]: {
    summaryField: null,
    name: "workPlacementPostcode",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_OFFER_EVIDENCE]: {
    summaryField: null,
    name: "offerEvidence",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_ACCEPTED]: {
    summaryField: null,
    name: "coursesAccepted",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS1]: {
    summaryField: null,
    name: "offers_courses_qual_hecos1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS2]: {
    summaryField: null,
    name: "offers_courses_qual_hecos2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS3]: {
    summaryField: null,
    name: "offers_courses_qual_hecos3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS4]: {
    summaryField: null,
    name: "offers_courses_qual_hecos4",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_HECOS5]: {
    summaryField: null,
    name: "offers_courses_qual_hecos5",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION1]: {
    summaryField: null,
    name: "offers_courses_qual_proportion1",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION2]: {
    summaryField: null,
    name: "offers_courses_qual_proportion2",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION3]: {
    summaryField: null,
    name: "offers_courses_qual_proportion3",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION4]: {
    summaryField: null,
    name: "offers_courses_qual_proportion4",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION5]: {
    summaryField: null,
    name: "offers_courses_qual_proportion5",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFERS_COURSES_QUAL_CAT]: {
    summaryField: null,
    name: "offers_courses_qual_cat",
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ""
  },
  [Field.OFFER_ID]: {
    summaryField: "offerId",
    summaryFieldType: "string",
    name: "offerId",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Offer ID"
  },
  [Field.INTAKE_ID]: {
    summaryField: "intakeId",
    summaryFieldType: "string",
    name: "intakeId",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Intake ID"
  },
  [Field.UNI_PARTNER_ID]: {
    summaryField: "uniPartnerId",
    summaryFieldType: "string",
    name: "uniPartnerId",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Secondary Student Number"
  },
  [Field.UNI]: {
    summaryField: "uni",
    summaryFieldType: "string",
    name: "uni",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "University"
  },
  [Field.PATHWAY]: {
    summaryField: "pathway",
    summaryFieldType: "string",
    name: "pathway",
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: "Pathway Provider"
  },
  [Field.EXTERNAL_CAS_STATUS]: {
    summaryField: "externalCasStatus",
    summaryFieldType: "string",
    name: "externalCasStatus",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "CAS Bypass"
  },
  [Field.OFFERS_DURATION_MONTHS]: {
    summaryField: "offersDurationMonths",
    summaryFieldType: "number",
    name: "offersDurationMonths",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Offers Duration Months"
  },
  [Field.TUITION_DEPOSIT]: {
    summaryField: "tuitionDeposit",
    summaryFieldType: "number",
    name: "depositAmount",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Tuition Deposit"
  },
  [Field.DEPOSIT_AMOUNT]: {
    summaryField: "depositAmount",
    summaryFieldType: "number",
    name: "depositAmount",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Tuition Deposit"
  },
  [Field.AGENT_FAMILY_NAME]: {
    summaryField: null,
    name: "agentFamilyName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Key Contact Family Name"
  },
  [Field.AGENT_GIVEN_NAME]: {
    summaryField: null,
    name: "agentGivenName",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Key Contact Given Name"
  },
  [Field.BRANCH_ADDRESS_LINE_1]: {
    summaryField: null,
    name: "branchAddressLine1",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Address Line 1"
  },
  [Field.BRANCH_ADDRESS_LINE_2]: {
    summaryField: null,
    name: "branchAddressLine2",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Address Line 2"
  },
  [Field.BRANCH_ADDRESS_LINE_3]: {
    summaryField: null,
    name: "branchAddressLine3",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Address Line 3"
  },
  [Field.BRANCH_CITY]: {
    summaryField: null,
    name: "branchCity",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch City"
  },
  [Field.BRANCH_COUNTRY]: {
    summaryField: null,
    name: "branchCountry",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Country"
  },
  [Field.BRANCH_POSTCODE]: {
    summaryField: null,
    name: "branchPostcode",
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: "Branch Postcode"
  }
});
export {
  countries,
  countryByAlpha3,
  countryByCountryName,
  countryByNationality,
  countryByNumeric,
  countryByRegionName,
  countryCodes,
  countryNames,
  countryPhoneCodes,
  importStudentFields,
  months,
  nationalityCountriesMap,
  recognisedCountries,
  subdivisions
};
